import React, { Component } from "react";
import { v4 as uuidv4 } from "uuid";
import Masonry from "react-masonry-css";

import { Link, useNavigate, useParams } from "react-router-dom";
import {
  TITIK_BACA_CONTENT_CATEGORIES,
  TITIK_BACA,
  TITIK_BACA_TERLARIS,
  TITIK_BACA_TOP,
  TITIK_BACA_BERITA,
  TITIK_BACA_GET_RSS,
  TITIK_BACA_YOUTUBE,
  GET_RADIO,
  TITIK_BACA_KATEGORI,
  BASE_URL,
  CONTENT_JENJANG,
  TITIK_BACA_GET_THEMES,
} from "../api";
import {
  shuffle,
  executeGet,
  executePost,
  createNewHeaders,
  formatTanggal,
} from "../functions/Kubuku";
import Glider from "react-glider";
import SkeletonHome from "../components/SkeletonHome";
import logo_titikbaca from "../assets/images/logo-titikbaca.png";
import QRCode from "react-qr-code";
import logoBpEdu from "../assets/images/logo-bintangpusnas-master.png";
import image_location from "../assets/images/location.png";
import logoLiterasiKeluarga from "../assets/images/logo_literasikeluarga.png";
import iconIlmuTerapan from "../assets/category-icon/ic-terapan.svg";
import iconKesehatan from "../assets/category-icon/ic-kesehatan.svg";
import iconUmum from "../assets/category-icon/ic-koleksi-umum.svg";
import iconAudiobook from "../assets/category-icon/ic-audiobooks.svg";
import iconKemenag from "../assets/category-icon/ic-kemenag.svg";
import iconLokal from "../assets/category-icon/ic-pl.svg";
import iconVideobook from "../assets/category-icon/ic-videobooks.svg";
import iconKemendikbud from "../assets/category-icon/ic-kemendikbud.svg";
import iconLiterasiDaerah from "../assets/category-icon/ic-literasi-daerahs.svg";
import iconBukuDigital from "../assets/category-icon/buku-digital.svg";
import iconBukuAjar from "../assets/category-icon/ic-buku-ajar-sekolah.svg";
import iconBukuPengayaan from "../assets/category-icon/ic-buku-pengayaan.svg";
import iconP3SMPT from "../assets/category-icon/ic-p3smpt.svg";
import iconInfoKemendikbud from "../assets/category-icon/ic-info-kemendikbud.svg";
import iconInfoSekolah from "../assets/category-icon/ic-info-sekolah.svg";
import iconPermainanEdukasi from "../assets/category-icon/ic-permainan-deukasi.svg";
import iconSirkulasi from "../assets/category-icon/ic-sirkulasi.svg";
import tutorialEdukasi from "../assets/category-icon/ic-tutorial-edukasi.svg";
import mascot from "../assets/images/mascot.gif";
import kreator from "../assets/images/kreator.png";
import Draggable from "react-draggable";
import ContentJauh from "../components/ContenJauh";
import ContentNoGPS from "../components/ContentNoGPS";
import {
  SkeletonBanyakDibaca,
  SkeletonBerita,
  SkeletonBukuTerlaris,
  SkeletonHalamanBerita,
  SkeletonHomePage,
  SkeletonLocation,
  SkeletonTitikBaca,
  SkeletonVideo,
} from "../components/Skeleton";
import { disableSplashScreen } from "../api/enkripsi";
var warna = [
  "bg-purple",
  "bg-gold",
  "bg-blue",
  "bg-tosca",
  "bg-red",
  "bg-green",
];

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isModal: false, // popup loading
      showMain: false,
      param: this.props.params,
      dataterdekat: "",
      dataterdekat_array: [],
      data: "",
      news: [],
      mode: 1,
      hal: 1,
      dataRekomendasi: "",
      dataTerlaris: "",
      dataTop: [],
      dataBerita: "",
      datakategori: {}, // koreksi: awalnya string kosong, sekarang menjadi objek
      youtube: [],
      dataRadio: [],
      flagRadio: false,
      flagData: false,
      flagBerita: false,
      flagDataRSS: false,
      flagNoBook: false,
      dataRSS: [],
      halRSS: 2,
      dataRssKominfo: [],
      flagRSSKominfo: false,
      flagRekomendasi: false,
      flagYoutube: false,
      flagDataTop: false,
      showModal: false, // popup preview
      alias: "kfh-12f9-kas",
      lokasi: "",
      lat: "-7.557130246009252",
      long: "110.79448368501073",
      alt: "1",
      jauh: false,
      msgJauh: "",
      lokasiMsgJauh: "",
      halaman: 1,
      noGPS: false,
      flagMoreSearch: false,
      urlTitikBaca: "",
      hasMore: true,
      msgTitleGPS: "Aktifkan Servis Lokasi",
      msgGPS:
        "Tidak dapat mendeteksi lokasi anda, pastikan GPS anda aktif, dan mengijinkan browser anda membaca lokasi anda",
      color: "bg-orange",
      darkcolor: "bg-orang-dark",
      textcolor: "text-orange",
      imgHead: "",
      imgSplash: "",
      flagAudio: false,
      dataAudio: [],
      flagVideo: false,
      dataVideo: [],
      flagKesehatan: false,
      dataKesehatan: [],
      hybrid_umum: true,
      hybrid_smp: false,
      hybrid_sma: false,
      halaman_jenjang: 1,
      limit_jenjang: 10,
      dataJenjang: [],
      sn: "",
      guid: "",
      loadingBukuPopuler: true,
      loadingLiterasiKeluraga: true,
      loadingRekomendasi: true,
      loadingBukuKesehatan: true,
      loadingAudioBook: true,
      loadingVideoBook: true,
      loadingBukuTerlaris: true,
      loadingBukuTop: true,
      loadigngBerita: true,
      loadingNextRss: true,
      loadingGetRss: true,
      loadingGetRssKominfo: true,
      loadingYoutube: true,
      loadingKatergori: true,
      loadingGetRadio: true,
      loadingGetTitikbacaTerdekat: true,
      loadingLokasi: true,
    };
    this.intervalId = null;
    this.locationInterval = null;
  }

  updateUrl = () => {
    const newTimestamp = Date.now();
    this.setState({
      urlTitikBaca: `http://103.216.188.14:8080/home/${this.props.params.alias}?${newTimestamp}`,
    });
  };

  componentDidMount = async () => {
    const storedAlias = window.localStorage.getItem("alias");
    const paramAlias = String(this.props.params.alias);

    // Jika alias berbeda, hapus semua localStorage
    if (storedAlias && storedAlias !== paramAlias) {
      console.log("Alias berbeda, menghapus semua localStorage");
      window.localStorage.clear();
    }

    // UUID
    if (!window.localStorage.getItem("uuid")) {
      let uuid = uuidv4();
      window.localStorage.setItem("uuid", uuid);
    }

    let pushal = "kfh-12f9-kas";
    window.localStorage.setItem("color", "bg-orange");

    if (paramAlias === "home" || paramAlias === "undefined") {
      if (
        !window.localStorage.getItem("alias") ||
        window.localStorage.getItem("alias") === "undefined" ||
        window.localStorage.getItem("alias") === "tidakadatitik"
      ) {
        this.setState({
          alias: "kfh-12f9-kas",
          lokasi: "Selamat Datang",
          urlTitikBaca: window.location.origin + "/kfh-12f9-kas",
        });
        window.localStorage.setItem("nama", "Selamat Datang");
      } else {
        this.setState({ alias: window.localStorage.getItem("alias") });
        pushal = window.localStorage.getItem("alias");
        pushal = paramAlias;
      }
    } else {
      this.setState({ alias: paramAlias });
      pushal = paramAlias;
      window.localStorage.setItem("alias", paramAlias);
    }

    if (
      this.props.sn &&
      this.props.sn !== "undefined" &&
      this.props.guid &&
      this.props.guid !== "undefined"
    ) {
      window.localStorage.setItem("sn", this.props.sn);
      window.localStorage.setItem("guid", this.props.guid);
      this.setState({ sn: this.props.sn, guid: this.props.guid });
    }

    window.localStorage.setItem("alias", pushal);
    this.getLocation();

    warna = shuffle(warna);
    disableSplashScreen();
    this.updateUrl();

    this.updateInterval = setInterval(this.updateUrl, 5000);
    this.locationInterval = setInterval(() => {
      this.getLocation();
    }, 600000);
  };

  componentWillUnmount() {
    // Hapus interval biar nggak jalan terus
    clearInterval(this.updateInterval);
    clearInterval(this.locationInterval);
  }

  getTheme = async () => {
    try {
      const json = await executeGet(TITIK_BACA_GET_THEMES + this.state.alias);
      if (window.localStorage.getItem("themes") != null) {
        const ljson = window.localStorage.getItem("themes");
        const json = JSON.parse(ljson);
        if (json.code == 200) {
          if (json.warna != "") {
            this.setState({
              color: json.warna,
            });
          }
          if (json.dark != "") {
            this.setState({
              darkcolor: json.dark,
            });
          }
          if (json.text != "") {
            this.setState({
              textcolor: json.text,
            });
          }
          if (json.head != "") {
            this.setState({
              imgHead: json.head,
            });
          }
          if (json.splash != "") {
            this.setState({
              imgSplash: json.splash,
            });
          }
        }
      } else {
        localStorage.setItem("themes", JSON.stringify(json));
        if (json.code == 200) {
          if (json.warna != "") {
            this.setState({
              color: json.warna,
            });
          }
          if (json.dark != "") {
            this.setState({
              darkcolor: json.dark,
            });
          }
          if (json.text != "") {
            this.setState({
              textcolor: json.text,
            });
          }
          if (json.head != "") {
            this.setState({
              imgHead: json.head,
            });
          }
          if (json.splash != "") {
            this.setState({
              imgSplash: json.splash,
            });
          }
        }
      }
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };

  getLocation = async () => {
    // 1️⃣ Kalau ada SN, ambil data dari API

    if (localStorage.getItem("sn")) {
      const url = `https://kubuku.id/api/titikBaca/getTitikBacaGPS/${localStorage.getItem(
        "sn",
      )}/${localStorage.getItem("guid")}/${localStorage.getItem("alias")}`;
      const json = await executeGet(url);
      if (json.code === 200) {
        this.handleLocation(json.lat, json.long, json.alt);
      } else {
        localStorage.removeItem("sn");
        localStorage.removeItem("guid");
        this.geolocFail();
      }
      return;
    }

    // 2️⃣ Kalau sudah ada lat di localStorage & belum kadaluarsa (misal 10 menit)
    const cachedLat = localStorage.getItem("lat");
    const cachedLong = localStorage.getItem("long");
    const cachedAlt = localStorage.getItem("alt");
    const lastLocationTime = localStorage.getItem("lastLocationTime");

    const cacheValid =
      cachedLat &&
      lastLocationTime &&
      Date.now() - lastLocationTime < 1 * 60 * 1000;

    if (cacheValid) {
      this.handleLocation(cachedLat, cachedLong, cachedAlt, false);
      this.setState({
        lat: cachedLat,
        long: cachedLong,
        alt: cachedAlt,
      });
      return;
    }

    // 3️⃣ Kalau belum ada, pakai navigator.geolocation
    if (navigator.geolocation) {
      const location_timeout = setTimeout(this.geolocFail, 30000);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          clearTimeout(location_timeout);
          const lat = position.coords.latitude;
          const long = position.coords.longitude;
          const alt = position.coords.altitude;
          this.handleLocation(lat, long, alt, true);
          this.setState({
            lat: lat,
            long: long,
            alt: alt,
          });
        },
        (error) => {
          console.warn("Gagal ambil lokasi cache:", error);
          // 🔥 fallback: kalau ada lokasi lama, tetap pakai
          if (cachedLat) {
            console.warn("Pakai lokasi cache lama");
            this.handleLocation(cachedLat, cachedLong, cachedAlt, true);
          } else {
            this.geolocFail();
          }
        },
      );
    }
  };

  handleLocation = (lat, long, alt, isFresh) => {
    this.setState({ lat, long, alt });
    localStorage.setItem("lat", lat);
    localStorage.setItem("long", long);
    localStorage.setItem("alt", alt);

    if (isFresh) {
      localStorage.setItem("lastLocationTime", Date.now());
    }
    this.getTheme();
    this.getBukuPopuler(lat, long, alt);
  };

  geolocFail = () => {
    this.setState({
      noGPS: true,
      isLoading: false,
    });
  };

  aktifkanGeo = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        //alert("pos");
      },
      (error) => {
        //alert(error.message);
      },
    );
  };
  getBukuPopuler = async (lat, long, alt) => {
    try {
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      formData.append("isMobile", "1");
      formData.append("hal", "1");
      //const json = await executePost(BASE_URL + 'getTitikBacaPerpusnas/' + this.state.alias, formData)
      const json = await executePost(
        TITIK_BACA + window.localStorage.getItem("alias"),
        formData,
      );
      //const json = JSON.parse(jsonData);
      if (json.code == 404) {
        window.location.href = "https://titikbaca.id";
      } else if (json.code === 200) {
        this.setState({
          lokasi: json.nama_lokasi,
          data: json.data,
          //datakategori: json.list_sub_kategori,
          alias: json.token,
          flagData: true,
        });
        if (json.hybrid_type == "smp") {
          this.setState({
            color: "bg-smp",
            textColor: "text-smp",
            hybrid_umum: false,
            hybrid_smp: true,
          });
          this.getJenjangSekolahRakyat(json.hybrid_type);
          localStorage.setItem("P3SMPT", json.hybrid_type);
          window.localStorage.setItem("color", "bg-smp");
        } else if (json.hybrid_type == "sma") {
          this.setState({
            color: "bg-sma",
            textcolor: "text-sma",
            hybrid_sma: true,
            hybrid_umum: false,
            hybrid_smp: "false",
          });
          this.getJenjangSekolahRakyat(json.hybrid_type);
          localStorage.setItem("P3SMPT", json.hybrid_type);
          localStorage.setItem("color", "bg-sma");
        }
        window.localStorage.setItem("nama", json.nama_lokasi);
        window.localStorage.setItem("alias", json.token);

        this.getBerita();

        this.getKategori(lat, long, alt);
        this.getTitikBacaTerdekat(lat, long, alt);

        this.getRSS(1, 1);

        this.nextRss();

        this.getRadio();

        this.getRSSKominfo();

        this.getAudio();
        this.getVideo();

        this.getBukuRekomendasi(lat, long, alt);
        this.getBukuKesehatan(lat, long, alt);
        this.getYoutube(lat, long, alt);
        [
          "CAT001",
          "CAT002",
          "CAT003",
          "CAT007",
          "CAT008",
          "CAT009",
          "CAT020",
          "CAT021",
        ].forEach((code) => this.getLiterasiKeluarga(lat, long, alt, code));
      } else {
        var parsingMsg = json.msg.substr(0, json.msg.indexOf("<p>"));
        var parsingMsg2 = parsingMsg.replace(/,\s*$/, "");
        // var parsingMsg2 = parsingMsg.substr(0, parsingMsg.indexOf(','));
        this.setState({
          jauh: true,
          isLoading: false,
          msgJauh: parsingMsg2,
          lokasiMsgJauh: json.google_maps,
          lokasi: json.nama_lokasi,
        });

        // console.log(json.msg)

        window.localStorage.setItem("nama", json.nama_lokasi);
        window.localStorage.setItem("alias", this.state.alias);
        if (json.nama_lokasi == null) {
          this.setState({ lokasi: "Selamat Datang" });
          window.localStorage.setItem("nama", "Selamat Datang");
        }
        /*
        this.getRSS(1, 2)
        this.getTitikBacaTerdekat(lat, long, alt)
        this.getYoutube(lat, long, alt)
        this.getRSSKominfo();
        this.nextRss();
        this.getRadio(); 
        */
      }
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    } finally {
      this.setState({
        loadingBukuPopuler: false,
        loadingLokasi: false,
      });
    }
  };

  getJenjangSekolahRakyat = async (jenjang) => {
    const queryParams = {
      hal: this.state.halaman_jenjang.toString(),
      limit: this.state.limit_jenjang.toString(),
    };
    const json = await executeGet(
      `${CONTENT_JENJANG}/${this.state.alias}/${jenjang}?${new URLSearchParams(
        queryParams,
      )}`,
    );

    if (json.code == 200) {
      this.setState({
        dataJenjang: json.data,
      });
    }
  };

  getLiterasiKeluarga = async (lat, long, alt, code) => {
    try {
      const formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      formData.append("isMobile", "1");
      formData.append("hal", "1");

      const json = await executePost(
        TITIK_BACA_CONTENT_CATEGORIES + code + "/" + this.state.alias,
        formData,
      );

      if (json.code === 200) {
        this.setState((prevState) => ({
          datakategori: {
            ...prevState.datakategori,
            [code]: json.data.length > 0 ? 1 : 0,
          },
          flagNoBook: true,
        }));
      }
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };

  getBukuRekomendasi = async (lat, long, alt) => {
    try {
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      formData.append("isMobile", "1");
      formData.append("hal", "1");
      formData.append("cat", "ALL");
      const json = await executePost(
        BASE_URL + "randomBuku/" + this.state.alias,
        formData,
      );
      this.setState({
        dataRekomendasi: json.data,
        flagRekomendasi: true,
      });
    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    } finally {
      this.setState({
        loadingRekomendasi: false,
      });
    }
  };

  getBukuKesehatan = async (lat, long, alt) => {
    try {
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      formData.append("isMobile", "1");
      formData.append("hal", "1");
      formData.append("cat", "CAT002");
      const json = await executePost(
        BASE_URL + "randomBuku/" + this.state.alias,
        formData,
      );
      if (json.data.length > 0) {
        this.setState({
          dataKesehatan: json.data,
          flagKesehatan: true,
        });
      } else {
        this.setState({
          dataKesehatan: json.data,
          flagKesehatan: false,
        });
      }
    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    } finally {
      this.setState({
        loadingBukuKesehatan: false,
      });
    }
  };

  getAudio = async (lat, long, alt) => {
    try {
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      formData.append("isMobile", "1");
      formData.append("hal", "1");
      //const json = await executePost(TITIK_BACA_REKOMENDASI + this.state.alias, formData)
      const json = await executePost(
        TITIK_BACA_CONTENT_CATEGORIES + "CAT008/" + this.state.alias,
        formData,
      );
      this.setState({
        dataAudio: json.data,
        flagAudio: true,
      });
    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    } finally {
      this.setState({
        loadingAudioBook: false,
      });
    }
  };

  getVideo = async (lat, long, alt) => {
    try {
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      formData.append("isMobile", "1");
      formData.append("hal", "1");
      //const json = await executePost(TITIK_BACA_REKOMENDASI + this.state.alias, formData)
      const json = await executePost(
        TITIK_BACA_CONTENT_CATEGORIES + "CAT009/" + this.state.alias,
        formData,
      );
      this.setState({
        dataVideo: json.data,
        flagVideo: true,
      });
    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    } finally {
      this.setState({
        loadingVideoBook: false,
      });
    }
  };

  getBukuTerlaris = async (lat, long, alt) => {
    try {
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      formData.append("isMobile", "1");
      formData.append("hal", "1");
      const json = await executePost(
        TITIK_BACA_TERLARIS + this.state.alias,
        formData,
      );
      this.setState({
        dataTerlaris: json.data,
      });
    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    } finally {
      this.setState({
        loadingBukuTerlaris: false,
      });
      this.getBukuTop();
    }
  };

  getBukuTop = async () => {
    try {
      let ldata = this.state.dataTop;
      let formData = new FormData();
      formData.append("latitude", this.state.lat);
      formData.append("longitude", this.state.long);
      formData.append("altitude", this.state.alt);
      formData.append("isMobile", "1");
      formData.append("hal", this.state.halaman);

      const json = await executePost(
        TITIK_BACA_TOP + this.state.alias,
        formData,
      );

      if (json.code === 200 && json.data && json.data.length > 0) {
        let nextHal = parseInt(this.state.halaman) + 1;
        this.setState({
          dataTop: ldata.concat(json.data),
          isLoading: false,
          flagDataTop: true,
          halaman: nextHal,
        });
      } else {
        // Jika respons JSON tidak berisi data, tidak ubah halaman.
        this.setState({
          isLoading: false,
          flagDataTop: true,
        });
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      this.setState({
        isLoading: false,
        isError: true,
        errorMessage: "Network Error!",
      });
    } finally {
      this.setState({
        loadingBukuTop: false,
      });
    }
  };

  getBerita = async () => {
    try {
      let formData = new FormData();
      formData.append("latitude", this.state.lat);
      formData.append("longitude", this.state.long);
      formData.append("altitude", this.state.alt);
      formData.append("isMobile", "1");
      const json = await executePost(
        TITIK_BACA_BERITA + this.state.alias,
        formData,
      );
      this.setState({
        dataBerita: json.data,
        flagBerita: true,
      });
    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    } finally {
      this.setState({
        loadigngBerita: false,
      });
    }
  };

  nextRss = async () => {
    let nextHal = parseInt(this.state.halRSS);
    try {
      let oNews = this.state.dataRSS;
      let formData = new FormData();
      formData.append("latitude", "1");
      formData.append("longitude", "1");
      formData.append("altitude", "1");
      formData.append("alias", this.state.alias);
      formData.append("isMobile", "1");
      formData.append("hal", nextHal);
      const json = await executePost(TITIK_BACA_GET_RSS + "/1", formData);

      this.setState({
        dataRSS: oNews.concat(json),
        flagDataRSS: true,
        halRSS: nextHal + 1,
        //isLoading: false
      });
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    } finally {
      this.setState({
        loadingNextRss: false,
      });
    }
  };

  getRSS = async (mode, hal) => {
    try {
      let oNews = this.state.news;
      let formData = new FormData();
      formData.append("latitude", "1");
      formData.append("longitude", "1");
      formData.append("altitude", "1");
      formData.append("alias", this.state.alias);
      formData.append("isMobile", "1");
      formData.append("hal", hal);
      //const json = await executePost(TITIK_BACA_GET_RSS + '/' + mode, formData)
      //let json = await executeGet("https://kubuku.id/api/titikBaca/downloadRSSKumparan")
      let json = await executeGet(
        "https://kubuku.id/api/titikBaca/downloadRSSRandom/0/0/" +
          window.localStorage.getItem("alias") +
          "/1",
      );
      this.setState({
        news: oNews.concat(json),
        flagBerita: true,
        mode: mode,
        hal: 1,
        //isLoading: false
      });
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    } finally {
      this.setState({
        loadingGetRss: false,
      });
    }
  };

  getRSSKominfo = async () => {
    try {
      //const json = await executeGet(TITIK_BACA_GET_RSS + '/jakarta/1')

      let json = await executeGet(
        "https://kubuku.id/api/titikBaca/downloadRSSKumparan",
      );
      this.setState({
        dataRssKominfo: json,
        flagRSSKominfo: true,
        hal: 1,
        //isLoading: false
      });
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    } finally {
      this.setState({
        loadingGetRssKominfo: false,
      });
    }
  };

  getYoutube = async (lat, long, alt) => {
    try {
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      formData.append("isMobile", "1");
      formData.append("hal", 1);
      const json = await executePost(
        TITIK_BACA_YOUTUBE + this.state.alias,
        formData,
      );
      this.setState({
        youtube: json.data,
        flagYoutube: true,
        hal: 1,
        isLoading: false,
      });
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    } finally {
      this.setState({
        loadingYoutube: false,
      });
    }
  };

  getKategori = async (lat, long, alt) => {
    try {
      let alias = this.state.alias;
      let alt = 1;
      //const json = await executeGet(TITIK_BACA_YOUTUBE + '/' + alias + '/' + lat + '/' + long + '/' + alt + '/1')
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      formData.append("isMobile", "1");
      formData.append("hal", 1);
      const json = await executePost(
        TITIK_BACA_KATEGORI + this.state.alias,
        formData,
      );
      this.setState({
        datakategori: json.data,
        isLoading: false,
      });
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    } finally {
      this.setState({
        loadingKatergori: false,
      });
    }
  };

  getRadio = async () => {
    try {
      this.setState({
        isLoading: true,
      });
      const json = await executeGet(GET_RADIO);
      if (json.code == 404) {
        this.setState({
          isLoading: false,
        });
        //window.location.href = 'https://titikbaca.id'
      } else {
        let newArray = [...json];
        let length = newArray.length;

        for (let start = 0; start < length; start++) {
          const randomPosition = Math.floor(
            (newArray.length - start) * Math.random(),
          );
          const randomItem = newArray.splice(randomPosition, 1);
          newArray.push(...randomItem);
        }
        this.setState({
          dataRadio: newArray,
          isLoading: false,
          flagRadio: true,
        });
      }
    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    } finally {
      this.setState({
        loadingGetRadio: false,
      });
    }
  };

  getTitikBacaTerdekat = async (lat, long, alt) => {
    try {
      createNewHeaders();
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      const json = await executePost(BASE_URL + "titikPerpusnas/", formData);
      // console.log("getTitikBacaTerdekat",formData,  TITIK_BACA, json);
      this.setState({
        dataterdekat: json,
        showMain: true,
      });

      let arrayTemp = [];
      json.forEach((item) => {
        //console.log("foreach = " + item.alias);
        //console.log("STATAIEAL " + this.state.alias);
        if (item.alias != this.state.alias) {
          //console.log("foreach res= " + JSON.stringify(item));
          arrayTemp.push(item);
          //console.log("arrayTemp = " + JSON.stringify(arrayTemp))
          this.setState({
            isLoading: false,
            showMain: true,
            dataterdekat_array: arrayTemp,
            loadingGetTitikbacaTerdekat: false,
          });
        }
      });
      // console.log("Respone_TITIK = " + JSON.stringify(this.state.dataterdekat_array));
    } catch (error) {
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    } finally {
      this.getBukuTerlaris(lat, long, alt);
    }
  };

  gotoRSSDetail = async (tipe, id) => {
    this.props.navigate("/rss/" + id);
  };
  gotoRadioDetail = async (radio) => {
    this.props.navigate("/detailRadio/" + radio.id);
  };

  gotoDetail = async (id) => {
    let aid = id.split("-");
    id = aid[aid.length - 1];
    this.props.navigate(
      "/detail/konten/" + id + "/" + this.state.alias + "/REG",
    );
  };

  gotoNewsDetail = async (id) => {
    this.props.navigate("/detailBerita/" + id + "/" + this.state.alias);
  };

  bacaBerita = async (id, tanggal) => {
    this.props.navigate(
      "/bacaBerita/" + this.state.alias + "/" + btoa(id) + "/" + btoa(tanggal),
    );
  };

  listRSS = async (id) => {
    this.props.navigate("/listrss/" + id);
  };

  gotoSearch = async (tipe) => {
    this.props.navigate("/listBuku/" + tipe + "/" + this.state.alias);
  };

  gotoKategori = async (cat) => {
    this.props.navigate("/kategori/" + cat + "/" + this.state.alias);
  };

  gotoKementerian = async () => {
    this.props.navigate("/kementerian/" + this.state.alias);
  };

  gotoYoutube = async (id) => {
    this.props.navigate("/ytb/" + id);
  };

  gotoGames = async () => {
    //window.location.href = "https://perpusnas.titikbaca.id/fruit/index.html";
    this.props.navigate("/listgames");
  };

  gotoMusik = async () => {
    //window.location.href = "https://perpusnas.titikbaca.id/fruit/index.html";
    this.props.navigate("/listmusik");
  };

  gotoContenCreator = async () => {
    //window.location.href = "https://perpusnas.titikbaca.id/fruit/index.html";
    this.props.navigate("/contentcreator");
  };

  render() {
    let ukuran = [
      { columns: 2, gutter: 10 },
      ,
      { mq: "768px", columns: 6, gutter: 10 },
    ];

    return (
      // this.state.isLoading ? <Loader />:
      <div className="overflow-y-scroll no-scrollbar">
        <>
          {this.state.noGPS && (
            <>
              <ContentNoGPS></ContentNoGPS>
            </>
          )}
          {this.state.jauh && (
            <>
              {/* Section Hero */}
              <ContentJauh></ContentJauh>
            </>
          )}
          {!this.state.noGPS && !this.state.jauh && (
            <>
              <div className="overflow-y-scroll no-scrollbar">
                {/* Search */}
                <div className="search-bar fixed top-[-74px] w-full px-4 py-3 z-50 bg-white shadow-md ease-in duration-300">
                  <div className="relative">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="absolute top-3 left-[16px] mr-2"
                    >
                      <path
                        d="M9.33512 4.80232C9.74423 4.73752 10.0234 4.35334 9.95856 3.94423C9.89376 3.53511 9.50958 3.25599 9.10047 3.32079C6.64008 3.71047 4.71044 5.64012 4.32076 8.1005C4.25596 8.50961 4.53508 8.89379 4.9442 8.95859C5.35331 9.02339 5.73749 8.74426 5.80229 8.33515C6.09032 6.51661 7.51658 5.09035 9.33512 4.80232Z"
                        fill="#d3d3d3"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11 0.25C5.61522 0.25 1.25 4.61522 1.25 10C1.25 15.3848 5.61522 19.75 11 19.75C16.3848 19.75 20.75 15.3848 20.75 10C20.75 4.61522 16.3848 0.25 11 0.25ZM2.75 10C2.75 5.44365 6.44365 1.75 11 1.75C15.5563 1.75 19.25 5.44365 19.25 10C19.25 14.5563 15.5563 18.25 11 18.25C6.44365 18.25 2.75 14.5563 2.75 10Z"
                        fill="#d3d3d3"
                      />
                      <path
                        d="M19.5304 17.4698C19.2375 17.1769 18.7626 17.1769 18.4697 17.4698C18.1768 17.7626 18.1768 18.2375 18.4697 18.5304L22.4696 22.5304C22.7625 22.8233 23.2374 22.8233 23.5303 22.5304C23.8232 22.2375 23.8232 21.7626 23.5303 21.4697L19.5304 17.4698Z"
                        fill="#d3d3d3"
                      />
                    </svg>
                    <input
                      type="text"
                      className="flex items-center w-full pr-4 pl-11 py-2.5 bg-white border border-gray-200 rounded-2xl placeholder:text-gray-400 text-sm focus:outline-none focus:border-orange focus:ring-orange"
                      placeholder="Cari judul buku, penulis, penerbit..."
                    />
                  </div>
                </div>
                {/* End Search */}

                {/* Section Hero */}
                <div
                  className={
                    "fixed w-full top-0 left-0 p-4 pb-10 " +
                    this.state.color +
                    " text-white"
                  }
                >
                  <img
                    src={logo_titikbaca}
                    alt="logo titikbaca"
                    className="mb-3"
                    style={{ height: "41px" }}
                  />
                  <div className="flex">
                    {this.state.loadingLokasi ? (
                      <SkeletonLocation />
                    ) : (
                      <>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="mr-2"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14.7808 19.7005C17.0905 16.7551 20 12.4759 20 9.6087C20 4.85424 16.4183 1 12 1C7.58172 1 4 4.85424 4 9.6087C4 12.4759 6.90945 16.7551 9.21921 19.7005C10.4242 21.2371 11.0268 22.0055 12 22.0055C12.9732 22.0055 13.5758 21.2371 14.7808 19.7005ZM12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 11.6569 13.6569 13 12 13Z"
                            fill="#FAFAFA"
                          />
                        </svg>
                        <h3 className="text-base font-medium line-clamp-1">
                          {this.state.lokasi}
                        </h3>
                      </>
                    )}
                  </div>
                  <div>
                    <div>
                      <div className="grid grid-cols-2 gap-2">
                        {localStorage.getItem("sn") == null ? (
                          <div
                            className={
                              "mt-4 p-4 " +
                              this.state.darkcolor +
                              " bg-opacity-20 rounded-2xl"
                            }
                          >
                            <p className="text-sm">
                              Cari buku yang ingin kamu baca
                            </p>
                            <button
                              onClick={() => this.gotoSearch(0)}
                              className={
                                "flex w-full mt-2 p-1 items-center text-xs border border-white rounded-full hover:bg-white hover:" +
                                this.state.textcolor +
                                " duration-150 ease-in-out"
                              }
                            >
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="mr-2 ml-3"
                              >
                                <path
                                  d="M19.5304 17.4698C19.2375 17.1769 18.7626 17.1769 18.4697 17.4698C18.1768 17.7626 18.1768 18.2375 18.4697 18.5304L19.5304 17.4698ZM22.4696 22.5304C22.7625 22.8233 23.2374 22.8233 23.5303 22.5304C23.8232 22.2375 23.8232 21.7626 23.5303 21.4697L22.4696 22.5304ZM9.33512 4.80232C9.74423 4.73752 10.0234 4.35334 9.95856 3.94423C9.89376 3.53511 9.50958 3.25599 9.10047 3.32079L9.33512 4.80232ZM4.32076 8.1005C4.25596 8.50961 4.53508 8.89379 4.9442 8.95859C5.35331 9.02339 5.73749 8.74426 5.80229 8.33515L4.32076 8.1005ZM18.4697 18.5304L22.4696 22.5304L23.5303 21.4697L19.5304 17.4698L18.4697 18.5304ZM11 18.25C6.44365 18.25 2.75 14.5563 2.75 10H1.25C1.25 15.3848 5.61522 19.75 11 19.75V18.25ZM19.25 10C19.25 14.5563 15.5563 18.25 11 18.25V19.75C16.3848 19.75 20.75 15.3848 20.75 10H19.25ZM11 1.75C15.5563 1.75 19.25 5.44365 19.25 10H20.75C20.75 4.61522 16.3848 0.25 11 0.25V1.75ZM11 0.25C5.61522 0.25 1.25 4.61522 1.25 10H2.75C2.75 5.44365 6.44365 1.75 11 1.75V0.25ZM9.10047 3.32079C6.64008 3.71047 4.71044 5.64012 4.32076 8.1005L5.80229 8.33515C6.09032 6.51661 7.51658 5.09035 9.33512 4.80232L9.10047 3.32079Z"
                                  fill="white"
                                />
                              </svg>
                              Cari Buku
                            </button>
                          </div>
                        ) : (
                          <>
                            <div className={"pl-4 pr-4 grid grid-cols-2"}>
                              <div>
                                Scan Wifi
                                <div
                                  className=" p-2 rounded-2xl"
                                  style={{ width: "120px", height: "120px" }}
                                >
                                  <img
                                    src={"/QR-WIFI.png"}
                                    style={{ maxWidth: "115px" }}
                                  ></img>
                                </div>
                              </div>

                              <div
                                className={
                                  "p-4 w-[300px] " +
                                  this.state.darkcolor +
                                  " bg-opacity-20 rounded-2xl"
                                }
                              >
                                <p className="text-sm">
                                  Cari buku yang ingin kamu baca
                                </p>
                                <button
                                  onClick={() => this.gotoSearch(0)}
                                  className={
                                    "flex w-full mt-2 p-1 items-center text-xs border border-white rounded-full hover:bg-white hover:" +
                                    this.state.textcolor +
                                    " duration-150 ease-in-out"
                                  }
                                >
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="mr-2 ml-3"
                                  >
                                    <path
                                      d="M19.5304 17.4698C19.2375 17.1769 18.7626 17.1769 18.4697 17.4698C18.1768 17.7626 18.1768 18.2375 18.4697 18.5304L19.5304 17.4698ZM22.4696 22.5304C22.7625 22.8233 23.2374 22.8233 23.5303 22.5304C23.8232 22.2375 23.8232 21.7626 23.5303 21.4697L22.4696 22.5304ZM9.33512 4.80232C9.74423 4.73752 10.0234 4.35334 9.95856 3.94423C9.89376 3.53511 9.50958 3.25599 9.10047 3.32079L9.33512 4.80232ZM4.32076 8.1005C4.25596 8.50961 4.53508 8.89379 4.9442 8.95859C5.35331 9.02339 5.73749 8.74426 5.80229 8.33515L4.32076 8.1005ZM18.4697 18.5304L22.4696 22.5304L23.5303 21.4697L19.5304 17.4698L18.4697 18.5304ZM11 18.25C6.44365 18.25 2.75 14.5563 2.75 10H1.25C1.25 15.3848 5.61522 19.75 11 19.75V18.25ZM19.25 10C19.25 14.5563 15.5563 18.25 11 18.25V19.75C16.3848 19.75 20.75 15.3848 20.75 10H19.25ZM11 1.75C15.5563 1.75 19.25 5.44365 19.25 10H20.75C20.75 4.61522 16.3848 0.25 11 0.25V1.75ZM11 0.25C5.61522 0.25 1.25 4.61522 1.25 10H2.75C2.75 5.44365 6.44365 1.75 11 1.75V0.25ZM9.10047 3.32079C6.64008 3.71047 4.71044 5.64012 4.32076 8.1005L5.80229 8.33515C6.09032 6.51661 7.51658 5.09035 9.33512 4.80232L9.10047 3.32079Z"
                                      fill="white"
                                    />
                                  </svg>
                                  Cari Buku
                                </button>
                              </div>
                            </div>
                          </>
                        )}
                        <div
                          className="mt-5 sm:mt-[3px]"
                          style={{ marginLeft: "calc(50vw - 140px)" }}
                        >
                          <center>Scan Disini</center>
                          <center>
                            <QRCode
                              className="bg-white p-2 rounded"
                              size={70}
                              style={{
                                height: "auto",
                                maxWidth: "120px",
                                width: "120px",
                              }}
                              value={this.state.urlTitikBaca}
                              viewBox={`0 0 90 90`}
                            />
                          </center>
                        </div>
                      </div>
                      {localStorage.getItem("sn") && (
                        <div className="text-sm">
                          SSID: Wifi titikbaca, Password: titikbaca
                        </div>
                      )}
                    </div>
                  </div>
                  {/*
              <div className="mt-2">
                <span className="text-sm mr-1 float-left">Disponsori oleh:</span>
                <img src={logo_sponsor} alt="logo bca" className="float-left h-4" />
              </div>
              */}
                </div>
                {/* End Section Hero */}

                {/* Main Content Wrap */}
                <div className="relative mt-[315px] mb-[70px] sm:mb-0 sm:mt-[280px] md:mb-[0px] bg-white z-10 before:absolute before:top-[-25px] before:left-0 before:w-full before:h-[25px] before:bg-white before:rounded-t-2xl after:absolute after:w-20 after:h-1 after:top-[-14px] after:left-[38%] after:sm:left-[44%] after:bg-gray-200 after:rounded-full no-scrollbar overflow-auto">
                  {this.state.loadingYoutube ? (
                    <SkeletonVideo />
                  ) : (
                    <>
                      {this.state.flagYoutube &&
                        this.state.youtube.length > 0 && (
                          <>
                            {this.state.alias == "TB1734344746" &&
                            localStorage.getItem("sn") !== null ? null : (
                              <>
                                {/* <!-- Titel Section --> */}
                                <div className="flex justify-between px-4 items-center mt-4 mb-2">
                                  <div className="flex">
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M6.98901 4.89052C10.3247 4.62955 13.6756 4.62955 17.0113 4.89052L19.252 5.06582C20.5001 5.16346 21.5211 6.09886 21.7274 7.33363C22.2436 10.4231 22.2436 13.5769 21.7274 16.6664C21.5211 17.9011 20.5001 18.8365 19.252 18.9342L17.0113 19.1095C13.6756 19.3704 10.3247 19.3704 6.989 19.1095L4.7483 18.9342C3.50023 18.8365 2.47921 17.9011 2.2729 16.6664C1.75669 13.5769 1.75669 10.4231 2.2729 7.33363C2.47921 6.09886 3.50023 5.16346 4.7483 5.06582L6.98901 4.89052ZM10.0001 14.4701V9.52986C10.0001 9.29667 10.2545 9.15263 10.4545 9.27261L14.5714 11.7428C14.7656 11.8593 14.7656 12.1407 14.5714 12.2572L10.4545 14.7274C10.2545 14.8474 10.0001 14.7033 10.0001 14.4701Z"
                                        fill="#E23D31"
                                      />
                                    </svg>
                                    <h3 className="ml-1 text-base text-black font-semibold">
                                      Video Untukmu
                                    </h3>
                                  </div>
                                  <Link
                                    to="/ytb/0"
                                    className={
                                      "text-xs font-medium " +
                                      this.state.textcolor +
                                      " hover:opacity-50 duration-150"
                                    }
                                  >
                                    Lihat Semua
                                  </Link>
                                </div>
                                {/* <!-- End Title Section --> */}
                                <div className="pl-4 md:hidden sm:block ">
                                  <Glider
                                    draggable
                                    slidesToShow={1.7}
                                    slidesToScroll={1}
                                  >
                                    {this.state.youtube.map((item) => {
                                      return (
                                        <div className="p-1 pr-2">
                                          <div
                                            onClick={() =>
                                              this.gotoYoutube(item.id)
                                            }
                                            className="mb-1 border bg-white rounded-md shadow-md hover:shadow-lg"
                                          >
                                            <div className="max-h-[155px] overflow-hidden">
                                              <img
                                                className="rounded-lg"
                                                src={item.thumbnail}
                                                alt="cover news"
                                              />
                                            </div>
                                            <div className="flex min-h-[50px] p-2.5 items-center">
                                              <div className="w-12/12">
                                                <h3 className="mb-1 font-semibold text-sm text-black line-clamp-1">
                                                  {item.judul}
                                                </h3>
                                                <div className="leading-[10px] overflow-hidden">
                                                  <div className="inline text-xs text-gray-light mr-0.5">
                                                    {item.channel}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </Glider>
                                </div>
                                {/** IPAD */}
                                <div className="pl-4 hidden md:block lg:hidden">
                                  <Glider
                                    draggable
                                    slidesToShow={3.5}
                                    slidesToScroll={1}
                                  >
                                    {this.state.youtube.map((item) => {
                                      return (
                                        <div className="p-1 pr-2">
                                          <div
                                            onClick={() =>
                                              this.gotoYoutube(item.id)
                                            }
                                            className="mb-1 border bg-white rounded-md shadow-md hover:shadow-lg"
                                          >
                                            <div className="max-h-[155px] overflow-hidden">
                                              <img
                                                className="rounded-lg"
                                                src={item.thumbnail}
                                                alt="cover news"
                                              />
                                            </div>
                                            <div className="flex min-h-[50px] p-2.5 items-center">
                                              <div className="w-12/12">
                                                <h3 className="mb-1 font-semibold text-sm text-black line-clamp-1">
                                                  {item.judul}
                                                </h3>
                                                <div className="leading-[10px] overflow-hidden">
                                                  <div className="inline text-xs text-gray-light mr-0.5">
                                                    {item.channel}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </Glider>
                                </div>
                                <div className="pl-4 hidden lg:block">
                                  <Glider
                                    draggable
                                    slidesToShow={7}
                                    slidesToScroll={1}
                                  >
                                    {this.state.youtube.map((item) => {
                                      return (
                                        <div className="p-1">
                                          <div
                                            onClick={() =>
                                              this.gotoYoutube(item.id)
                                            }
                                            className="mb-2.5 border bg-white rounded-2xl shadow-md hover:shadow-lg"
                                          >
                                            <div className="max-h-[165px] overflow-hidden">
                                              <img
                                                className="rounded-lg"
                                                src={item.thumbnail}
                                                alt="cover news"
                                              />
                                            </div>
                                            <div className="flex min-h-[96px] p-2.5 items-center">
                                              <div className="w-12/12">
                                                <h3 className="mb-1 font-semibold text-sm text-black line-clamp-2">
                                                  {item.judul}
                                                </h3>
                                                <div className="leading-[10px] overflow-hidden">
                                                  <div className="inline text-xs text-gray-light mr-0.5">
                                                    {item.channel}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </Glider>
                                </div>
                              </>
                            )}
                          </>
                        )}
                    </>
                  )}

                  {/* Section Literasi Keluarga */}
                  {this.state.hybrid_umum && (
                    <div className="p-4 lg:p-6">
                      <div className="p-4 lg:p-8 rounded-2xl shadow-md bg-white bordeer border-slate-50 border-opacity-100 flex flex-col md:flex-row justify-center md:justify-center items-center">
                        <div className="w-[65%] md:w-[60%] mr-5 mb-5 lg:w-5/12">
                          <img
                            src={logoLiterasiKeluarga}
                            alt="logo litersi keluarga"
                            className="w-full"
                          />
                        </div>
                        <div className="w-full lg:w-7/12">
                          <div className="grid grid-cols-3 gap-2 md:gap-4">
                            <div
                              className="p-2 md:p-6 gap-y-6 md:gap-y-[2.5rem] lg:gap-y-14 md:h-[12.5rem] md:w-[8.5rem] flex flex-col rounded-xl md:rounded-3xl bg-no-repeat bg-cover bg-left-top bg-[url('/src/assets/images/icon/bg-pranikah.svg')] cursor-pointer"
                              onClick={() => this.gotoSearch(5)}
                            >
                              <div className="p-2 w-12 h-12 md:w-15 md:h-15 flex items-center justify-start bg-white rounded-md md:rounded-xl">
                                <svg
                                  className="md:w-16 md:h-16"
                                  width="37"
                                  height="38"
                                  viewBox="0 0 37 38"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clipPath="url(#clip0_1415_4119)">
                                    <path
                                      d="M13.1188 29.086C14.9519 29.086 16.6398 28.4678 18 27.4392C19.3607 28.4683 21.0481 29.086 22.8812 29.086C27.3583 29.086 31 25.4444 31 20.9677C31 16.4906 27.3584 12.8489 22.8812 12.8489C21.0481 12.8489 19.3602 13.4671 18 14.4956C16.6394 13.4666 14.9519 12.8489 13.1188 12.8489C8.64169 12.8489 5 16.4906 5 20.9677C5 25.4439 8.64169 29.086 13.1188 29.086ZM18 17.6872C18.6324 18.625 19.0021 19.7541 19.0021 20.9677C19.0021 22.1813 18.6324 23.3104 18 24.2482C17.3675 23.3104 16.9978 22.1813 16.9978 20.9677C16.9978 19.7541 17.3679 18.625 18 17.6872ZM22.8816 15.0839C26.1259 15.0839 28.7654 17.7234 28.7654 20.9677C28.7654 24.2119 26.1259 26.851 22.8816 26.851C21.6649 26.851 20.5331 26.4796 19.594 25.8444C20.6207 24.4846 21.2376 22.799 21.2376 20.9677C21.2376 19.1363 20.6207 17.4502 19.594 16.0905C20.5331 15.4553 21.6649 15.0839 22.8816 15.0839ZM13.1188 15.0839C14.3355 15.0839 15.4673 15.4553 16.4065 16.0905C15.3797 17.4503 14.7629 19.1364 14.7629 20.9677C14.7629 22.799 15.3797 24.4846 16.4065 25.8444C15.4673 26.4796 14.3355 26.851 13.1188 26.851C9.87454 26.851 7.235 24.2119 7.235 20.9677C7.23496 17.7234 9.87449 15.0839 13.1188 15.0839Z"
                                      fill="#7367F0"
                                    />
                                    <path
                                      d="M17.8424 9.63991H17.8334C17.8334 9.63991 16.5979 8.28684 15.5198 9.27516C14.4416 10.2635 15.3848 12.5405 17.8334 13.5288L17.8424 13.5373C20.2906 12.549 21.2342 10.2635 20.156 9.27521C19.0779 8.28684 17.8424 9.63991 17.8424 9.63991Z"
                                      fill="#7367F0"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1415_4119">
                                      <rect
                                        width="26"
                                        height="26"
                                        fill="white"
                                        transform="translate(5 6)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </div>
                              <div></div>
                              <h3 className="text-white font-semibold text-sm md:text-base text-center">
                                Pra Nikah
                              </h3>
                            </div>
                            <div
                              className="p-2 md:p-6 gap-y-6 md:gap-y-[2.5rem] lg:gap-y-14 md:h-[12.5rem] md:w-[8.5rem] flex flex-col rounded-xl md:rounded-3xl bg-no-repeat bg-cover bg-left-top bg-[url('/src/assets/images/icon/bg-menikah.svg')] cursor-pointer"
                              onClick={() => this.gotoSearch(6)}
                            >
                              <div className="p-2 w-12 h-12 md:w-15 md:h-15 flex items-center justify-start bg-white rounded-md md:rounded-xl">
                                <svg
                                  className="md:w-16 md:h-16"
                                  width="38"
                                  height="38"
                                  viewBox="0 0 38 38"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clipPath="url(#clip0_1415_4147)">
                                    <path
                                      d="M30.9926 20.3124C30.8066 17.1766 27.6448 17.2689 27.6448 17.2689C27.6448 17.2689 24.5797 20.127 21.323 17.2689C21.323 17.2689 21.1351 17.0844 20.4842 17.2689C19.8369 17.4524 19.465 17.8536 19.0037 17.7946C19.0037 17.7946 19.0009 17.7946 19 17.7946C18.9991 17.7946 18.9972 17.7946 18.9963 17.7946C18.535 17.8536 18.163 17.4524 17.5158 17.2689C16.8648 17.0844 16.677 17.2689 16.677 17.2689C13.4203 20.1279 10.3552 17.2689 10.3552 17.2689C10.3552 17.2689 7.19343 17.1766 7.00744 20.3124C6.82145 23.4481 10.1051 30.178 19 29.9963C27.8949 30.178 31.1785 23.4472 30.9926 20.3124ZM24.1965 22.9519C24.1184 23.8447 23.7316 24.6803 23.142 25.3591C22.6779 25.894 22.1014 26.475 21.3946 27.045C20.5325 27.7404 19.7021 28.2394 19.0028 28.5963V28.6101C19.0028 28.6101 18.9944 28.6055 18.9898 28.6037C18.9851 28.6055 18.9814 28.6083 18.9767 28.6101V28.5963C18.2784 28.2394 17.447 27.7404 16.5849 27.045C15.8782 26.475 15.3016 25.894 14.8376 25.3591C14.248 24.6803 13.8611 23.8447 13.783 22.9519C13.7012 22.0186 13.9337 20.9119 15.1891 20.2202C17.5558 18.9161 18.8484 21.053 18.9888 21.3029C19.1293 21.053 20.4219 18.9161 22.7886 20.2202C24.044 20.9119 24.2765 22.0186 24.1947 22.9519H24.1965Z"
                                      fill="#DC4776"
                                    />
                                    <path
                                      d="M13.3306 16.2084C15.6161 16.2084 17.4689 14.3709 17.4689 12.1043C17.4689 9.83761 15.6161 8.00012 13.3306 8.00012C11.0451 8.00012 9.19238 9.83761 9.19238 12.1043C9.19238 14.3709 11.0451 16.2084 13.3306 16.2084Z"
                                      fill="#DC4776"
                                    />
                                    <path
                                      d="M29.6854 15.1117C29.0056 14.6303 28.2914 13.72 28.1101 13.4812C28.2644 13.0505 28.35 12.5866 28.35 12.1033C28.35 9.83632 26.4975 7.99915 24.2117 7.99915C21.9259 7.99915 20.0735 9.83632 20.0735 12.1033C20.0735 12.7212 20.212 13.3069 20.4585 13.8325C20.1442 14.2125 19.6448 14.7696 19.1631 15.1108C18.4796 15.595 21.0918 16.0875 22.2737 15.7288C22.8521 16.0331 23.5115 16.2065 24.2127 16.2065C24.9864 16.2065 25.7099 15.9953 26.3292 15.6291C27.3317 16.1641 30.4238 15.6319 29.6872 15.1099L29.6854 15.1117Z"
                                      fill="#DC4776"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1415_4147">
                                      <rect
                                        width="24"
                                        height="22"
                                        fill="white"
                                        transform="translate(7 8)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </div>
                              <div></div>
                              <h3 className="text-white font-semibold text-sm md:text-base text-center">
                                Menikah
                              </h3>
                            </div>
                            <div
                              className="p-2 md:p-6 gap-y-6 md:gap-y-[2.5rem] lg:gap-y-14 md:h-[12.5rem] md:w-[8.5rem] flex flex-col rounded-xl md:rounded-3xl bg-no-repeat bg-cover bg-left-top bg-[url('/src/assets/images/icon/bg-golden-age.svg')] cursor-pointer"
                              onClick={() => this.gotoSearch(7)}
                            >
                              <div className="p-2 w-12 h-12 md:w-15 md:h-15 flex items-center justify-start bg-white rounded-md md:rounded-xl">
                                <svg
                                  className="md:w-16 md:h-16"
                                  width="38"
                                  height="38"
                                  viewBox="0 0 38 38"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clipPath="url(#clip0_1415_4173)">
                                    <path
                                      d="M28.4504 15.2215C28.0785 15.2582 27.7347 15.4329 27.4586 15.6836C23.4238 19.3182 19.2255 20.1832 19.0001 20.2283C18.7747 20.1832 14.5764 19.3182 10.5416 15.6836C10.2655 15.4329 9.92173 15.2582 9.5498 15.2215C8.82567 15.1511 7.84232 15.5399 8.02265 18.256C8.30441 22.4766 14.4356 31.3377 18.9888 31.9942C18.9888 31.9942 18.9973 31.9942 19.0001 31.9942C19.0029 31.9942 19.0086 31.9942 19.0114 31.9942C23.5647 31.3321 29.6958 22.471 29.9776 18.2504C30.1579 15.5343 29.1745 15.1455 28.4504 15.2159V15.2215Z"
                                      fill="#F4AF33"
                                    />
                                    <path
                                      d="M19.0002 16.9883C22.0347 16.9883 24.4946 14.5285 24.4946 11.4941C24.4946 8.45981 22.0347 6 19.0002 6C15.9658 6 13.5059 8.45981 13.5059 11.4941C13.5059 14.5285 15.9658 16.9883 19.0002 16.9883Z"
                                      fill="#F4AF33"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1415_4173">
                                      <rect
                                        width="22"
                                        height="26"
                                        fill="white"
                                        transform="translate(8 6)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </div>
                              <div></div>
                              <h3 className="text-white font-semibold text-sm md:text-sm text-center">
                                Golden Age
                              </h3>
                            </div>
                            <div
                              className="p-2 md:p-6 gap-y-6 md:gap-y-[4.5rem] md:h-[12.5rem] md:w-[8.5rem] flex flex-col rounded-xl md:rounded-3xl bg-no-repeat bg-cover bg-left-top bg-[url('/src/assets/images/icon/bg-game-education.svg')] cursor-pointer"
                              onClick={() => this.gotoGames()}
                            >
                              <div className="p-2 w-12 h-12 md:w-15 md:h-15 flex items-center justify-start bg-white rounded-md md:rounded-xl">
                                <svg
                                  className="md:w-16 md:h-16"
                                  width="37"
                                  height="38"
                                  viewBox="0 0 37 38"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M17.9999 8.4375C18.4486 8.4375 18.8124 8.80127 18.8124 9.25V11.1316C20.3631 11.1529 21.9131 11.2352 23.459 11.3784L23.8182 11.4116C26.2717 11.6389 28.1609 13.6763 28.2026 16.1399L28.2157 16.9128C28.2667 19.9189 28.0244 22.9227 27.4923 25.8818C27.2501 27.2284 26.0782 28.2083 24.71 28.2083H24.4705C23.2393 28.2083 22.1238 27.4828 21.6246 26.3573L20.4756 23.7667C19.5234 21.6197 16.4764 21.6197 15.5241 23.7667L14.3751 26.3573C13.876 27.4828 12.7604 28.2083 11.5292 28.2083H11.2897C9.9215 28.2083 8.74965 27.2284 8.50748 25.8818C7.97535 22.9227 7.73304 19.9189 7.78398 16.9128L7.79708 16.1399C7.83884 13.6763 9.72807 11.6389 12.1815 11.4116L12.5408 11.3784C14.0866 11.2352 15.6367 11.1529 17.1874 11.1316V9.25C17.1874 8.80127 17.5511 8.4375 17.9999 8.4375ZM23.4165 14.6667C23.4165 14.0684 22.9315 13.5833 22.3332 13.5833C21.7349 13.5833 21.2499 14.0684 21.2499 14.6667V14.9375C21.2499 15.5358 21.7349 16.0208 22.3332 16.0208C22.9315 16.0208 23.4165 15.5358 23.4165 14.9375V14.6667ZM13.6665 13.8542C14.1153 13.8542 14.479 14.2179 14.479 14.6667V16.0208H15.8332C16.2819 16.0208 16.6457 16.3846 16.6457 16.8333C16.6457 17.2821 16.2819 17.6458 15.8332 17.6458H14.479V19C14.479 19.4487 14.1153 19.8125 13.6665 19.8125C13.2178 19.8125 12.854 19.4487 12.854 19V17.6458H11.4999C11.0511 17.6458 10.6874 17.2821 10.6874 16.8333C10.6874 16.3846 11.0511 16.0208 11.4999 16.0208L12.854 16.0208V14.6667C12.854 14.2179 13.2178 13.8542 13.6665 13.8542ZM22.3332 17.6458C22.9315 17.6458 23.4165 18.1309 23.4165 18.7292V19C23.4165 19.5983 22.9315 20.0833 22.3332 20.0833C21.7349 20.0833 21.2499 19.5983 21.2499 19V18.7292C21.2499 18.1309 21.7349 17.6458 22.3332 17.6458ZM24.4999 17.9167C25.0982 17.9167 25.5832 17.4316 25.5832 16.8333C25.5832 16.235 25.0982 15.75 24.4999 15.75H24.229C23.6307 15.75 23.1457 16.235 23.1457 16.8333C23.1457 17.4316 23.6307 17.9167 24.229 17.9167H24.4999ZM21.5207 16.8333C21.5207 17.4316 21.0357 17.9167 20.4374 17.9167H20.1665C19.5682 17.9167 19.0832 17.4316 19.0832 16.8333C19.0832 16.235 19.5682 15.75 20.1665 15.75H20.4374C21.0357 15.75 21.5207 16.235 21.5207 16.8333Z"
                                    fill="#0194F3"
                                  />
                                </svg>
                              </div>
                              <h3 className="text-white font-semibold text-sm md:text-base text-center">
                                Game Edukasi
                              </h3>
                            </div>
                            <div
                              className="p-2 md:p-6 gap-y-6 md:gap-y-[4.5rem] md:h-[12.5rem] md:w-[8.5rem] flex flex-col rounded-xl md:rounded-3xl bg-no-repeat bg-cover bg-left-top bg-[url('/src/assets/images/icon/bg-music-family.svg')] cursor-pointer"
                              onClick={() => this.gotoMusik()}
                            >
                              <div className="p-2 w-12 h-12 md:w-15 md:h-15 flex items-center justify-start bg-white rounded-md md:rounded-xl">
                                <svg
                                  className="md:w-16 md:h-16"
                                  width="38"
                                  height="38"
                                  viewBox="0 0 38 38"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M19.25 11C19.25 9.55087 20.4891 8.09343 22.1648 8.52004C25.9498 9.48363 28.75 12.9139 28.75 17C28.75 18.159 28.5243 19.2671 28.1137 20.2814C27.999 20.5646 27.724 20.75 27.4185 20.75C27.1129 20.75 26.8379 20.5646 26.7233 20.2814C26.1709 18.9168 25.2213 17.5152 24.0274 16.4633C23.0413 15.5946 21.9228 14.9925 20.75 14.8089V24C20.75 27.1756 18.1756 29.75 15 29.75C11.8244 29.75 9.25 27.1756 9.25 24C9.25 20.8244 11.8244 18.25 15 18.25C16.6837 18.25 18.1984 18.9737 19.25 20.127V11Z"
                                    fill="#12D7E4"
                                  />
                                </svg>
                              </div>
                              <h3 className="text-white font-semibold text-sm md:text-base text-center">
                                Musik Keluarga
                              </h3>
                            </div>
                            <div
                              className="p-2 md:p-6 gap-y-2  md:gap-y-[2.5rem] lg:gap-y-9 md:h-[12.5rem] md:w-[8.5rem] flex flex-col rounded-xl md:rounded-3xl bg-no-repeat bg-cover bg-left-top bg-[url('/src/assets/images/icon/bg-lembaga.svg')] cursor-pointer"
                              onClick={() => this.gotoKementerian()}
                            >
                              <div className="p-2 w-12 h-12 md:w-15 md:h-15 flex items-center justify-start bg-white rounded-md md:rounded-xl">
                                <svg
                                  className="md:w-16 md:h-16"
                                  width="38"
                                  height="38"
                                  viewBox="0 0 38 38"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clipPath="url(#clip0_1415_4134)">
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M31.5345 14.9121C31.3865 14.3068 31.4624 14.8085 31.5536 14.2236C31.6068 13.8824 31.6232 13.8101 31.542 13.4605C31.3701 12.7201 31.7175 12.6562 31.5238 11.9833C31.4974 11.8922 31.4279 11.7889 31.4077 11.6874C31.3534 11.4184 31.4895 10.9476 31.2616 10.5423C31.0388 10.1459 31.2791 10.4657 31.1734 9.85998C31.1228 9.57048 31.115 9.46783 30.9876 9.22121C30.7248 8.71281 31.0485 7.96123 30.4306 7.40856C30.2155 7.21636 30.3077 7.19914 30.2145 6.74895C30.1781 6.5738 30.1254 6.41208 30.0468 6.24692C29.9376 6.01769 29.7215 5.60574 29.498 5.45694C29.498 5.62365 29.4895 5.81103 29.4961 5.97447C29.5042 6.18199 29.55 6.24727 29.5514 6.48752L29.4782 7.49967C29.3755 8.09074 29.2734 8.64581 29.0016 9.18694C27.5284 12.1182 24.8618 12.2224 23.9277 12.8603C23.3076 13.2838 23.0565 14.3376 22.4795 14.6552C22.0711 14.8799 21.9018 14.7456 21.509 14.7387C21.4966 14.6665 21.4918 14.5448 21.4797 14.484C21.4457 14.314 21.3298 13.9868 21.3296 13.7913C21.4284 13.581 21.4795 13.6558 21.5351 13.4496C21.2433 13.4496 20.9945 13.5223 20.807 13.295C21.0142 13.1655 21.2106 13.2326 21.2781 12.9857C21.0548 12.9808 20.7803 12.8963 20.6573 12.7234C20.8384 12.6226 21.1066 12.6217 21.1754 12.3669C20.8787 12.3674 20.5409 12.3198 20.4561 12.0059C20.8741 12.1068 21.2709 11.9571 21.265 11.6492C21.0787 11.7386 20.7346 11.6988 20.5769 11.5753C20.2809 11.3439 20.2783 10.4075 20.247 10.1016C20.2232 9.87014 20.1103 9.65986 20.0027 9.44527C20.1694 9.2758 20.34 9.0979 20.4048 8.86023L20.148 8.96356C20.3123 8.71126 20.3541 8.55695 20.3535 8.24143C20.0876 8.31411 20.2404 8.57176 19.9425 8.65408C20.0387 8.50752 20.1094 8.33788 20.0879 8.15136C20.0827 8.10676 20.0521 7.95227 20.041 7.88407L19.9559 7.63607C19.6178 8.10676 20.1356 8.44466 18.5555 8.44793C18.2058 8.44844 17.7932 8.35613 17.4952 8.41486C17.0282 8.50666 17.0927 8.58605 16.7574 8.80873C16.6794 8.48392 16.7581 8.52887 16.7574 8.18994C16.5496 8.24643 16.4141 8.44225 16.3332 8.6496C16.1686 8.51527 16.2894 8.53852 16.0473 8.53542C16.1994 8.71263 16.088 8.64426 15.8884 8.71005C15.8193 8.72314 15.75 8.73365 15.6822 8.76017L15.52 8.86453L15.8796 8.977C15.6881 9.07637 15.4202 9.1177 15.3792 9.36691C15.5956 9.36433 15.6652 9.23912 15.8709 9.38895C15.7068 9.52931 15.3225 9.63609 14.9969 9.92904C14.6327 10.2566 14.6512 10.5968 14.6512 11.0774C15.056 10.9657 14.939 10.2158 16.6548 10.4164C16.569 10.6031 16.3368 10.7288 16.1303 10.7612C15.856 10.8043 15.7013 10.6243 15.4732 10.5618L15.5694 10.8711L15.4339 10.8267C15.3857 11.3776 15.9794 11.6594 16.7414 11.3707C16.9802 11.2803 17.4365 11.183 17.4056 11.5769C17.3765 11.9487 17.0384 12.05 16.7061 12.057C16.7557 12.2408 16.8756 12.2795 17.01 12.3532C16.853 12.414 16.545 12.4741 16.4625 12.5343C16.5001 12.7461 16.7146 12.7487 16.8515 12.8127C16.6792 12.9514 16.4658 12.985 16.2438 12.9851C16.3282 13.2157 16.5197 13.2304 16.7531 13.2562C16.5094 13.55 16.314 13.4784 15.9868 13.4491L16.141 13.7421L16.044 14.1225C15.9794 14.432 15.9409 14.4211 15.9355 14.5921C15.7488 14.7676 15.3031 14.8222 15.0392 14.7614C14.1905 14.566 14.0193 13.5326 13.4584 12.9963C13.0285 12.5852 10.1461 11.8063 9.46162 10.8716C9.122 10.4078 8.85048 10.3431 8.24921 9.30405C7.86904 8.64702 7.66302 7.33227 7.66441 6.53936C7.6651 6.14324 7.71587 5.85822 7.71587 5.45642C7.02866 5.91436 6.98517 7.20121 6.82991 7.35173C6.59685 7.57786 6.55007 7.54824 6.45148 7.90009C6.38996 8.1195 6.32672 8.45551 6.3281 8.70454C6.33105 9.19934 6.26313 9.05915 6.12814 9.43201C6.02799 9.70877 6.0318 9.93645 6.02297 10.2547C6.01465 10.5492 5.83756 10.6818 5.81434 11.0251C5.78974 11.3891 5.88556 11.54 5.72874 11.8672C5.55304 12.2339 5.65562 12.6576 5.73689 13.0163C5.8237 13.3993 5.48581 13.3962 5.65614 14.2274C5.76427 14.7551 5.75595 14.4344 5.67035 14.9545C5.61092 15.315 5.72805 15.4412 5.81746 15.7164C5.8762 15.8972 5.73775 15.8905 5.89751 16.4602C6.1531 17.3711 5.8736 16.6874 5.99663 17.2349C6.0798 17.6057 6.15777 17.5959 6.28011 17.8811L6.72231 19.2935C6.8436 19.5787 7.00353 19.5851 7.0893 19.8534C7.18478 20.152 7.26258 20.1859 7.47311 20.3962C7.67082 20.5936 7.6495 20.776 7.80753 20.9887C8.02343 21.279 8.12705 21.1032 8.27416 21.4485C8.44224 21.8434 8.75015 21.8059 9.0319 22.1317C9.30983 22.4532 9.40583 22.3566 9.57979 22.5099C9.69745 22.6134 9.69 22.6258 9.83191 22.7209C10.0998 22.9007 10.1772 22.9305 10.4865 22.992C10.9381 23.0817 11.2706 23.6046 12.7982 23.2944C13.0455 23.2443 13.2818 23.1724 13.5151 23.0856C13.7481 22.999 13.9441 22.8411 14.1889 22.7822C13.9703 23.2563 14.0158 23.3076 13.6663 23.762L13.8748 23.8352L13.0586 24.6902L13.4674 24.6251C13.4123 24.7533 13.4173 24.7657 13.3305 24.8597C13.3054 24.8869 13.2536 24.9312 13.2227 24.9575C13.2144 24.9646 13.2016 24.9739 13.1935 24.9808L13.1056 25.0557C13.2149 25.1902 13.3652 25.2204 13.5209 25.2575L13.1877 25.7641L13.483 25.8522C13.3621 26.0703 13.2229 26.2111 13.1255 26.4076C12.8114 27.0418 12.7277 27.5507 11.9819 27.9391C11.9291 27.8612 11.3983 27.3924 11.3028 27.3294C10.8603 27.037 10.7595 27.1475 10.3916 27.4279C10.2701 27.3473 9.63853 26.4915 9.24416 26.0958C9.01544 25.8662 8.8607 25.7057 8.58987 25.515C8.47014 25.4306 8.34261 25.3511 8.21923 25.2682C8.05895 25.1606 7.9685 25.0428 7.80095 25.0855C7.78015 25.2947 8.21456 25.5412 8.28092 26.2892C7.99727 26.2892 7.8706 26.2823 7.60826 26.336L7.16918 26.4626C7.01895 26.533 7.09502 26.5051 7.04789 26.5472C7.10317 26.6997 6.95709 26.5945 7.20557 26.6982C8.56648 27.2658 9.06776 28.9548 9.46249 29.0738C9.94177 29.0735 10.0154 28.8226 10.3358 28.6097L10.6953 28.9658C10.6184 29.3012 10.5922 29.5902 10.9365 29.7598C11.2299 29.9045 10.9426 29.7822 11.4035 30.0646C11.4973 30.122 11.487 30.1709 11.6262 30.2541C11.8313 30.3767 12.0887 30.2871 12.2382 30.1566C13.0302 30.6869 13.7609 30.9688 14.5998 31.3671C14.466 31.7934 13.9113 32.6356 13.8805 32.9926C14.767 32.9917 15.0073 32.6368 15.2163 32.5801C15.126 32.9538 14.8332 33.094 14.754 33.3021C15.2617 33.2912 15.6781 33.1112 16.0898 32.8379L16.1029 32.7907L16.1409 32.8205L16.0898 32.8379L15.9225 33.2969C16.2707 33.3021 16.4841 33.2588 16.7759 33.1142C17.0819 32.9624 17.144 32.8362 17.3741 32.6833L17.3872 32.6361L17.4252 32.6659L17.3741 32.6833C17.2431 33.2358 16.9632 33.42 16.9118 33.6114C17.6926 33.6114 18.1561 33.4357 18.5208 32.8543L18.6071 32.7348L18.731 32.9197C18.7535 32.9568 18.8268 33.0734 18.8532 33.1066C19.1553 33.4869 19.8483 33.6114 20.3024 33.6114C20.2534 33.4299 20.1508 33.4113 20.0446 33.1998C19.9448 33.0009 19.8897 32.8927 19.84 32.6833C20.3466 33.0198 20.3624 33.3021 21.2785 33.3021L21.1245 32.8379L21.0775 32.8247L21.1071 32.7866L21.1245 32.8379C21.5466 33.115 21.9515 33.2566 22.4602 33.3021C22.4081 33.1119 22.0943 32.9798 21.9979 32.5801C22.3772 32.6831 22.1016 32.8825 23.3337 32.9926C23.3036 32.645 22.7411 31.7882 22.6145 31.3627C23.4349 31.0074 24.2268 30.6628 24.9753 30.1564L25.4371 30.3361C25.5466 30.2386 25.7017 30.1147 25.8005 30.0541C25.9673 29.9518 26.0314 29.8724 26.159 29.7951C26.6499 29.4972 26.5634 29.5123 26.5189 28.9574L26.871 28.6529C27.2324 28.8394 27.297 29.0731 27.7519 29.0737C28.1322 28.959 28.6202 27.2772 30.0086 26.698C30.2573 26.5943 30.111 26.6996 30.1665 26.547C30.1294 26.5139 30.1474 26.5137 30.0802 26.479C29.7643 26.3157 29.2738 26.2892 28.9335 26.2892C28.9473 25.6349 29.4257 25.2732 29.4134 25.0855C29.1395 25.0156 28.1626 25.9027 27.9959 26.0699L26.8226 27.4279C26.4795 27.1666 26.3662 27.0361 25.9424 27.3091C25.7889 27.4079 25.3032 27.8078 25.2621 27.9392C24.6669 27.7109 24.3489 26.9889 24.1119 26.4362C24.0336 26.2537 23.8626 26.0432 23.7359 25.8767L24.01 25.7995C23.9379 25.5273 23.8227 25.4544 23.6933 25.2579L24.0992 25.1105C24.0117 24.9527 23.8594 24.8425 23.7491 24.6524L24.1498 24.687L23.3426 23.8477L23.5531 23.7849C23.2367 23.3536 23.2249 23.2158 23.0253 22.7827C23.175 22.8189 23.4197 22.9711 23.5903 23.0407C23.8003 23.1263 24.0159 23.1991 24.2477 23.2575C24.8885 23.4189 25.7367 23.4866 26.3541 23.1328C26.7396 22.9119 27.0446 23.0402 27.5331 22.6146C27.9747 22.2297 27.795 22.5035 28.0485 22.2554C28.2591 22.0492 28.2452 22.0391 28.5018 21.8854C28.724 21.7525 28.8233 21.665 28.9329 21.4414C29.0908 21.1199 29.1393 21.2861 29.3594 21.0445C29.5318 20.8552 29.546 20.6299 29.6645 20.4742C29.7957 20.3022 29.9385 20.2593 30.0483 20.0344C30.1629 19.8005 30.1746 19.7511 30.1731 19.7428C30.1675 19.7459 30.1722 19.7383 30.1731 19.7428C30.183 19.7373 30.2258 19.6975 30.3826 19.4933C30.5756 19.242 30.5245 19.0921 30.5971 18.8321C30.6555 18.6234 30.7773 18.4921 30.8452 18.2045C30.9362 17.8189 30.8918 17.9489 31.0745 17.6097C31.2165 17.346 31.2349 17.224 31.2042 16.9444C31.1788 16.7129 31.4153 16.2691 31.3874 15.9346C31.3553 15.5492 31.6478 15.3749 31.5345 14.9116V14.9121ZM14.7443 15.2549L14.2454 15.2989C14.3348 15.2592 14.4864 15.2776 14.7443 15.2549ZM18.461 12.6393C18.4628 12.6353 18.4647 12.6312 18.4662 12.6271C18.4645 12.6312 18.4628 12.6353 18.461 12.6393ZM18.4699 12.6176C18.4714 12.6135 18.4728 12.6092 18.4744 12.6049C18.473 12.6092 18.4714 12.6135 18.4699 12.6176ZM18.4903 12.5401C18.4914 12.5341 18.4924 12.5279 18.4934 12.5215C18.4926 12.5279 18.4915 12.5339 18.4903 12.5401ZM18.4983 12.4816C18.499 12.4748 18.4995 12.4678 18.5 12.4607C18.4995 12.4678 18.4988 12.4748 18.4983 12.4816ZM18.5009 12.4506C18.5016 12.4399 18.5023 12.4289 18.5028 12.4175C18.5023 12.429 18.5016 12.4399 18.5009 12.4506ZM18.4493 12.6631C18.4519 12.6581 18.4546 12.6531 18.457 12.6479C18.4546 12.6531 18.452 12.6581 18.4493 12.6631ZM18.3912 12.7459C18.3943 12.7423 18.3974 12.7387 18.4002 12.7352C18.3973 12.7389 18.3941 12.7423 18.3912 12.7459ZM18.4078 12.7258C18.4104 12.7223 18.4132 12.719 18.4156 12.7156C18.413 12.719 18.4104 12.7223 18.4078 12.7258ZM18.4226 12.7063C18.425 12.7029 18.4274 12.6992 18.4298 12.6958C18.4274 12.6992 18.4252 12.7029 18.4226 12.7063ZM18.4357 12.6868C18.4385 12.6825 18.4411 12.6781 18.4435 12.6738C18.4409 12.6781 18.4385 12.6825 18.4357 12.6868ZM24.4678 29.8876C24.4666 29.8903 24.4647 29.8934 24.4628 29.8964C24.4649 29.8933 24.4666 29.8903 24.4678 29.8876ZM24.1188 30.1263C24.1235 30.1168 24.1268 30.1054 24.129 30.0925C24.1268 30.1054 24.1233 30.1168 24.1188 30.1263ZM24.1301 30.0059C24.1271 29.9809 24.1213 29.9444 24.1126 29.8962C24.1214 29.9442 24.1271 29.9809 24.1301 30.0059C24.1323 30.0248 24.1332 30.0417 24.1327 30.0567C24.133 30.0417 24.1322 30.0248 24.1299 30.0059H24.1301ZM23.8667 30.247C23.8667 30.2436 23.8662 30.2401 23.8652 30.2367C23.8662 30.2401 23.8669 30.2436 23.8667 30.247ZM23.2762 30.4309C23.2784 30.4359 23.2805 30.4406 23.2828 30.4452C23.2807 30.4406 23.2784 30.4359 23.2762 30.4309ZM20.2799 31.1918C20.2785 31.1193 20.2919 31.0506 20.3198 30.9858C20.2919 31.0506 20.2785 31.1191 20.2799 31.1918ZM20.4288 30.8631C20.4449 30.856 20.4625 30.8508 20.4818 30.8474C20.4884 30.8462 20.4949 30.8455 20.5014 30.8451C20.4949 30.8457 20.4884 30.8463 20.4818 30.8474C20.4624 30.8507 20.4447 30.8558 20.4288 30.8631ZM20.6613 31.5156C20.6564 31.5213 20.6509 31.5265 20.6452 31.5316C20.6509 31.5266 20.6564 31.5213 20.6613 31.5156ZM20.7308 31.0411C20.7223 31.0227 20.7134 31.0055 20.7046 30.9896C20.7136 31.0055 20.7223 31.0227 20.7308 31.0411ZM20.5377 30.829C20.5215 30.8281 20.5045 30.8286 20.4866 30.8305C20.5043 30.8286 20.5215 30.8281 20.5377 30.829C20.5435 30.8293 20.5494 30.8298 20.5554 30.8307C20.5494 30.83 20.5435 30.8293 20.5377 30.829ZM20.1635 31.2206C20.1628 31.1827 20.1664 31.146 20.1744 31.1102C20.1777 31.0959 20.1815 31.0821 20.1858 31.0687C20.1813 31.0819 20.1775 31.0959 20.1744 31.1102C20.1664 31.146 20.1628 31.1829 20.1635 31.2206ZM20.2059 31.4154C20.1971 31.3963 20.1896 31.3761 20.1836 31.3551C20.1896 31.3761 20.1971 31.3961 20.2059 31.4154ZM20.3132 31.5456C20.3031 31.539 20.2936 31.5318 20.2844 31.524C20.2936 31.532 20.3031 31.539 20.3132 31.5456ZM20.353 31.5669C20.3447 31.5633 20.3364 31.5593 20.3286 31.5549C20.3364 31.5593 20.3447 31.5631 20.353 31.5669ZM20.5568 31.5872C20.5986 31.5802 20.6374 31.5678 20.6731 31.55C20.6372 31.5678 20.5986 31.58 20.5568 31.5872C20.5353 31.591 20.5143 31.5931 20.4941 31.5934C20.5143 31.5929 20.5353 31.5909 20.5568 31.5872ZM20.7904 31.4686C20.7869 31.4693 20.7829 31.4708 20.7786 31.4736C20.7829 31.4708 20.7867 31.4691 20.7904 31.4686ZM21.5114 31.1007C21.5126 31.0894 21.5162 31.0797 21.5221 31.0716C21.5162 31.0795 21.5126 31.0892 21.5114 31.1007ZM21.2837 30.7017C21.313 30.7194 21.3419 30.7466 21.3702 30.7831C21.3417 30.7466 21.313 30.7194 21.2837 30.7017C21.2615 30.6884 21.239 30.6803 21.2158 30.6772C21.239 30.6802 21.2615 30.6882 21.2837 30.7017ZM21.1983 30.676C21.1808 30.6757 21.1627 30.6784 21.1446 30.6838C21.1303 30.6881 21.1175 30.6938 21.1056 30.6998C21.1177 30.6936 21.1303 30.6881 21.1446 30.6838C21.1627 30.6783 21.1806 30.6757 21.1983 30.676ZM21.1281 31.3446C21.1116 31.3312 21.0966 31.3155 21.0823 31.2983C21.0966 31.3157 21.1116 31.3312 21.1281 31.3446ZM21.1258 30.6721C21.1385 30.6681 21.151 30.665 21.1629 30.6628C21.1508 30.665 21.1385 30.6683 21.1258 30.6721ZM20.9198 30.8277C20.93 30.8114 20.9418 30.7961 20.9545 30.7816C20.9416 30.7961 20.93 30.8114 20.9198 30.8277ZM21.4951 31.2814C21.484 31.2957 21.4715 31.3093 21.4575 31.322C21.4714 31.3093 21.484 31.2957 21.4951 31.2814ZM21.546 31.2605C21.5332 31.2595 21.524 31.2599 21.5185 31.2617C21.524 31.26 21.5332 31.2597 21.546 31.2605ZM21.5429 31.2492C21.5386 31.2354 21.5349 31.2239 21.532 31.214C21.5349 31.2239 21.5386 31.2356 21.5429 31.2492ZM19.5797 30.5989C20.5145 30.4955 21.2769 30.2556 21.8811 30.0047C22.0106 29.951 22.1329 29.8965 22.248 29.843C22.1329 29.8965 22.0106 29.9508 21.8811 30.0047C21.2769 30.2556 20.5145 30.4957 19.5797 30.5989ZM19.3754 31.0117C19.3711 31.0117 19.3666 31.012 19.3617 31.0124C19.3666 31.012 19.3711 31.0119 19.3754 31.0117ZM19.4341 31.0267C19.4302 31.0237 19.426 31.0215 19.4218 31.0196C19.4262 31.0215 19.4303 31.0239 19.4341 31.0267ZM19.4847 31.6925C19.4865 31.6914 19.4882 31.6902 19.4899 31.6892C19.4882 31.6904 19.4865 31.6914 19.4847 31.6925ZM19.5464 31.5376C19.5504 31.5736 19.5554 31.6002 19.5612 31.6169C19.5554 31.6003 19.5504 31.5736 19.5464 31.5376ZM19.5868 31.6568C19.5944 31.6635 19.6027 31.6685 19.6114 31.672C19.6026 31.6685 19.5944 31.6634 19.5868 31.6568ZM19.6533 31.678C19.6577 31.678 19.6622 31.6777 19.6669 31.6773C19.6622 31.6777 19.6577 31.6778 19.6533 31.678ZM18.1956 31.6387C18.1923 31.6515 18.1871 31.6627 18.1802 31.672C18.1871 31.6627 18.1921 31.6515 18.1956 31.6387ZM18.0457 31.0318C18.0334 31.0367 18.0223 31.0432 18.0119 31.0518C18.0221 31.0434 18.0334 31.0367 18.0457 31.0318C18.0639 31.0248 18.089 31.0203 18.1207 31.0181C18.089 31.0203 18.0641 31.0248 18.0457 31.0318ZM18.1403 31.7013C18.1285 31.7054 18.1129 31.7075 18.0939 31.7076C18.1129 31.7076 18.1285 31.7054 18.1403 31.7013ZM18.3638 31.7119C18.3524 31.7066 18.3422 31.6988 18.3335 31.6882C18.3287 31.6823 18.3247 31.6756 18.3214 31.6682C18.3245 31.6756 18.3287 31.6821 18.3335 31.6882C18.3422 31.6988 18.3524 31.7068 18.3638 31.7119ZM18.7152 31.5681C18.7145 31.5526 18.714 31.5321 18.714 31.507C18.714 31.5323 18.7144 31.5526 18.7152 31.5681ZM18.7119 31.1367C18.7111 31.1236 18.7097 31.1129 18.708 31.1043C18.7097 31.1128 18.7111 31.1236 18.7119 31.1367ZM18.6367 31.0341C18.6353 31.0337 18.634 31.0336 18.6326 31.0334C18.634 31.0336 18.6353 31.0339 18.6367 31.0341ZM18.6253 31.0323C18.6237 31.0322 18.6222 31.032 18.6206 31.0318C18.6222 31.0318 18.6237 31.0322 18.6253 31.0323ZM18.8221 31.1429C18.823 31.1272 18.8242 31.1148 18.826 31.1059C18.8242 31.1148 18.8228 31.1272 18.8221 31.1429ZM18.848 31.6634C18.8582 31.6813 18.87 31.6957 18.8831 31.7073C18.87 31.6957 18.858 31.6813 18.848 31.6634ZM18.9694 31.7416C18.9452 31.7393 18.9242 31.7335 18.9069 31.724C18.9244 31.7333 18.9452 31.7391 18.9694 31.7416ZM19.2392 31.1038C19.2378 31.1104 19.2366 31.1186 19.2357 31.1279C19.2366 31.1188 19.2377 31.1104 19.2392 31.1038ZM19.2831 31.0423C19.2747 31.0468 19.2671 31.0528 19.2602 31.0606C19.2673 31.0528 19.2747 31.0468 19.2831 31.0423ZM14.1375 30.6064C14.1317 30.5963 14.1283 30.5849 14.1269 30.5723C14.1283 30.5849 14.1319 30.5963 14.1375 30.6064ZM14.218 30.0627C14.2276 30.0414 14.2347 30.0238 14.2395 30.009C14.2345 30.0238 14.2276 30.0414 14.218 30.0627ZM12.9883 29.2042C12.988 29.2002 12.9874 29.1963 12.9866 29.1923C12.9874 29.1963 12.988 29.2001 12.9883 29.2042ZM13.1139 29.2461L13.1531 29.2726C13.1832 29.2927 13.2044 29.3096 13.2172 29.323C13.2045 29.3096 13.1832 29.2926 13.1531 29.2726L13.1139 29.2461L12.9569 29.5142L13.1139 29.2459V29.2461ZM14.1716 18.0624C14.1716 18.0691 14.1716 18.0757 14.1716 18.0822C14.1716 18.0757 14.1716 18.069 14.1716 18.0624ZM14.1768 17.6367C14.1768 17.6288 14.1771 17.6207 14.1773 17.6128C14.1773 17.6209 14.177 17.6288 14.1768 17.6367ZM14.1763 18.415C14.1763 18.4117 14.1761 18.4084 14.1759 18.4052C14.1759 18.4084 14.1761 18.4117 14.1763 18.415ZM14.1751 18.3776C14.1751 18.3729 14.1749 18.3681 14.1747 18.3635C14.1747 18.3681 14.1749 18.3729 14.1751 18.3776ZM14.174 18.3388C14.174 18.3339 14.1738 18.3285 14.1737 18.3235C14.1737 18.3287 14.1738 18.3339 14.174 18.3388ZM14.1732 18.2989C14.1732 18.293 14.173 18.2872 14.1728 18.2813C14.1728 18.2872 14.173 18.2932 14.1732 18.2989ZM14.1725 18.2579C14.1725 18.2517 14.1725 18.2453 14.1723 18.239C14.1723 18.2453 14.1723 18.2517 14.1725 18.2579ZM14.1719 18.2155C14.1719 18.2092 14.1719 18.2028 14.1719 18.1964C14.1719 18.2028 14.1719 18.2093 14.1719 18.2155ZM14.1714 18.0361C14.1714 18.0292 14.1714 18.022 14.1714 18.0151C14.1714 18.0221 14.1714 18.0292 14.1714 18.0361ZM14.1719 17.9407C14.1719 17.9336 14.1719 17.9265 14.1721 17.9193C14.1721 17.9264 14.1721 17.9336 14.1719 17.9407ZM14.1725 17.8918C14.1725 17.8845 14.1726 17.8771 14.1728 17.8699C14.1728 17.8771 14.1726 17.8845 14.1725 17.8918ZM14.1732 17.842C14.1732 17.8348 14.1733 17.8273 14.1735 17.8201C14.1735 17.8273 14.1733 17.8348 14.1732 17.842ZM14.1738 17.7914C14.1738 17.7839 14.174 17.7764 14.1742 17.769C14.1742 17.7764 14.174 17.7839 14.1738 17.7914ZM14.1756 17.6885C14.1756 17.6808 14.1759 17.673 14.1761 17.6651C14.1761 17.6729 14.1758 17.6808 14.1756 17.6885ZM14.2102 15.8285C14.2102 15.8213 14.2102 15.8142 14.2101 15.807C14.2101 15.8142 14.2101 15.8213 14.2102 15.8285ZM14.2099 15.7817C14.2099 15.7746 14.2097 15.7677 14.2095 15.7607C14.2095 15.7677 14.2097 15.7746 14.2099 15.7817ZM14.2094 15.7359C14.2094 15.729 14.2092 15.7221 14.209 15.7152C14.209 15.7221 14.2092 15.729 14.2094 15.7359ZM14.2087 15.6909C14.2087 15.684 14.2083 15.6773 14.2082 15.6704C14.2082 15.6773 14.2085 15.684 14.2087 15.6909ZM14.2078 15.6472C14.2078 15.6405 14.2075 15.6341 14.2073 15.6274C14.2073 15.6339 14.2076 15.6405 14.2078 15.6472ZM14.2052 15.5623C14.205 15.5559 14.2047 15.5495 14.2045 15.5433C14.2047 15.5497 14.205 15.5559 14.2052 15.5623ZM14.2037 15.5216C14.2035 15.5153 14.2031 15.5092 14.2028 15.503C14.2031 15.5092 14.2033 15.5154 14.2037 15.5216ZM14.2019 15.482C14.2016 15.4763 14.2014 15.4707 14.2011 15.465C14.2014 15.4707 14.2016 15.4762 14.2019 15.482ZM14.2 15.4438C14.1997 15.4383 14.1993 15.4329 14.199 15.4276C14.1993 15.4331 14.1997 15.4383 14.2 15.4438ZM14.1953 15.3711C14.195 15.3663 14.1946 15.3618 14.1943 15.357C14.1946 15.3616 14.195 15.3663 14.1953 15.3711ZM14.204 16.5016C14.204 16.4933 14.2043 16.4852 14.2045 16.4771C14.2045 16.4852 14.2042 16.4935 14.204 16.5016ZM14.205 16.4461C14.205 16.4384 14.2054 16.4306 14.2056 16.4229C14.2056 16.4306 14.2052 16.4384 14.205 16.4461ZM14.2078 16.2847C14.2078 16.2761 14.208 16.2675 14.2082 16.2589C14.2082 16.2675 14.208 16.2761 14.2078 16.2847ZM14.2085 16.2314C14.2085 16.2229 14.2087 16.2147 14.2089 16.2064C14.2089 16.2147 14.2087 16.2231 14.2085 16.2314ZM14.2092 16.1785C14.2092 16.1704 14.2094 16.1623 14.2094 16.1542C14.2094 16.1623 14.2094 16.1704 14.2092 16.1785ZM14.2097 16.1261C14.2097 16.1186 14.2097 16.111 14.2099 16.1034C14.2099 16.111 14.2099 16.1186 14.2097 16.1261ZM14.2101 16.0748C14.2101 16.0669 14.2101 16.059 14.2101 16.0509C14.2101 16.0588 14.2101 16.0667 14.2101 16.0748ZM14.2104 16.0245C14.2104 16.0164 14.2104 16.0085 14.2104 16.0006C14.2104 16.0085 14.2104 16.0166 14.2104 16.0245ZM14.2104 15.9739C14.2104 15.9663 14.2104 15.9589 14.2104 15.9515C14.2104 15.9589 14.2104 15.9665 14.2104 15.9739ZM17.0923 31.5172C17.0923 31.5139 17.0927 31.5108 17.0932 31.5075C17.0927 31.5108 17.0925 31.5141 17.0923 31.5172ZM16.9535 31.5666C16.9492 31.5642 16.945 31.5619 16.9416 31.5593C16.9452 31.5618 16.9492 31.5642 16.9535 31.5666ZM16.9743 31.5647C16.9794 31.5635 16.9842 31.5621 16.9889 31.56C16.9842 31.5619 16.9794 31.5635 16.9743 31.5647ZM16.9556 31.5673C16.9606 31.5671 16.9657 31.5664 16.9703 31.5655C16.9655 31.5664 16.9606 31.5671 16.9556 31.5673ZM16.9835 30.8706C16.9885 30.8699 16.9943 30.8696 17.0003 30.8698C16.9943 30.8698 16.9885 30.8698 16.9835 30.8706ZM16.8603 30.8496C16.8672 30.8598 16.8695 30.871 16.8669 30.8839C16.865 30.8934 16.8607 30.9013 16.8541 30.9078C16.8607 30.9011 16.865 30.8932 16.8669 30.8839C16.8695 30.8711 16.8672 30.8598 16.8603 30.8496ZM17.0963 31.5451C17.1003 31.5571 17.1064 31.5673 17.1145 31.5757C17.1062 31.5673 17.1003 31.5571 17.0963 31.5451ZM17.0968 31.4896C17.0994 31.48 17.1038 31.4691 17.1088 31.4574C17.1038 31.4691 17.0996 31.48 17.0968 31.4896ZM17.4302 31.507C17.4361 31.5325 17.4382 31.5526 17.4363 31.5669C17.438 31.5526 17.4361 31.5325 17.4302 31.507ZM17.3827 31.6239C17.3888 31.6227 17.3942 31.6213 17.3983 31.6195C17.3942 31.6213 17.3888 31.6229 17.3827 31.6239ZM16.5964 30.928C16.6001 30.9102 16.6039 30.8949 16.6075 30.8822C16.6039 30.8951 16.6002 30.9104 16.5964 30.928ZM16.5063 31.3906C16.5063 31.3906 16.5063 31.3916 16.5063 31.3921C16.5063 31.3916 16.5063 31.3911 16.5063 31.3906ZM16.5022 30.8226C16.5022 30.8048 16.4982 30.7893 16.4902 30.7756C16.4982 30.7892 16.5023 30.8048 16.5022 30.8226ZM16.4994 30.856C16.4975 30.8693 16.4947 30.8849 16.4911 30.9027C16.4947 30.8849 16.4976 30.8693 16.4994 30.856ZM15.9863 30.9555C16.004 30.9607 16.0192 30.9666 16.0315 30.9733C16.0191 30.9667 16.004 30.9609 15.9863 30.9555ZM15.9137 30.661C15.9141 30.6536 15.9134 30.6466 15.9123 30.6397C15.9134 30.6464 15.9141 30.6535 15.9137 30.661ZM15.907 31.2268C15.9063 31.2225 15.9057 31.218 15.9054 31.2134C15.9057 31.218 15.9063 31.2227 15.907 31.2268ZM15.9435 31.2953C15.9532 31.3043 15.9652 31.3122 15.9792 31.3194C15.9652 31.3124 15.9534 31.3043 15.9435 31.2953ZM16.1274 31.3496C16.1558 31.3463 16.1809 31.3363 16.2024 31.3189C16.1807 31.3363 16.1558 31.3465 16.1274 31.3496C16.0991 31.3527 16.0658 31.3487 16.0277 31.3379C16.0658 31.3487 16.0991 31.3525 16.1274 31.3496ZM16.2289 30.6869C16.2337 30.6896 16.2383 30.6924 16.2426 30.6955C16.2383 30.6924 16.2336 30.6896 16.2289 30.6869ZM16.309 30.8446C16.3091 30.8377 16.3093 30.831 16.309 30.8246C16.3091 30.831 16.3091 30.8377 16.309 30.8446ZM15.2258 30.4223C15.2262 30.4179 15.2263 30.4136 15.2263 30.4092C15.2263 30.4136 15.2263 30.4179 15.2258 30.4223ZM15.0567 30.3188C15.0432 30.3252 15.0314 30.3355 15.0219 30.3502C15.0316 30.3355 15.0432 30.325 15.0567 30.3188C15.078 30.3088 15.1016 30.3083 15.1277 30.3174C15.1017 30.3083 15.078 30.3088 15.0567 30.3188ZM13.9706 26.9984C14.1314 26.838 14.2295 26.6379 14.4133 26.5146C14.645 26.3589 14.7704 26.3116 15.0106 26.1255L15.0988 26.3038C15.3502 26.1187 15.2773 26.1181 15.4095 25.9166C15.418 25.9037 15.444 25.8676 15.4528 25.8559C15.5108 25.7799 15.4895 25.8128 15.5287 25.7691C15.7049 25.9135 15.6287 26.0136 15.8839 26.0828C15.8908 25.7513 16.0203 25.4401 16.2949 25.2577C16.297 26.3358 16.1497 26.7003 15.839 27.6363L15.1343 29.765C15.1305 29.7718 15.1203 29.7853 15.1133 29.7954C14.8694 29.736 13.9455 29.2753 13.7394 29.1119C13.7857 28.7525 13.7492 29.1632 13.6616 28.4165L13.2174 28.1474C13.2205 27.9191 13.2524 27.9732 13.3539 27.8233C13.5873 27.4785 13.1056 27.8607 13.9708 26.9985L13.9706 26.9984ZM18.7012 26.0863C18.6731 26.092 18.6423 26.0966 18.6081 26.0997C18.6099 26.0994 18.6118 26.0989 18.6135 26.0985C18.643 26.0952 18.6721 26.0911 18.7012 26.0863ZM15.8075 24.5661C15.8307 24.5886 15.8541 24.611 15.8775 24.6329C15.8635 24.6351 15.8461 24.6379 15.8238 24.6408C15.8205 24.6146 15.8149 24.5897 15.8075 24.5661ZM19.186 25.9876C19.1427 25.985 19.1048 25.9855 19.0706 25.9883C19.0978 25.9786 19.1247 25.9687 19.1517 25.9583C19.1964 25.9449 19.2408 25.9309 19.285 25.9166L19.186 25.9876ZM15.5973 24.3496C15.5758 24.3429 15.5531 24.3377 15.5292 24.3351C15.5171 24.2943 15.5029 24.2581 15.4869 24.2251C15.5233 24.2674 15.5602 24.3089 15.5973 24.3496ZM16.2277 24.9484C16.2202 24.9377 16.2136 24.9283 16.2078 24.9198C16.2206 24.93 16.2332 24.9401 16.2461 24.9501C16.2452 24.9496 16.2443 24.9491 16.2435 24.9486H16.2277V24.9484ZM16.8648 25.3776C16.8283 25.3686 16.7924 25.3628 16.7572 25.3609C16.7432 25.3249 16.7404 25.3089 16.7378 25.2989C16.7803 25.3259 16.8227 25.3523 16.8648 25.3776ZM13.7372 29.6303C13.7294 29.6274 13.7223 29.6255 13.7159 29.6243C13.7223 29.6253 13.7294 29.6274 13.7372 29.6303ZM13.6582 29.6382C13.6519 29.6427 13.6459 29.6484 13.6405 29.6551C13.6292 29.6687 13.6157 29.6912 13.5994 29.7229C13.6156 29.6911 13.6292 29.6685 13.6405 29.6551C13.6461 29.6484 13.6519 29.6429 13.6582 29.6382ZM13.5187 29.5094C13.5104 29.4992 13.4982 29.4889 13.4821 29.4782C13.4981 29.4887 13.5104 29.4992 13.5187 29.5094ZM15.1707 30.3252C15.1813 30.3307 15.1899 30.3362 15.1965 30.3421C15.1899 30.3362 15.1811 30.3307 15.1707 30.3252ZM15.658 30.5122C15.6677 30.5207 15.6755 30.5312 15.681 30.5443C15.6753 30.5312 15.6677 30.5207 15.658 30.5122ZM15.7808 31.1953C15.773 31.2111 15.7628 31.2232 15.75 31.2313C15.7626 31.2232 15.7728 31.2111 15.7808 31.1953ZM15.0361 29.8759C15.2353 29.9637 15.4535 30.0529 15.6902 30.1382C15.4535 30.0529 15.2355 29.9637 15.0361 29.8759ZM14.4861 29.6177C14.4861 29.6177 14.4851 29.6172 14.4844 29.6168C14.4849 29.6172 14.4854 29.6174 14.4861 29.6177ZM23.001 17.8375C23.0062 18.008 23.0114 18.1785 23.0168 18.3492C23.0114 18.1787 23.0062 18.008 23.001 17.8375ZM22.982 17.1679C22.9868 17.3493 22.9918 17.5306 22.9974 17.7123C22.992 17.5308 22.9868 17.3493 22.982 17.1679ZM14.9534 23.5136C14.9506 23.5093 14.9479 23.5048 14.9449 23.5005C14.9477 23.505 14.9506 23.5093 14.9534 23.5136ZM14.9065 23.4401C14.912 23.4487 14.9174 23.4575 14.9229 23.4661C14.9174 23.4575 14.9118 23.4487 14.9065 23.4401ZM14.8687 23.3793C14.8739 23.3879 14.8793 23.3963 14.8845 23.4049C14.8793 23.3965 14.8739 23.3879 14.8687 23.3793ZM13.3368 29.4124C13.3451 29.4305 13.3499 29.4491 13.3511 29.4684C13.3499 29.4491 13.3452 29.4305 13.3368 29.4124C13.3238 29.3847 13.3021 29.3589 13.2719 29.3347C13.2688 29.3323 13.264 29.3289 13.2581 29.3248C13.264 29.3289 13.2688 29.3325 13.2719 29.3347C13.3023 29.3589 13.3238 29.3847 13.3368 29.4124ZM13.2505 29.4019C13.2498 29.3904 13.2479 29.3795 13.2447 29.3694C13.248 29.3795 13.2499 29.3904 13.2505 29.4019ZM13.1396 29.633C13.1455 29.6344 13.1512 29.6356 13.1565 29.6368C13.1512 29.6358 13.1456 29.6344 13.1396 29.633ZM13.189 29.5533C13.2016 29.5421 13.2125 29.5283 13.222 29.5121C13.2125 29.5285 13.2014 29.5421 13.189 29.5533ZM13.0753 29.5795C13.0661 29.5765 13.0554 29.5722 13.0431 29.5666C13.0552 29.5722 13.0659 29.5765 13.0753 29.5795ZM13.0897 29.6325C13.0732 29.6137 13.0515 29.5953 13.0249 29.5774C13.0515 29.5955 13.0732 29.6139 13.0897 29.6325ZM12.9614 29.9306C12.954 29.9306 12.9465 29.9294 12.9391 29.9281C12.9465 29.9294 12.954 29.9305 12.9614 29.9306ZM13.176 29.5636C13.1623 29.5731 13.1479 29.5796 13.1326 29.5829C13.1479 29.5795 13.1623 29.5731 13.176 29.5636ZM13.217 29.6418C13.2238 29.641 13.2305 29.6396 13.2373 29.6377C13.2305 29.6398 13.2238 29.6411 13.217 29.6418ZM13.3298 30.0114C13.3234 30.024 13.3177 30.0347 13.3121 30.0443C13.3177 30.0347 13.3236 30.024 13.3298 30.0114ZM14.0824 29.8623C14.0683 29.8671 14.0557 29.8762 14.0446 29.8896C14.0557 29.8764 14.0683 29.8671 14.0824 29.8623ZM14.1875 29.8747C14.1959 29.8795 14.2031 29.8843 14.2094 29.8891C14.203 29.8843 14.1957 29.8795 14.1875 29.8747ZM14.3896 30.0135C14.4021 30.0085 14.4145 30.0066 14.427 30.008C14.4364 30.009 14.4471 30.0119 14.4592 30.0164C14.4471 30.0118 14.4365 30.009 14.427 30.008C14.4147 30.0066 14.4022 30.0085 14.3896 30.0135ZM14.3735 30.675C14.3735 30.6709 14.374 30.6665 14.3747 30.6621C14.374 30.6664 14.3736 30.6707 14.3735 30.675ZM14.5178 30.2141C14.5242 30.1976 14.5292 30.1829 14.533 30.1702C14.5292 30.1829 14.524 30.1974 14.5178 30.2141ZM14.9921 30.3002C14.9945 30.3114 14.9947 30.3235 14.9927 30.3364C14.9921 30.3409 14.9912 30.3457 14.9898 30.3512C14.991 30.3459 14.9921 30.3409 14.9927 30.3364C14.9948 30.3236 14.9945 30.3116 14.9921 30.3002ZM15.004 30.986C14.999 30.9872 14.994 30.9879 14.9889 30.9881C14.9829 30.9881 14.9761 30.9876 14.9687 30.9864C14.9761 30.9876 14.9829 30.9883 14.9889 30.9881C14.994 30.9881 14.999 30.9872 15.004 30.986ZM15.0503 30.9562C15.043 30.9655 15.0347 30.9728 15.0255 30.9778C15.0349 30.9726 15.0432 30.9655 15.0503 30.9562ZM15.118 31.0356C15.1085 31.0272 15.1007 31.0165 15.0952 31.0036C15.1009 31.0165 15.1085 31.0272 15.118 31.0356ZM16.2817 31.2068C16.2715 31.2287 16.2616 31.2471 16.2525 31.2621C16.2616 31.2471 16.2715 31.2289 16.2817 31.2068ZM16.3909 31.3625C16.3961 31.3504 16.4015 31.3329 16.407 31.3098C16.4015 31.3329 16.3963 31.3504 16.3909 31.3625ZM16.5917 31.1124L16.6699 31.2829C16.6787 31.3019 16.6893 31.3262 16.7018 31.3558C16.6893 31.326 16.6789 31.3017 16.6699 31.2829L16.5917 31.1124ZM16.6909 31.5046C16.6817 31.5046 16.6711 31.5039 16.6588 31.502C16.6711 31.5037 16.6817 31.5046 16.6909 31.5046ZM17.1247 31.5829C17.135 31.5902 17.1473 31.5957 17.1622 31.5993C17.1474 31.5957 17.135 31.5903 17.1247 31.5829ZM17.6582 31.6734C17.6484 31.6706 17.6395 31.668 17.6323 31.6654C17.6397 31.668 17.6484 31.6706 17.6582 31.6734ZM23.5702 29.6695C23.576 29.6708 23.5808 29.6737 23.5851 29.6771C23.5808 29.6737 23.576 29.6709 23.5702 29.6695ZM23.5118 29.672L23.5169 29.6818C23.5259 29.6776 23.5338 29.6744 23.5406 29.6723C23.5338 29.6745 23.5259 29.6776 23.5169 29.6818L23.5118 29.672ZM22.3247 30.318C22.3298 30.3057 22.3365 30.2954 22.3457 30.2866C22.3365 30.2954 22.3296 30.3057 22.3247 30.318ZM21.7547 31.0826C21.7547 31.0876 21.7547 31.0923 21.7547 31.0969C21.7547 31.0923 21.7547 31.0875 21.7547 31.0826ZM21.782 31.1941C21.7884 31.2008 21.7957 31.2058 21.8033 31.2094C21.7955 31.2058 21.7884 31.2008 21.782 31.1941ZM21.8113 31.2123C21.8188 31.2146 21.8269 31.2156 21.8354 31.2152C21.8269 31.2154 21.8188 31.2146 21.8113 31.2123ZM22.0809 31.1114C22.0901 31.0992 22.095 31.0864 22.0957 31.0732C22.0948 31.0864 22.0899 31.0992 22.0809 31.1114C22.0747 31.1202 22.0631 31.1293 22.0463 31.1388C22.0631 31.1291 22.0745 31.12 22.0809 31.1114ZM22.0958 31.0716C22.0962 31.0633 22.0948 31.0549 22.092 31.0461C22.095 31.0547 22.0962 31.0633 22.0958 31.0716ZM22.1035 30.3882C22.1159 30.3838 22.1269 30.3812 22.1364 30.3807C22.1393 30.3805 22.1424 30.3805 22.1454 30.3807C22.1424 30.3807 22.1393 30.3807 22.1364 30.3807C22.1269 30.3813 22.1159 30.3839 22.1035 30.3882ZM22.1723 30.3863C22.178 30.3886 22.1832 30.3917 22.1882 30.3955C22.1832 30.3918 22.1778 30.3886 22.1723 30.3863ZM22.331 30.4099C22.3253 30.3931 22.3214 30.3788 22.3197 30.3679C22.3214 30.3788 22.3254 30.3931 22.331 30.4099ZM22.5297 30.8705C22.5183 30.86 22.5074 30.8445 22.497 30.8243C22.5074 30.8445 22.5185 30.86 22.5297 30.8705ZM22.5727 29.6844C22.6063 29.6675 22.6392 29.6506 22.6715 29.6342C22.6394 29.6508 22.6065 29.6675 22.5727 29.6844ZM22.7733 30.8224C22.7629 30.8331 22.7506 30.8432 22.7363 30.8527C22.7505 30.8432 22.7629 30.8331 22.7733 30.8224ZM23.1137 29.9175C23.1079 29.9237 23.1036 29.9313 23.0998 29.9392C23.1036 29.9313 23.1081 29.9237 23.1137 29.9175ZM23.3082 30.4905C23.3063 30.4874 23.3043 30.484 23.302 30.4804C23.3041 30.484 23.3062 30.4874 23.3082 30.4905ZM23.2466 29.8766C23.2403 29.8743 23.2341 29.8729 23.2278 29.8724C23.2341 29.8729 23.2403 29.8745 23.2466 29.8766C23.2609 29.8809 23.2736 29.89 23.2845 29.9033C23.2736 29.89 23.2609 29.881 23.2466 29.8766ZM23.638 30.3259C23.643 30.3319 23.6486 30.3371 23.6541 30.3412C23.6484 30.3369 23.643 30.3319 23.638 30.3259ZM23.6558 30.3426C23.6558 30.3426 23.6562 30.3428 23.6564 30.3429C23.6562 30.3429 23.656 30.3428 23.6558 30.3426ZM23.9885 28.1309C23.2906 28.4745 23.651 28.267 23.5184 28.7423C23.463 28.9409 23.3692 28.8596 23.4793 29.1062C23.2046 29.3258 22.4311 29.7154 22.101 29.7942L21.0409 26.5785C20.9488 26.3091 20.9689 26.2282 20.9711 25.9268C20.973 25.6478 20.921 25.4983 20.9195 25.2567C21.384 25.5653 21.1946 25.8452 21.3994 26.1245L21.7373 25.8255C21.7439 25.834 21.7746 25.8738 21.7832 25.8856L22.0629 26.2749C22.2454 26.2241 22.06 26.2814 22.2376 26.1423C22.454 26.3582 22.6143 26.3439 22.8078 26.5069L23.7094 27.4584C23.8695 27.6458 23.7397 27.5836 23.847 27.7844C23.9631 28.0017 24.0168 27.8247 23.9887 28.1313L23.9885 28.1309ZM14.2326 21.6448C14.2316 21.6355 14.2307 21.6262 14.2298 21.6169C14.2307 21.6262 14.2317 21.6355 14.2326 21.6448ZM14.2265 21.5784C14.2258 21.5692 14.225 21.5601 14.2244 21.551C14.2251 21.5601 14.2258 21.5692 14.2265 21.5784ZM14.2218 21.511C14.2213 21.5024 14.2208 21.494 14.2205 21.4854C14.2208 21.494 14.2215 21.5024 14.2218 21.511ZM14.2187 21.4413C14.2186 21.434 14.2182 21.427 14.218 21.4197C14.218 21.427 14.2186 21.434 14.2187 21.4413ZM14.2123 15.3177C14.2123 15.3177 14.2128 15.3172 14.2132 15.317C14.2128 15.3172 14.2127 15.3175 14.2123 15.3177ZM14.2307 15.3055C14.2293 15.3064 14.2277 15.307 14.2264 15.3079C14.2277 15.307 14.2291 15.3062 14.2307 15.3055ZM14.204 16.5314C14.204 16.5391 14.2037 16.5469 14.2035 16.5546C14.2035 16.5469 14.2038 16.5391 14.204 16.5314ZM14.2028 16.5872C14.2028 16.5949 14.2024 16.6025 14.2023 16.6102C14.2024 16.6025 14.2026 16.5949 14.2028 16.5872ZM14.2016 16.6421C14.2014 16.6502 14.2012 16.6581 14.2011 16.6662C14.2012 16.6581 14.2014 16.65 14.2016 16.6421ZM14.2002 16.7003C14.2002 16.7069 14.1998 16.7132 14.1997 16.7198C14.1997 16.7132 14.2 16.7069 14.2002 16.7003ZM14.1988 16.7561C14.1986 16.7632 14.1985 16.7702 14.1983 16.7775C14.1985 16.7704 14.1986 16.7632 14.1988 16.7561ZM14.1974 16.8124C14.1974 16.8186 14.1971 16.8248 14.1969 16.8309C14.1969 16.8247 14.1972 16.8185 14.1974 16.8124ZM14.1959 16.8715C14.1959 16.8767 14.1955 16.882 14.1955 16.8872L14.1959 16.8715ZM14.1929 16.9862C14.1929 16.9891 14.1929 16.9921 14.1927 16.9952C14.1927 16.9922 14.1927 16.9893 14.1929 16.9862ZM14.1881 17.177C14.1881 17.1836 14.1877 17.1901 14.1875 17.1967C14.1875 17.1901 14.1879 17.1836 14.1881 17.177ZM14.1867 17.2323C14.1867 17.239 14.1863 17.2457 14.1862 17.2523C14.1862 17.2456 14.1865 17.2389 14.1867 17.2323ZM14.1839 17.3405C14.1837 17.3487 14.1836 17.357 14.1832 17.3653C14.1834 17.357 14.1836 17.3487 14.1839 17.3405ZM14.1825 17.3963C14.1823 17.4038 14.1822 17.4116 14.182 17.4192C14.1822 17.4116 14.1823 17.404 14.1825 17.3963ZM14.1813 17.4502C14.1811 17.4583 14.181 17.4662 14.1808 17.4743C14.181 17.4664 14.1811 17.4583 14.1813 17.4502ZM14.1801 17.5046C14.1799 17.5125 14.1797 17.5203 14.1796 17.5282C14.1796 17.5203 14.1799 17.5125 14.1801 17.5046ZM14.1789 17.558C14.1789 17.5659 14.1785 17.5737 14.1784 17.5816C14.1784 17.5738 14.1787 17.5659 14.1789 17.558ZM14.2555 21.8167C14.2568 21.8253 14.2582 21.8341 14.2596 21.8427C14.2581 21.8341 14.2568 21.8253 14.2555 21.8167ZM14.2367 21.6827C14.2378 21.692 14.239 21.7013 14.2402 21.7106C14.239 21.7013 14.238 21.692 14.2367 21.6827ZM14.2452 21.7494C14.2465 21.7585 14.2478 21.7676 14.2492 21.7769C14.2478 21.7678 14.2466 21.7587 14.2452 21.7494ZM14.5675 22.8137C14.5634 22.8048 14.5594 22.7958 14.5552 22.7868C14.5592 22.7958 14.5634 22.8048 14.5675 22.8137ZM14.5379 22.7476C14.5343 22.7391 14.5305 22.7309 14.5268 22.7224C14.5305 22.7309 14.5341 22.7391 14.5379 22.7476ZM14.5081 22.6778C14.5053 22.6711 14.5024 22.6646 14.4996 22.6578C14.5024 22.6646 14.5052 22.6711 14.5081 22.6778ZM14.4487 22.5283C14.4457 22.5206 14.4429 22.5128 14.44 22.5049C14.4429 22.5127 14.4457 22.5204 14.4487 22.5283ZM14.4248 22.4632C14.4216 22.4545 14.4185 22.4457 14.4154 22.4367C14.4185 22.4455 14.4215 22.4543 14.4248 22.4632ZM14.4019 22.3978C14.3988 22.3887 14.3956 22.3794 14.3927 22.3702C14.3958 22.3794 14.3988 22.3887 14.4019 22.3978ZM14.3802 22.332C14.3773 22.3227 14.3743 22.3134 14.3714 22.3039C14.3743 22.3132 14.3773 22.3225 14.3802 22.332ZM14.322 22.1319C14.3197 22.1233 14.3175 22.1148 14.3152 22.1062C14.3173 22.1148 14.3197 22.1233 14.322 22.1319ZM14.2846 21.9745C14.2841 21.9722 14.2837 21.97 14.2832 21.9676C14.2837 21.9698 14.2841 21.9721 14.2846 21.9745ZM14.7609 23.194C14.7581 23.189 14.7554 23.184 14.7526 23.1788C14.7554 23.1838 14.7581 23.1888 14.7609 23.194ZM14.7266 23.1318C14.7223 23.1239 14.7181 23.116 14.7139 23.1082C14.7181 23.1161 14.7224 23.1241 14.7266 23.1318ZM14.6602 23.0061C14.6556 22.9971 14.6511 22.988 14.6465 22.979C14.6511 22.9882 14.6556 22.9971 14.6602 23.0061ZM14.5973 22.8785C14.593 22.8693 14.5887 22.8602 14.5843 22.8509C14.5887 22.86 14.593 22.8693 14.5973 22.8785ZM12.9751 29.2595C12.9687 29.2736 12.9597 29.2907 12.9478 29.311C12.9597 29.2907 12.9687 29.2738 12.9751 29.2595ZM12.6007 29.7216C12.6125 29.7276 12.6229 29.7317 12.6322 29.7336C12.6338 29.734 12.6355 29.7341 12.6372 29.7345C12.6355 29.7343 12.6339 29.7341 12.6322 29.7336C12.623 29.7317 12.6125 29.7278 12.6007 29.7216ZM12.6693 29.7324C12.6766 29.7305 12.6835 29.7278 12.6901 29.7236C12.6835 29.7276 12.6766 29.7305 12.6693 29.7324ZM13.1385 29.9764C13.115 29.9921 13.0902 30.0007 13.064 30.0023C13.0902 30.0007 13.1151 29.9921 13.1385 29.9764ZM13.1976 29.912C13.2134 29.885 13.2229 29.8566 13.2267 29.8268C13.2281 29.8156 13.2283 29.8046 13.2279 29.7937C13.2283 29.8046 13.2279 29.8156 13.2267 29.8268C13.2229 29.8566 13.2134 29.8852 13.1976 29.912C13.1896 29.9256 13.1806 29.9377 13.1708 29.9485C13.1806 29.9379 13.1895 29.9256 13.1976 29.912ZM13.3934 30.1397C13.3981 30.1223 13.4083 30.0977 13.4244 30.0658C13.4083 30.0977 13.3979 30.1223 13.3934 30.1397ZM13.7341 30.2463C13.7178 30.2785 13.7041 30.3013 13.6928 30.3145C13.7041 30.3013 13.7176 30.2784 13.7341 30.2463ZM13.6 30.3405C13.5916 30.3378 13.5826 30.334 13.5728 30.3288C13.5826 30.334 13.5916 30.3376 13.6 30.3405ZM14.003 29.9566C14.0098 29.9434 14.016 29.9322 14.0217 29.922C14.0158 29.932 14.0096 29.9434 14.003 29.9566ZM13.9715 30.5162C13.967 30.5172 13.9623 30.5179 13.9576 30.5181C13.9623 30.5181 13.9668 30.5172 13.9715 30.5162ZM14.3438 30.0543C14.3345 30.0703 14.3249 30.0893 14.3149 30.1113C14.3248 30.0893 14.3345 30.0703 14.3438 30.0543ZM14.2912 30.6855C14.2849 30.6869 14.2789 30.6874 14.2726 30.687C14.2789 30.6874 14.2851 30.6869 14.2912 30.6855ZM14.3993 30.7427C14.4062 30.7496 14.4154 30.7561 14.4267 30.7626C14.4154 30.7561 14.4062 30.7494 14.3993 30.7427ZM18.57 31.1009C18.5799 31.1154 18.588 31.1334 18.5946 31.1548C18.588 31.1333 18.5799 31.1152 18.57 31.1009C18.5633 31.0911 18.5549 31.0825 18.5456 31.0745C18.5548 31.0825 18.5633 31.0911 18.57 31.1009ZM22.4103 30.9278C22.4095 30.9221 22.4077 30.9154 22.4058 30.908C22.4077 30.9152 22.4095 30.9221 22.4103 30.9278ZM22.3977 30.9948C22.4013 30.9889 22.4043 30.9829 22.4067 30.9764C22.4044 30.9829 22.4013 30.9891 22.3977 30.9948C22.3868 31.0122 22.3696 31.026 22.3466 31.0365C22.3696 31.0261 22.3866 31.0122 22.3977 30.9948ZM22.9371 30.0224C22.9283 30.02 22.9192 30.0193 22.9102 30.0202C22.9192 30.0192 22.9283 30.02 22.9371 30.0224ZM23.3432 30.5257C23.3543 30.5313 23.3658 30.5343 23.3777 30.5343C23.3658 30.5343 23.3542 30.5313 23.3432 30.5257ZM23.533 30.3872C23.5283 30.37 23.5177 30.3455 23.5013 30.3135C23.5179 30.3455 23.5283 30.37 23.533 30.3872ZM23.9417 30.1208C23.9468 30.123 23.9518 30.1247 23.9566 30.1266C23.9516 30.1247 23.9468 30.1228 23.9417 30.1208ZM24.6244 29.7708C24.6196 29.7703 24.6146 29.7691 24.6094 29.7677C24.6146 29.7693 24.6196 29.7703 24.6244 29.7708ZM23.8924 29.1301C24.0081 29.0428 24.0487 28.9152 24.1512 28.8596C24.0487 28.9152 24.0081 29.043 23.8924 29.1301ZM25.2687 29.7954C25.2158 29.6616 25.0173 29.3843 24.7915 29.1624C25.0171 29.3843 25.2157 29.6616 25.2687 29.7954ZM23.4029 24.7254C23.4037 24.7268 23.4048 24.7283 23.4056 24.7297C23.4046 24.7283 23.4037 24.7268 23.4029 24.7254ZM23.4107 24.7369C23.4131 24.7404 23.4153 24.7438 23.4179 24.7471C23.4155 24.7436 23.4131 24.7402 23.4107 24.7369ZM23.4223 24.7529C23.4245 24.7559 23.4268 24.759 23.429 24.7619C23.4268 24.759 23.4243 24.7559 23.4223 24.7529ZM23.4339 24.7681C23.4366 24.7717 23.4396 24.7752 23.4427 24.7788C23.4398 24.7752 23.4368 24.7717 23.4339 24.7681ZM23.4467 24.7834C23.4503 24.7876 23.454 24.7917 23.458 24.7958C23.4541 24.7917 23.4503 24.7876 23.4467 24.7834ZM23.6378 24.9219C23.629 24.9178 23.6203 24.9136 23.6122 24.9093C23.6205 24.9136 23.629 24.9178 23.6378 24.9219ZM23.5798 24.8917C23.5727 24.8876 23.5657 24.8833 23.559 24.8792C23.5657 24.8835 23.5727 24.8876 23.5798 24.8917ZM23.556 24.8773C23.5491 24.8728 23.5427 24.8683 23.5363 24.8638C23.5427 24.8683 23.5493 24.8728 23.556 24.8773ZM23.5318 24.8607C23.5257 24.8564 23.5198 24.852 23.5143 24.8477C23.5198 24.8521 23.5257 24.8564 23.5318 24.8607ZM23.4912 24.8284C23.4867 24.8244 23.4824 24.8203 23.4781 24.8163C23.4822 24.8203 23.4867 24.8244 23.4912 24.8284ZM23.6428 24.9241C23.6522 24.9284 23.6619 24.9326 23.672 24.9369C23.6619 24.9327 23.6522 24.9284 23.6428 24.9241ZM23.674 24.9376C23.6839 24.9415 23.6941 24.9457 23.7049 24.9494C23.6943 24.9455 23.6839 24.9415 23.674 24.9376ZM23.7096 24.9513C23.7203 24.9553 23.7314 24.9591 23.743 24.9629C23.7316 24.9591 23.7203 24.9553 23.7096 24.9513ZM23.7496 24.9649C23.7612 24.9687 23.7731 24.9723 23.7854 24.976C23.773 24.9723 23.761 24.9687 23.7496 24.9649Z"
                                      fill="#50CD89"
                                    />
                                    <path
                                      d="M16.0898 32.8379C15.6781 33.1112 15.2617 33.2912 14.754 33.3021C14.8332 33.094 15.126 32.9538 15.2163 32.5801C15.0073 32.6368 14.767 32.9917 13.8805 32.9926C13.9113 32.6356 14.466 31.7934 14.5998 31.3671C13.7609 30.9688 13.0302 30.6869 12.2382 30.1566C12.0887 30.2871 11.8313 30.3767 11.6262 30.2541C11.487 30.1709 11.4973 30.122 11.4035 30.0646C10.9426 29.7822 11.2299 29.9045 10.9365 29.7598C10.5922 29.5902 10.6184 29.3012 10.6953 28.9658L10.3358 28.6097C10.0154 28.8226 9.94177 29.0735 9.46249 29.0738C9.06776 28.9548 8.56648 27.2658 7.20557 26.6982C6.95709 26.5945 7.10317 26.6997 7.04789 26.5472C7.09502 26.5051 7.01895 26.533 7.16918 26.4626L7.60826 26.336C7.8706 26.2823 7.99727 26.2892 8.28092 26.2892C8.21456 25.5412 7.78015 25.2947 7.80095 25.0855C7.9685 25.0428 8.05895 25.1606 8.21923 25.2682C8.34261 25.3511 8.47014 25.4306 8.58987 25.515C8.8607 25.7057 9.01544 25.8662 9.24416 26.0958C9.63853 26.4915 10.2701 27.3473 10.3916 27.4279C10.7595 27.1475 10.8603 27.037 11.3028 27.3294C11.3983 27.3924 11.9291 27.8612 11.9819 27.9391C12.7277 27.5507 12.8114 27.0418 13.1255 26.4077C13.2229 26.2111 13.3621 26.0703 13.483 25.8522L13.1877 25.7641L13.5209 25.2575C13.3652 25.2203 13.2149 25.1902 13.1056 25.0557L13.1935 24.9808C13.2016 24.9739 13.2144 24.9646 13.2227 24.9575C13.2536 24.9312 13.3054 24.8869 13.3305 24.8597C13.4173 24.7657 13.4123 24.7533 13.4674 24.6251L13.0586 24.6902L13.8748 23.8352L13.6663 23.762C14.0158 23.3076 13.9703 23.2563 14.1889 22.7822C13.9441 22.8411 13.7481 22.999 13.5151 23.0856C13.2818 23.1724 13.0455 23.2443 12.7982 23.2944C11.2706 23.6046 10.9381 23.0817 10.4865 22.992C10.1772 22.9305 10.0998 22.9007 9.83191 22.7209C9.69 22.6258 9.69745 22.6134 9.57979 22.5099C9.40583 22.3566 9.30983 22.4532 9.0319 22.1317C8.75015 21.8059 8.44224 21.8434 8.27416 21.4485C8.12705 21.1032 8.02343 21.279 7.80753 20.9887C7.6495 20.776 7.67082 20.5936 7.47311 20.3962C7.26258 20.1859 7.18478 20.152 7.0893 19.8534C7.00353 19.5851 6.8436 19.5787 6.72231 19.2935L6.28011 17.8811C6.15777 17.5959 6.0798 17.6057 5.99663 17.2349C5.8736 16.6874 6.1531 17.3711 5.89751 16.4602C5.73775 15.8905 5.8762 15.8972 5.81746 15.7164C5.72805 15.4412 5.61092 15.315 5.67035 14.9545C5.75595 14.4344 5.76427 14.7551 5.65614 14.2274C5.48581 13.3962 5.8237 13.3993 5.73689 13.0163C5.65562 12.6576 5.55304 12.2339 5.72874 11.8672C5.88556 11.54 5.78974 11.3891 5.81434 11.0251C5.83756 10.6818 6.01465 10.5492 6.02297 10.2547C6.0318 9.93645 6.02799 9.70877 6.12814 9.43201C6.26313 9.05915 6.33105 9.19934 6.3281 8.70454C6.32672 8.45551 6.38996 8.1195 6.45148 7.90009C6.55007 7.54824 6.59685 7.57786 6.82991 7.35173C6.98517 7.20121 7.02866 5.91436 7.71587 5.45642C7.71587 5.85822 7.6651 6.14324 7.66441 6.53936C7.66302 7.33227 7.86904 8.64702 8.24921 9.30405C8.85048 10.3431 9.122 10.4078 9.46162 10.8716C10.1461 11.8063 13.0285 12.5852 13.4584 12.9963C14.0193 13.5326 14.1905 14.566 15.0392 14.7614C15.3031 14.8222 15.7488 14.7676 15.9355 14.5921C15.9409 14.4211 15.9794 14.432 16.044 14.1225L16.141 13.7421L15.9868 13.4491C16.314 13.4784 16.5094 13.55 16.7531 13.2562C16.5197 13.2304 16.3282 13.2157 16.2438 12.9851C16.4658 12.985 16.6792 12.9514 16.8515 12.8127C16.7146 12.7487 16.5001 12.7461 16.4625 12.5343C16.545 12.4741 16.853 12.414 17.01 12.3532C16.8756 12.2795 16.7557 12.2408 16.7061 12.057C17.0384 12.05 17.3765 11.9487 17.4056 11.5769C17.4365 11.183 16.9802 11.2803 16.7414 11.3707C15.9794 11.6594 15.3857 11.3776 15.4339 10.8267L15.5694 10.8711L15.4732 10.5618C15.7013 10.6243 15.856 10.8043 16.1303 10.7612C16.3368 10.7288 16.569 10.6031 16.6548 10.4164C14.939 10.2158 15.056 10.9657 14.6512 11.0774C14.6512 10.5968 14.6327 10.2566 14.9969 9.92904C15.3225 9.63609 15.7068 9.52931 15.8709 9.38895C15.6652 9.23912 15.5956 9.36432 15.3792 9.36691C15.4202 9.1177 15.6881 9.07637 15.8796 8.977L15.52 8.86453L15.6822 8.76017C15.75 8.73365 15.8193 8.72314 15.8884 8.71005C16.088 8.64426 16.1994 8.71263 16.0473 8.53542C16.2894 8.53852 16.1686 8.51527 16.3332 8.6496C16.4141 8.44225 16.5496 8.24643 16.7574 8.18994C16.7581 8.52887 16.6794 8.48392 16.7574 8.80873C17.0927 8.58605 17.0282 8.50666 17.4952 8.41486C17.7932 8.35613 18.2058 8.44844 18.5555 8.44793C20.1356 8.44466 19.6178 8.10676 19.9559 7.63607L20.041 7.88407C20.0521 7.95227 20.0827 8.10676 20.0879 8.15136C20.1094 8.33788 20.0387 8.50752 19.9425 8.65408C20.2404 8.57176 20.0876 8.31411 20.3535 8.24143C20.3541 8.55695 20.3123 8.71126 20.148 8.96356L20.4048 8.86023C20.34 9.0979 20.1694 9.2758 20.0027 9.44527C20.1103 9.65986 20.2232 9.87014 20.247 10.1016C20.2783 10.4075 20.2809 11.3439 20.5769 11.5753C20.7346 11.6988 21.0787 11.7386 21.265 11.6492C21.2709 11.9571 20.8741 12.1068 20.4561 12.0059C20.5409 12.3198 20.8787 12.3674 21.1754 12.3669C21.1066 12.6217 20.8384 12.6226 20.6573 12.7234C20.7803 12.8963 21.0548 12.9808 21.2781 12.9857C21.2106 13.2326 21.0142 13.1655 20.807 13.295C20.9945 13.5223 21.2433 13.4496 21.5351 13.4496C21.4795 13.6558 21.4284 13.581 21.3296 13.7913C21.3298 13.9868 21.4457 14.314 21.4797 14.484C21.4918 14.5448 21.4966 14.6665 21.509 14.7387C21.9018 14.7456 22.0711 14.8799 22.4795 14.6552C23.0565 14.3376 23.3076 13.2838 23.9277 12.8603C24.8618 12.2224 27.5284 12.1182 29.0016 9.18694C29.2734 8.64581 29.3755 8.09074 29.4782 7.49967L29.5514 6.48752C29.55 6.24727 29.5042 6.18199 29.4961 5.97447C29.4895 5.81103 29.498 5.62365 29.498 5.45694C29.7215 5.60574 29.9376 6.01769 30.0468 6.24692C30.1254 6.41208 30.1781 6.5738 30.2145 6.74895C30.3077 7.19914 30.2155 7.21636 30.4306 7.40856C31.0485 7.96123 30.7248 8.71281 30.9876 9.22121C31.115 9.46783 31.1228 9.57048 31.1734 9.85998C31.2791 10.4657 31.0388 10.1459 31.2616 10.5423C31.4895 10.9476 31.3534 11.4184 31.4077 11.6874C31.4279 11.7889 31.4974 11.8922 31.5238 11.9833C31.7175 12.6562 31.3701 12.7201 31.542 13.4605C31.6232 13.8101 31.6068 13.8824 31.5536 14.2236C31.4624 14.8085 31.3865 14.3068 31.5345 14.9121V14.9116C31.6478 15.3749 31.3553 15.5492 31.3874 15.9346C31.4153 16.2691 31.1788 16.7129 31.2042 16.9444C31.2349 17.224 31.2165 17.346 31.0745 17.6097C30.8918 17.9489 30.9362 17.8189 30.8452 18.2045C30.7773 18.4921 30.6555 18.6234 30.5971 18.8321C30.5245 19.0921 30.5756 19.242 30.3826 19.4933C30.2258 19.6975 30.183 19.7373 30.1731 19.7428M16.0898 32.8379L16.1029 32.7907L16.1409 32.8205L16.0898 32.8379ZM16.0898 32.8379L15.9225 33.2969C16.2707 33.3021 16.4841 33.2588 16.7759 33.1142C17.0819 32.9624 17.144 32.8362 17.3741 32.6833M17.3741 32.6833L17.3872 32.6361L17.4252 32.6659L17.3741 32.6833ZM17.3741 32.6833C17.2431 33.2358 16.9632 33.42 16.9118 33.6114C17.6926 33.6114 18.1561 33.4357 18.5208 32.8543L18.6071 32.7348L18.731 32.9197C18.7535 32.9568 18.8268 33.0734 18.8532 33.1066C19.1553 33.4869 19.8483 33.6114 20.3024 33.6114C20.2534 33.4299 20.1508 33.4113 20.0446 33.1998C19.9448 33.0009 19.8897 32.8927 19.84 32.6833C20.3466 33.0198 20.3624 33.3021 21.2785 33.3021L21.1245 32.8379M21.1245 32.8379L21.0775 32.8247L21.1071 32.7866L21.1245 32.8379ZM21.1245 32.8379C21.5466 33.115 21.9515 33.2566 22.4602 33.3021C22.4081 33.1119 22.0943 32.9798 21.9979 32.5801C22.3772 32.6831 22.1016 32.8825 23.3337 32.9926C23.3036 32.645 22.7411 31.7882 22.6144 31.3627C23.4349 31.0074 24.2268 30.6628 24.9753 30.1564L25.4371 30.3361C25.5466 30.2386 25.7017 30.1147 25.8005 30.0541C25.9673 29.9518 26.0314 29.8724 26.159 29.7951C26.6499 29.4972 26.5634 29.5123 26.5189 28.9574L26.871 28.6529C27.2324 28.8394 27.297 29.0731 27.7519 29.0737C28.1322 28.959 28.6202 27.2772 30.0086 26.698C30.2573 26.5943 30.111 26.6996 30.1665 26.547C30.1294 26.5139 30.1474 26.5137 30.0802 26.479C29.7643 26.3157 29.2738 26.2892 28.9335 26.2892C28.9473 25.6349 29.4257 25.2732 29.4134 25.0855C29.1395 25.0156 28.1626 25.9027 27.9959 26.0699L26.8226 27.4279C26.4795 27.1666 26.3662 27.0361 25.9424 27.3091C25.7889 27.4079 25.3032 27.8078 25.2621 27.9392C24.6669 27.7109 24.3489 26.9889 24.1119 26.4362C24.0336 26.2537 23.8626 26.0432 23.7359 25.8767L24.01 25.7995C23.9379 25.5272 23.8227 25.4544 23.6933 25.2579L24.0992 25.1105C24.0117 24.9527 23.8594 24.8425 23.7491 24.6524L24.1498 24.687L23.3426 23.8477L23.5531 23.7849C23.2367 23.3536 23.2249 23.2158 23.0253 22.7827C23.175 22.8189 23.4197 22.9711 23.5903 23.0407C23.8003 23.1263 24.0159 23.1991 24.2477 23.2575C24.8885 23.4189 25.7367 23.4866 26.3541 23.1328C26.7396 22.9119 27.0446 23.0402 27.5331 22.6146C27.9747 22.2297 27.795 22.5035 28.0485 22.2554C28.2591 22.0492 28.2452 22.0391 28.5018 21.8854C28.724 21.7525 28.8233 21.665 28.9329 21.4414C29.0908 21.1199 29.1393 21.2861 29.3594 21.0445C29.5318 20.8552 29.546 20.6299 29.6645 20.4742C29.7957 20.3022 29.9385 20.2593 30.0483 20.0344C30.1629 19.8005 30.1746 19.7511 30.1731 19.7428M30.1731 19.7428C30.1675 19.7459 30.1722 19.7383 30.1731 19.7428ZM24.2796 30.0474L24.1583 30.1294M13.4468 30.257L13.4418 30.2668M18.4773 12.5954C18.4789 12.5904 18.4803 12.5854 18.4817 12.5802M18.4837 12.5721C18.4856 12.5644 18.4874 12.5565 18.4889 12.5482M18.4948 12.511C18.4957 12.505 18.4964 12.4989 18.4971 12.4927M24.4678 29.8876C24.469 29.885 24.4699 29.8826 24.4708 29.88M24.4678 29.8876C24.4666 29.8903 24.4647 29.8934 24.4628 29.8964C24.4649 29.8933 24.4666 29.8903 24.4678 29.8876ZM24.2857 29.6733L24.0606 29.5003L24.1145 29.7892L24.2079 29.726M24.1065 30.133L24.1102 30.1402M24.1112 30.139C24.114 30.1349 24.1167 30.1308 24.1188 30.1263M24.1188 30.1263C24.1235 30.1168 24.1268 30.1054 24.1291 30.0925C24.1268 30.1054 24.1233 30.1168 24.1188 30.1263ZM24.0963 30.1562C24.0972 30.1554 24.098 30.1545 24.0989 30.1537M24.1301 30.0059C24.1271 29.9809 24.1213 29.9444 24.1126 29.8962C24.1214 29.9442 24.1271 29.9809 24.1301 30.0059ZM24.1301 30.0059C24.1323 30.0248 24.1332 30.0417 24.1327 30.0567C24.133 30.0417 24.1322 30.0248 24.1299 30.0059H24.1301ZM24.0159 29.369L24.0402 29.3527M24.0688 30.1449C24.058 30.1466 24.0445 30.1468 24.0284 30.1456M23.5363 30.4036C23.5378 30.4154 23.5371 30.4268 23.5342 30.4378C23.5325 30.4451 23.5297 30.452 23.5264 30.4583M23.1192 30.0777L23.2762 30.4309M23.2762 30.4309C23.2784 30.4359 23.2805 30.4406 23.2828 30.4452C23.2807 30.4406 23.2784 30.4359 23.2762 30.4309ZM20.3925 31.5018C20.4029 31.5127 20.4135 31.5218 20.4242 31.5301M20.3198 30.9858C20.2919 31.0506 20.2785 31.1193 20.2799 31.1918C20.2785 31.1191 20.2919 31.0506 20.3198 30.9858ZM20.3198 30.9858C20.3296 30.9633 20.3406 30.944 20.3523 30.9273M20.5738 31.5673C20.5715 31.5678 20.5693 31.5685 20.567 31.5688C20.5246 31.5762 20.4844 31.5681 20.4464 31.5454M20.4818 30.8474C20.4625 30.8508 20.4449 30.856 20.4288 30.8631C20.4447 30.8558 20.4624 30.8507 20.4818 30.8474ZM20.4818 30.8474C20.4884 30.8462 20.4949 30.8455 20.5014 30.8451C20.4949 30.8457 20.4884 30.8463 20.4818 30.8474ZM20.5691 31.3041C20.5792 31.3024 20.5885 31.3014 20.5973 31.3008M20.7308 31.0411C20.7223 31.0227 20.7134 31.0055 20.7046 30.9896C20.7136 31.0055 20.7223 31.0227 20.7308 31.0411ZM20.7308 31.0411L20.7419 31.0382M20.6436 30.8519C20.6512 30.8538 20.658 30.8541 20.6639 30.8531C20.6705 30.8519 20.6758 30.8481 20.68 30.8414M20.5377 30.829C20.5215 30.8281 20.5045 30.8286 20.4866 30.8305C20.5043 30.8286 20.5215 30.8281 20.5377 30.829ZM20.5377 30.829C20.5435 30.8293 20.5494 30.8298 20.5554 30.8307C20.5494 30.83 20.5435 30.8293 20.5377 30.829ZM20.1744 31.1102C20.1664 31.146 20.1628 31.1827 20.1635 31.2206C20.1628 31.1829 20.1664 31.146 20.1744 31.1102ZM20.1744 31.1102C20.1777 31.0959 20.1815 31.0821 20.1858 31.0687C20.1813 31.0819 20.1775 31.0959 20.1744 31.1102ZM20.2059 31.4154C20.2148 31.4347 20.2246 31.4522 20.2355 31.4682M20.2059 31.4154C20.1971 31.3963 20.1896 31.3761 20.1836 31.3551C20.1896 31.3761 20.1971 31.3961 20.2059 31.4154ZM20.5568 31.5872C20.5986 31.5802 20.6374 31.5678 20.6731 31.55C20.6372 31.5678 20.5986 31.58 20.5568 31.5872ZM20.5568 31.5872C20.5353 31.591 20.5143 31.5931 20.4941 31.5934C20.5143 31.5929 20.5353 31.5909 20.5568 31.5872ZM20.8055 31.4009C20.8072 31.4136 20.8108 31.4329 20.8162 31.4593L20.819 31.4713M20.8009 31.3077C20.8044 31.2929 20.8115 31.2816 20.8223 31.2738M21.3726 31.3518C21.391 31.3344 21.4045 31.3141 21.4131 31.291C21.422 31.2669 21.4247 31.2414 21.4214 31.2149M20.9902 30.876C20.972 30.9559 20.9742 31.0385 20.9969 31.124M21.2837 30.7017C21.313 30.7194 21.3419 30.7466 21.3702 30.7831C21.3417 30.7466 21.313 30.7194 21.2837 30.7017ZM21.2837 30.7017C21.2615 30.6884 21.239 30.6803 21.2158 30.6772C21.239 30.6802 21.2615 30.6882 21.2837 30.7017ZM21.1446 30.6838C21.1627 30.6784 21.1808 30.6757 21.1983 30.676C21.1806 30.6757 21.1627 30.6783 21.1446 30.6838ZM21.1446 30.6838C21.1303 30.6881 21.1175 30.6938 21.1056 30.6998C21.1177 30.6936 21.1303 30.6881 21.1446 30.6838ZM21.1281 31.3446C21.1723 31.3809 21.2172 31.3981 21.2627 31.3968M21.1281 31.3446C21.1116 31.3312 21.0966 31.3155 21.0823 31.2983C21.0966 31.3157 21.1116 31.3312 21.1281 31.3446ZM21.4237 30.841L21.3584 30.6199L21.3462 30.6237C21.3456 30.6479 21.3388 30.6619 21.3261 30.6659C21.3204 30.6674 21.3138 30.6679 21.3059 30.6671L21.2743 30.6617C21.2669 30.6607 21.2598 30.6598 21.2527 30.6591M21.1258 30.6721C21.1009 30.6796 21.0775 30.6896 21.0553 30.7017M21.1258 30.6721C21.1385 30.6681 21.151 30.665 21.1629 30.6628C21.1508 30.665 21.1385 30.6683 21.1258 30.6721ZM21.2794 31.4149C21.2312 31.4271 21.1851 31.4304 21.1411 31.4245M21.4951 31.2814C21.4994 31.2759 21.5036 31.2714 21.5076 31.2681M21.4951 31.2814C21.484 31.2957 21.4715 31.3093 21.4575 31.322C21.4714 31.3093 21.484 31.2957 21.4951 31.2814ZM21.5471 31.2605L21.5429 31.2492M21.5429 31.2492C21.5386 31.2354 21.5349 31.2239 21.532 31.214C21.5349 31.2239 21.5386 31.2356 21.5429 31.2492ZM19.5797 30.5989C18.0431 30.7687 16.7827 30.5152 15.8155 30.1824M19.5797 30.5989C20.5145 30.4955 21.2769 30.2556 21.8811 30.0047M19.5797 30.5989C20.5145 30.4957 21.2769 30.2556 21.8811 30.0047M21.8811 30.0047C22.0106 29.951 22.1329 29.8965 22.248 29.843M21.8811 30.0047C22.0106 29.9508 22.1329 29.8965 22.248 29.843M22.248 29.843C22.3055 29.8161 22.3613 29.7896 22.4154 29.7632M20.0727 30.9201C20.0597 30.9218 20.0482 30.9254 20.0378 30.93M19.8448 30.9376L20.0711 30.9082L20.072 30.9149M19.9867 31.0863C19.9829 31.0528 19.9817 31.0277 19.9831 31.0098M19.9665 31.0895L20.0094 31.4696M19.4847 31.6925C19.4865 31.6914 19.4882 31.6902 19.4899 31.6892C19.4882 31.6904 19.4865 31.6914 19.4847 31.6925ZM19.4847 31.6925C19.4737 31.6985 19.4588 31.7032 19.4402 31.7068M19.4946 31.0795L20.0271 31.6429L20.0493 31.6399M19.0386 31.756C19.0978 31.7476 19.1456 31.7266 19.1817 31.693C19.1955 31.6802 19.2063 31.6665 19.2141 31.6518M18.6184 31.2156H18.6189L18.6178 31.0317M18.1956 31.6387C18.1959 31.6372 18.1963 31.6353 18.1966 31.6336M18.1956 31.6387C18.1923 31.6515 18.1871 31.6627 18.1802 31.672C18.1871 31.6627 18.1921 31.6515 18.1956 31.6387ZM18.2046 31.5583C18.2042 31.5681 18.2037 31.5771 18.203 31.5855M18.0457 31.0318C18.0334 31.0367 18.0223 31.0432 18.0119 31.0518C18.0221 31.0434 18.0334 31.0367 18.0457 31.0318ZM18.0457 31.0318C18.0639 31.0248 18.089 31.0203 18.1207 31.0181C18.089 31.0203 18.0641 31.0248 18.0457 31.0318ZM18.3638 31.7119C18.3524 31.7066 18.3422 31.6988 18.3335 31.6882M18.3638 31.7119C18.3524 31.7068 18.3422 31.6988 18.3335 31.6882M18.3638 31.7119C18.3753 31.7171 18.3903 31.7205 18.4091 31.7224M18.3335 31.6882C18.3287 31.6823 18.3247 31.6756 18.3214 31.6682C18.3245 31.6756 18.3287 31.6821 18.3335 31.6882ZM17.9495 30.9881L18.6094 31.0191M18.714 31.507C18.714 31.5321 18.7145 31.5526 18.7152 31.5681C18.7144 31.5526 18.714 31.5323 18.714 31.507ZM18.714 31.507L18.7135 31.1849C18.7135 31.1672 18.713 31.1519 18.7121 31.1386M18.708 31.1043C18.7097 31.1129 18.7111 31.1236 18.7119 31.1367C18.7111 31.1236 18.7097 31.1128 18.708 31.1043ZM18.708 31.1043C18.7066 31.0978 18.7047 31.0919 18.7022 31.0863M18.6468 31.0365C18.6457 31.0361 18.6445 31.036 18.6435 31.0356M18.848 31.6634C18.8582 31.6813 18.87 31.6957 18.8831 31.7073C18.87 31.6957 18.858 31.6813 18.848 31.6634ZM18.848 31.6634C18.8412 31.6518 18.836 31.6394 18.8322 31.6265M18.8575 31.0516C18.8615 31.0484 18.8656 31.0453 18.8701 31.0429M19.1089 31.0299V31.0181M19.2392 31.1038C19.2422 31.0907 19.2467 31.0794 19.2531 31.0697M19.2392 31.1038C19.2378 31.1104 19.2366 31.1186 19.2357 31.1279C19.2366 31.1188 19.2377 31.1104 19.2392 31.1038ZM14.0593 30.4149L14.218 30.0627M14.218 30.0627C14.2276 30.0414 14.2347 30.0238 14.2395 30.009C14.2345 30.0238 14.2276 30.0414 14.218 30.0627ZM13.9401 29.8295C13.9424 29.8209 13.9436 29.8125 13.9436 29.8044M13.1139 29.2461L13.1531 29.2726M13.1139 29.2461L12.9569 29.5142L13.1139 29.2459V29.2461ZM13.1531 29.2726C13.1832 29.2927 13.2044 29.3096 13.2172 29.323C13.2045 29.3096 13.1832 29.2926 13.1531 29.2726ZM14.1716 18.1723C14.1716 18.1658 14.1716 18.159 14.1716 18.1525M14.1714 18.1277C14.1714 18.1213 14.1714 18.1148 14.1714 18.1084M14.1716 17.9889C14.1716 17.9818 14.1716 17.9748 14.1716 17.9677M14.1747 17.7409C14.1747 17.7328 14.1751 17.7247 14.1751 17.7166M14.2106 15.925C14.2106 15.9172 14.2106 15.9095 14.2106 15.9017M14.2106 15.8766C14.2106 15.869 14.2106 15.8614 14.2106 15.8538M14.2066 15.604C14.2064 15.5978 14.2063 15.5917 14.2061 15.5857M14.1978 15.4068C14.1974 15.4016 14.1971 15.3966 14.1967 15.3914M14.1971 15.3325C14.1983 15.3313 14.1993 15.3301 14.2005 15.3289M14.2061 16.3915C14.2061 16.3836 14.2064 16.3759 14.2064 16.3679M14.2069 16.3381C14.2069 16.3297 14.2073 16.3213 14.2073 16.3128M22.9537 15.3568H22.9806M16.813 30.8207L16.8153 30.8098M16.7094 31.377C16.7172 31.3961 16.7226 31.41 16.7259 31.419C16.7272 31.4229 16.7283 31.4264 16.7293 31.43M16.8669 30.8839C16.8695 30.871 16.8672 30.8598 16.8603 30.8496C16.8672 30.8598 16.8695 30.8711 16.8669 30.8839ZM16.8669 30.8839C16.865 30.8934 16.8607 30.9013 16.8541 30.9078C16.8607 30.9011 16.865 30.8932 16.8669 30.8839ZM16.9109 31.5311C16.892 31.5108 16.8754 31.4846 16.8607 31.4529L16.8411 31.4087M17.189 31.3008L17.3888 31.3308M16.8317 30.9257C16.8286 30.928 16.8253 30.9302 16.8217 30.9328M16.5583 31.1123L16.5964 30.928M16.5964 30.928C16.6001 30.9102 16.6039 30.8949 16.6075 30.8822C16.6039 30.8951 16.6002 30.9104 16.5964 30.928ZM16.6924 30.7976C16.7028 30.7973 16.7149 30.7983 16.7288 30.8009M16.7311 30.79L16.4233 30.7167M16.4642 30.7466C16.4562 30.7411 16.4462 30.7363 16.4339 30.7318M16.1183 30.9264C16.113 30.9323 16.1071 30.9376 16.1005 30.9419M16.0877 31.0642C16.0877 31.0637 16.0877 31.0632 16.0877 31.0627C16.0859 31.0451 16.0816 31.0291 16.0745 31.015C16.0678 31.0013 16.0572 30.9896 16.043 30.9802M15.9624 30.9326L15.9913 30.9409M15.9754 30.8811L16.04 30.625M15.9863 30.9555C16.004 30.9607 16.0192 30.9666 16.0315 30.9733C16.0191 30.9667 16.004 30.9609 15.9863 30.9555ZM15.9863 30.9555L15.9588 30.9478M15.907 31.2268C15.9089 31.238 15.9123 31.2481 15.9167 31.2576M15.907 31.2268C15.9063 31.2225 15.9057 31.218 15.9054 31.2134C15.9057 31.218 15.9063 31.2227 15.907 31.2268ZM15.9435 31.2953C15.9532 31.3043 15.9652 31.3122 15.9792 31.3194C15.9652 31.3124 15.9534 31.3043 15.9435 31.2953ZM15.9435 31.2953C15.9355 31.2881 15.9291 31.2797 15.9236 31.2707M16.1274 31.3496C16.1558 31.3463 16.1809 31.3363 16.2024 31.3189C16.1807 31.3363 16.1558 31.3465 16.1274 31.3496ZM16.1274 31.3496C16.0991 31.3527 16.0658 31.3487 16.0277 31.3379C16.0658 31.3487 16.0991 31.3525 16.1274 31.3496ZM16.2289 30.6869C16.2145 30.6788 16.1961 30.671 16.1736 30.6636M16.2289 30.6869C16.2337 30.6896 16.2383 30.6924 16.2426 30.6955C16.2383 30.6924 16.2336 30.6896 16.2289 30.6869ZM16.3188 30.8691L16.3076 30.8663M15.8368 30.5623L15.8395 30.5515L16.3526 30.6981M16.3001 30.7732C16.2946 30.7573 16.2864 30.7422 16.2755 30.7275M15.2258 30.4223C15.2253 30.4268 15.2246 30.4318 15.2236 30.4373M15.2258 30.4223C15.2262 30.4179 15.2263 30.4136 15.2263 30.4092C15.2263 30.4136 15.2263 30.4179 15.2258 30.4223ZM15.0567 30.3188C15.0432 30.3252 15.0314 30.3355 15.0219 30.3502C15.0316 30.3355 15.0432 30.325 15.0567 30.3188ZM15.0567 30.3188C15.078 30.3088 15.1016 30.3083 15.1277 30.3174C15.1017 30.3083 15.078 30.3088 15.0567 30.3188ZM13.5391 29.5686C13.5391 29.5645 13.539 29.5605 13.5384 29.5566M13.487 29.4686L13.7647 29.6306L13.7597 29.6404M13.6405 29.6551C13.6459 29.6484 13.6519 29.6427 13.6582 29.6382C13.6519 29.6429 13.6461 29.6484 13.6405 29.6551ZM13.6405 29.6551C13.6292 29.6687 13.6157 29.6912 13.5994 29.7229C13.6156 29.6911 13.6292 29.6685 13.6405 29.6551ZM14.9318 30.2179L15.1433 30.3111M14.9593 30.2486C14.951 30.2418 14.9404 30.2353 14.9278 30.2288M15.1555 30.318L15.1589 30.3071L15.339 30.3736L15.5521 31.0334M15.8056 31.119C15.799 31.1452 15.7928 31.166 15.7867 31.1815M14.8929 23.488C14.8988 23.4905 14.9042 23.493 14.9094 23.4952M14.9139 23.4973C14.9177 23.499 14.9215 23.5005 14.925 23.5021M14.9285 23.5035C14.9328 23.5054 14.937 23.5071 14.9408 23.5086M14.9439 23.5098C14.9465 23.5109 14.9491 23.5119 14.9515 23.5129M14.7957 23.2567C14.7992 23.2629 14.8028 23.2689 14.8065 23.2751M14.8318 23.3181C14.8365 23.3261 14.8413 23.3342 14.8462 23.3421M13.3368 29.4124C13.3451 29.4305 13.3499 29.4491 13.3511 29.4684C13.3499 29.4491 13.3452 29.4305 13.3368 29.4124ZM13.3368 29.4124C13.3238 29.3847 13.3021 29.3589 13.2719 29.3347M13.3368 29.4124C13.3238 29.3847 13.3023 29.3589 13.2719 29.3347M13.2719 29.3347C13.2688 29.3323 13.264 29.3289 13.2581 29.3248C13.264 29.3289 13.2688 29.3325 13.2719 29.3347ZM13.1061 29.5852C13.0988 29.5848 13.0914 29.584 13.0839 29.5821M13.2373 29.6377C13.2305 29.6396 13.2238 29.641 13.217 29.6418C13.2238 29.6411 13.2305 29.6398 13.2373 29.6377ZM13.2373 29.6377C13.2747 29.6275 13.3047 29.6029 13.3277 29.5635M13.3298 30.0114L13.5048 29.667C13.513 29.6509 13.5197 29.6367 13.5249 29.6244M13.3298 30.0114C13.3234 30.024 13.3177 30.0347 13.3121 30.0443C13.3177 30.0347 13.3236 30.024 13.3298 30.0114ZM14.0824 29.8623C14.0919 29.859 14.1012 29.8576 14.1106 29.858M14.0824 29.8623C14.0683 29.8671 14.0557 29.8762 14.0446 29.8896C14.0557 29.8764 14.0683 29.8671 14.0824 29.8623ZM14.1875 29.8747L14.1924 29.8638L14.4767 30.0107L14.4717 30.0216M14.1875 29.8747C14.1959 29.8795 14.2031 29.8843 14.2094 29.8891C14.203 29.8843 14.1957 29.8795 14.1875 29.8747ZM14.3679 30.0269C14.3747 30.0211 14.382 30.0164 14.3896 30.0135M14.3896 30.0135C14.4021 30.0085 14.4145 30.0066 14.427 30.008M14.3896 30.0135C14.4022 30.0085 14.4147 30.0066 14.427 30.008M14.427 30.008C14.4364 30.009 14.4471 30.0119 14.4592 30.0164C14.4471 30.0118 14.4365 30.009 14.427 30.008ZM14.3646 30.6111C14.3575 30.6269 14.3509 30.6399 14.345 30.6488M14.5178 30.2141C14.5242 30.1976 14.5292 30.1829 14.533 30.1702C14.5292 30.1829 14.524 30.1974 14.5178 30.2141ZM14.5178 30.2141L14.488 30.292M14.9927 30.3364C14.9947 30.3235 14.9945 30.3114 14.9921 30.3002C14.9945 30.3116 14.9948 30.3236 14.9927 30.3364ZM14.9927 30.3364C14.9921 30.3409 14.9912 30.3457 14.9898 30.3512C14.991 30.3459 14.9921 30.3409 14.9927 30.3364ZM14.9889 30.9881C14.994 30.9879 14.999 30.9872 15.004 30.986C14.999 30.9872 14.994 30.9881 14.9889 30.9881ZM14.9889 30.9881C14.9829 30.9881 14.9761 30.9876 14.9687 30.9864C14.9761 30.9876 14.9829 30.9883 14.9889 30.9881ZM15.0945 30.9226C15.0976 30.9096 15.1019 30.8944 15.1075 30.8772L15.248 30.4401L15.498 31.197M15.0952 31.0036C15.1007 31.0165 15.1085 31.0272 15.118 31.0356C15.1085 31.0272 15.1009 31.0165 15.0952 31.0036ZM15.0952 31.0036C15.092 30.9964 15.09 30.9888 15.0887 30.9809M16.2358 31.4128L15.6661 31.25M16.2817 31.2068C16.2715 31.2287 16.2616 31.2471 16.2525 31.2621C16.2616 31.2471 16.2715 31.2289 16.2817 31.2068ZM16.2817 31.2068L16.2927 31.2106M16.5534 31.1381L16.5917 31.1124L16.6699 31.2829M16.6699 31.2829C16.6787 31.3019 16.6893 31.3262 16.7018 31.3558C16.6893 31.326 16.6789 31.3017 16.6699 31.2829ZM16.6565 31.5128L16.9757 31.5888L16.9764 31.5859M17.1443 31.3883L17.1793 31.3196M17.6581 31.6747L17.6567 31.6852M23.5169 29.6818L23.5118 29.672L23.6981 29.5619L23.7037 29.5728C23.6919 29.5814 23.6823 29.5898 23.6756 29.5981M23.5169 29.6818C23.5259 29.6776 23.5338 29.6744 23.5406 29.6723C23.5338 29.6745 23.5259 29.6776 23.5169 29.6818ZM22.3457 30.2866C22.3365 30.2954 22.3298 30.3057 22.3247 30.318C22.3296 30.3057 22.3365 30.2954 22.3457 30.2866ZM22.3457 30.2866C22.349 30.2835 22.3528 30.2804 22.357 30.2773M21.759 30.9307L21.7999 30.9152M21.7335 31.0847C21.7325 31.1097 21.7311 31.13 21.7297 31.1457M21.7746 31.1844C21.777 31.1877 21.7793 31.1911 21.782 31.1941M21.782 31.1941C21.7884 31.2008 21.7957 31.2058 21.8033 31.2094C21.7955 31.2058 21.7884 31.2008 21.782 31.1941ZM21.7579 30.953L21.9624 30.8756L22.0459 30.9776M22.0809 31.1114C22.0901 31.0992 22.095 31.0864 22.0957 31.0732C22.0948 31.0864 22.0899 31.0992 22.0809 31.1114ZM22.0809 31.1114C22.0747 31.1202 22.0631 31.1293 22.0463 31.1388C22.0631 31.1291 22.0745 31.12 22.0809 31.1114ZM21.7765 30.4885L22.1521 30.9378M22.1364 30.3807C22.1269 30.3812 22.1159 30.3838 22.1035 30.3882C22.1159 30.3839 22.1269 30.3813 22.1364 30.3807ZM22.1364 30.3807C22.1393 30.3805 22.1424 30.3805 22.1454 30.3807C22.1424 30.3807 22.1393 30.3807 22.1364 30.3807ZM22.0912 30.3865L22.0891 30.3812M22.822 30.6851C22.8226 30.7068 22.8203 30.7275 22.8154 30.7471M23.1651 29.8893C23.1778 29.8828 23.1892 29.8781 23.1994 29.8752M23.3082 30.4905C23.3126 30.4971 23.3169 30.5028 23.3212 30.5078M23.3082 30.4905C23.3063 30.4874 23.3043 30.484 23.302 30.4804C23.3041 30.484 23.3062 30.4874 23.3082 30.4905ZM23.2466 29.8766C23.2403 29.8743 23.2341 29.8729 23.2278 29.8724C23.2341 29.8729 23.2403 29.8745 23.2466 29.8766ZM23.2466 29.8766C23.2609 29.8809 23.2736 29.89 23.2845 29.9033C23.2736 29.89 23.2609 29.881 23.2466 29.8766ZM23.1601 29.8797L23.4363 29.7164M23.5051 30.0806L23.4202 29.9153M23.5966 30.2582C23.613 30.2899 23.6267 30.3125 23.638 30.3259M23.638 30.3259C23.643 30.3319 23.6486 30.3371 23.6541 30.3412C23.6484 30.3369 23.643 30.3319 23.638 30.3259ZM23.5607 29.9473L23.5786 29.8865M14.1945 16.9239C14.1943 16.9314 14.1941 16.9392 14.1939 16.9468M14.1853 17.2869C14.1851 17.2941 14.1849 17.3016 14.1848 17.3088M14.4736 22.5933C14.4721 22.5891 14.4705 22.5852 14.4689 22.581M14.3598 22.2659C14.357 22.2566 14.3542 22.2473 14.3515 22.238M14.3404 22.1994C14.3378 22.1903 14.3352 22.1811 14.3327 22.172M14.3043 22.0613C14.3026 22.0544 14.3009 22.0473 14.2993 22.0404M14.2714 21.9087C14.27 21.9011 14.2686 21.8937 14.2672 21.8861M14.693 23.0691C14.6885 23.0605 14.684 23.0517 14.6795 23.0431M14.6284 22.9425C14.6238 22.9334 14.6193 22.9241 14.6148 22.915M12.6322 29.7336C12.6229 29.7317 12.6125 29.7276 12.6007 29.7216C12.6125 29.7278 12.623 29.7317 12.6322 29.7336ZM12.6322 29.7336C12.6338 29.734 12.6355 29.7341 12.6372 29.7345C12.6355 29.7343 12.6339 29.7341 12.6322 29.7336ZM12.6599 29.7345C12.6631 29.734 12.6662 29.7333 12.6693 29.7324M12.6693 29.7324C12.6766 29.7305 12.6835 29.7278 12.6901 29.7236C12.6835 29.7276 12.6766 29.7305 12.6693 29.7324ZM13.1976 29.912C13.2134 29.885 13.2229 29.8566 13.2267 29.8268M13.1976 29.912C13.2134 29.8852 13.2229 29.8566 13.2267 29.8268M13.1976 29.912C13.1896 29.9256 13.1806 29.9377 13.1708 29.9486C13.1806 29.9379 13.1895 29.9256 13.1976 29.912ZM13.2267 29.8268C13.2281 29.8156 13.2283 29.8046 13.2279 29.7937C13.2283 29.8046 13.2279 29.8156 13.2267 29.8268ZM13.85 30.4905L13.8451 30.5004L13.5677 30.3386M13.828 30.3013L14.003 29.9566M14.003 29.9566C14.0098 29.9434 14.016 29.9322 14.0217 29.922C14.0158 29.932 14.0096 29.9434 14.003 29.9566ZM14.1874 30.6509L14.1825 30.6617L13.8982 30.5148M14.3896 30.7306C14.3925 30.7349 14.3956 30.7391 14.3993 30.7427M14.3993 30.7427C14.4062 30.7496 14.4154 30.7561 14.4267 30.7626C14.4154 30.7561 14.4062 30.7494 14.3993 30.7427ZM14.9423 30.9791L14.9389 30.99L15.1546 31.0694M18.57 31.1009C18.5799 31.1154 18.588 31.1334 18.5946 31.1548C18.588 31.1333 18.5799 31.1152 18.57 31.1009ZM18.57 31.1009C18.5633 31.0911 18.5549 31.0825 18.5456 31.0745C18.5548 31.0825 18.5633 31.0911 18.57 31.1009ZM18.7196 31.6058C18.7272 31.6424 18.7435 31.6723 18.7686 31.6957M22.3977 30.9948C22.4013 30.9889 22.4043 30.9829 22.4067 30.9764C22.4044 30.9829 22.4013 30.9891 22.3977 30.9948ZM22.3977 30.9948C22.3868 31.0122 22.3696 31.026 22.3466 31.0365C22.3696 31.0261 22.3866 31.0122 22.3977 30.9948ZM22.8654 30.0338C22.874 30.03 22.8822 30.0269 22.8896 30.0247M23.4314 30.5207L23.4363 30.5315L23.1511 30.6771M23.8568 30.2205C23.8492 30.2105 23.8371 30.2007 23.8198 30.1909M24.1024 30.1476L23.8253 30.3114M23.9237 30.1125L23.9417 30.1208M23.9417 30.1208C23.9468 30.123 23.9518 30.1247 23.9566 30.1266C23.9516 30.1247 23.9468 30.1228 23.9417 30.1208ZM24.0863 30.1626L24.092 30.1724M24.1654 30.0124C24.1719 30.0236 24.1803 30.0324 24.1907 30.039M24.1374 29.9165L24.1322 29.8865L24.1174 29.8094M24.1512 28.8596C24.0487 28.9152 24.0081 29.0428 23.8924 29.1301C24.0081 29.043 24.0487 28.9152 24.1512 28.8596ZM24.1512 28.8596C24.1734 28.8475 24.1973 28.8405 24.2226 28.8375M14.2362 15.3036L15.73 15.2895M12.0244 29.6549C12.041 29.6311 12.0588 29.6067 12.0777 29.5817C12.3139 29.2693 12.7133 28.8744 12.9555 28.8508M23.4619 24.8001C23.4661 24.8044 23.4703 24.8087 23.4748 24.813M23.2509 24.5475L23.6163 24.6293M23.607 24.9067C23.5988 24.9024 23.5909 24.8981 23.5832 24.8938M23.5101 24.8442C23.5046 24.8397 23.4992 24.8353 23.494 24.8308M23.7917 24.9777C23.8049 24.9815 23.8184 24.9851 23.8324 24.9887M14.7443 15.2549L14.2454 15.2989C14.3348 15.2592 14.4864 15.2776 14.7443 15.2549ZM18.461 12.6393C18.4628 12.6353 18.4647 12.6312 18.4662 12.6271C18.4645 12.6312 18.4628 12.6353 18.461 12.6393ZM18.4699 12.6176C18.4714 12.6135 18.4728 12.6092 18.4744 12.6049C18.473 12.6092 18.4714 12.6135 18.4699 12.6176ZM18.4903 12.5401C18.4914 12.5341 18.4924 12.5279 18.4934 12.5215C18.4926 12.5279 18.4915 12.5339 18.4903 12.5401ZM18.4983 12.4816C18.499 12.4748 18.4995 12.4678 18.5 12.4607C18.4995 12.4678 18.4988 12.4748 18.4983 12.4816ZM18.5009 12.4506C18.5016 12.4399 18.5023 12.4289 18.5028 12.4175C18.5023 12.429 18.5016 12.4399 18.5009 12.4506ZM18.4493 12.6631C18.4519 12.6581 18.4546 12.6531 18.457 12.6479C18.4546 12.6531 18.452 12.6581 18.4493 12.6631ZM18.3912 12.7459C18.3943 12.7423 18.3974 12.7387 18.4002 12.7352C18.3973 12.7389 18.3941 12.7423 18.3912 12.7459ZM18.4078 12.7258C18.4104 12.7223 18.4132 12.719 18.4156 12.7156C18.413 12.719 18.4104 12.7223 18.4078 12.7258ZM18.4226 12.7063C18.425 12.7029 18.4274 12.6992 18.4298 12.6958C18.4274 12.6992 18.4252 12.7029 18.4226 12.7063ZM18.4357 12.6868C18.4385 12.6825 18.4411 12.6781 18.4435 12.6738C18.4409 12.6781 18.4385 12.6825 18.4357 12.6868ZM23.8667 30.247C23.8667 30.2436 23.8662 30.2401 23.8652 30.2367C23.8662 30.2401 23.8669 30.2436 23.8667 30.247ZM20.6613 31.5156C20.6564 31.5213 20.6509 31.5265 20.6452 31.5316C20.6509 31.5266 20.6564 31.5213 20.6613 31.5156ZM20.3132 31.5456C20.3031 31.539 20.2936 31.5318 20.2844 31.524C20.2936 31.532 20.3031 31.539 20.3132 31.5456ZM20.353 31.5669C20.3447 31.5633 20.3364 31.5593 20.3286 31.5549C20.3364 31.5593 20.3447 31.5631 20.353 31.5669ZM20.7904 31.4686C20.7869 31.4693 20.7829 31.4708 20.7786 31.4736C20.7829 31.4708 20.7867 31.4691 20.7904 31.4686ZM21.5114 31.1007C21.5126 31.0894 21.5162 31.0797 21.5221 31.0716C21.5162 31.0795 21.5126 31.0892 21.5114 31.1007ZM20.9198 30.8277C20.93 30.8114 20.9418 30.7961 20.9545 30.7816C20.9416 30.7961 20.93 30.8114 20.9198 30.8277ZM21.546 31.2605C21.5332 31.2595 21.524 31.2599 21.5185 31.2617C21.524 31.26 21.5332 31.2597 21.546 31.2605ZM19.3754 31.0117C19.3711 31.0117 19.3666 31.012 19.3617 31.0124C19.3666 31.012 19.3711 31.0119 19.3754 31.0117ZM19.4341 31.0267C19.4302 31.0237 19.426 31.0215 19.4218 31.0196C19.4262 31.0215 19.4303 31.0239 19.4341 31.0267ZM19.5464 31.5376C19.5504 31.5736 19.5554 31.6002 19.5612 31.6169C19.5554 31.6003 19.5504 31.5736 19.5464 31.5376ZM19.5868 31.6568C19.5944 31.6635 19.6027 31.6685 19.6114 31.672C19.6026 31.6685 19.5944 31.6634 19.5868 31.6568ZM19.6533 31.678C19.6577 31.678 19.6622 31.6777 19.6669 31.6773C19.6622 31.6777 19.6577 31.6778 19.6533 31.678ZM18.1403 31.7013C18.1285 31.7054 18.1129 31.7075 18.0939 31.7076C18.1129 31.7076 18.1285 31.7054 18.1403 31.7013ZM18.6367 31.0341C18.6353 31.0337 18.634 31.0336 18.6326 31.0334C18.634 31.0336 18.6353 31.0339 18.6367 31.0341ZM18.6253 31.0323C18.6237 31.0322 18.6222 31.032 18.6206 31.0318C18.6222 31.0318 18.6237 31.0322 18.6253 31.0323ZM18.8221 31.1429C18.823 31.1272 18.8242 31.1148 18.826 31.1059C18.8242 31.1148 18.8228 31.1272 18.8221 31.1429ZM18.9694 31.7416C18.9452 31.7393 18.9242 31.7335 18.9069 31.724C18.9244 31.7333 18.9452 31.7391 18.9694 31.7416ZM19.2831 31.0423C19.2747 31.0468 19.2671 31.0528 19.2602 31.0606C19.2673 31.0528 19.2747 31.0468 19.2831 31.0423ZM14.1375 30.6064C14.1317 30.5963 14.1283 30.5849 14.1269 30.5723C14.1283 30.5849 14.1319 30.5963 14.1375 30.6064ZM12.9883 29.2042C12.988 29.2002 12.9874 29.1963 12.9866 29.1923C12.9874 29.1963 12.988 29.2001 12.9883 29.2042ZM14.1716 18.0624C14.1716 18.0691 14.1716 18.0757 14.1716 18.0822C14.1716 18.0757 14.1716 18.069 14.1716 18.0624ZM14.1768 17.6367C14.1768 17.6288 14.1771 17.6207 14.1773 17.6128C14.1773 17.6209 14.177 17.6288 14.1768 17.6367ZM14.1763 18.415C14.1763 18.4117 14.1761 18.4084 14.1759 18.4052C14.1759 18.4084 14.1761 18.4117 14.1763 18.415ZM14.1751 18.3776C14.1751 18.3729 14.1749 18.3681 14.1747 18.3635C14.1747 18.3681 14.1749 18.3729 14.1751 18.3776ZM14.174 18.3388C14.174 18.3339 14.1738 18.3285 14.1737 18.3235C14.1737 18.3287 14.1738 18.3339 14.174 18.3388ZM14.1732 18.2989C14.1732 18.293 14.173 18.2872 14.1728 18.2813C14.1728 18.2872 14.173 18.2932 14.1732 18.2989ZM14.1725 18.2579C14.1725 18.2517 14.1725 18.2453 14.1723 18.239C14.1723 18.2453 14.1723 18.2517 14.1725 18.2579ZM14.1719 18.2155C14.1719 18.2092 14.1719 18.2028 14.1719 18.1964C14.1719 18.2028 14.1719 18.2093 14.1719 18.2155ZM14.1714 18.0361C14.1714 18.0292 14.1714 18.022 14.1714 18.0151C14.1714 18.0221 14.1714 18.0292 14.1714 18.0361ZM14.1719 17.9407C14.1719 17.9336 14.1719 17.9265 14.1721 17.9193C14.1721 17.9264 14.1721 17.9336 14.1719 17.9407ZM14.1725 17.8918C14.1725 17.8845 14.1726 17.8771 14.1728 17.8699C14.1728 17.8771 14.1726 17.8845 14.1725 17.8918ZM14.1732 17.842C14.1732 17.8348 14.1733 17.8273 14.1735 17.8201C14.1735 17.8273 14.1733 17.8348 14.1732 17.842ZM14.1738 17.7914C14.1738 17.7839 14.174 17.7764 14.1742 17.769C14.1742 17.7764 14.174 17.7839 14.1738 17.7914ZM14.1756 17.6885C14.1756 17.6808 14.1759 17.673 14.1761 17.6651C14.1761 17.6729 14.1758 17.6808 14.1756 17.6885ZM14.2102 15.8285C14.2102 15.8213 14.2102 15.8142 14.2101 15.807C14.2101 15.8142 14.2101 15.8213 14.2102 15.8285ZM14.2099 15.7817C14.2099 15.7746 14.2097 15.7677 14.2095 15.7607C14.2095 15.7677 14.2097 15.7746 14.2099 15.7817ZM14.2094 15.7359C14.2094 15.729 14.2092 15.7221 14.209 15.7152C14.209 15.7221 14.2092 15.729 14.2094 15.7359ZM14.2087 15.6909C14.2087 15.684 14.2083 15.6773 14.2082 15.6704C14.2082 15.6773 14.2085 15.684 14.2087 15.6909ZM14.2078 15.6472C14.2078 15.6405 14.2075 15.6341 14.2073 15.6274C14.2073 15.6339 14.2076 15.6405 14.2078 15.6472ZM14.2052 15.5623C14.205 15.5559 14.2047 15.5495 14.2045 15.5433C14.2047 15.5497 14.205 15.5559 14.2052 15.5623ZM14.2037 15.5216C14.2035 15.5153 14.2031 15.5092 14.2028 15.503C14.2031 15.5092 14.2033 15.5154 14.2037 15.5216ZM14.2019 15.482C14.2016 15.4763 14.2014 15.4707 14.2011 15.465C14.2014 15.4707 14.2016 15.4762 14.2019 15.482ZM14.2 15.4438C14.1997 15.4383 14.1993 15.4329 14.199 15.4276C14.1993 15.4331 14.1997 15.4383 14.2 15.4438ZM14.1953 15.3711C14.195 15.3663 14.1946 15.3618 14.1943 15.357C14.1946 15.3616 14.195 15.3663 14.1953 15.3711ZM14.204 16.5016C14.204 16.4933 14.2043 16.4852 14.2045 16.4771C14.2045 16.4852 14.2042 16.4935 14.204 16.5016ZM14.205 16.4461C14.205 16.4384 14.2054 16.4306 14.2056 16.4229C14.2056 16.4306 14.2052 16.4384 14.205 16.4461ZM14.2078 16.2847C14.2078 16.2761 14.208 16.2675 14.2082 16.2589C14.2082 16.2675 14.208 16.2761 14.2078 16.2847ZM14.2085 16.2314C14.2085 16.2229 14.2087 16.2147 14.2089 16.2064C14.2089 16.2147 14.2087 16.2231 14.2085 16.2314ZM14.2092 16.1785C14.2092 16.1704 14.2094 16.1623 14.2094 16.1542C14.2094 16.1623 14.2094 16.1704 14.2092 16.1785ZM14.2097 16.1261C14.2097 16.1186 14.2097 16.111 14.2099 16.1034C14.2099 16.111 14.2099 16.1186 14.2097 16.1261ZM14.2101 16.0748C14.2101 16.0669 14.2101 16.059 14.2101 16.0509C14.2101 16.0588 14.2101 16.0667 14.2101 16.0748ZM14.2104 16.0245C14.2104 16.0164 14.2104 16.0085 14.2104 16.0006C14.2104 16.0085 14.2104 16.0166 14.2104 16.0245ZM14.2104 15.9739C14.2104 15.9663 14.2104 15.9589 14.2104 15.9515C14.2104 15.9589 14.2104 15.9665 14.2104 15.9739ZM17.0923 31.5172C17.0923 31.5139 17.0927 31.5108 17.0932 31.5075C17.0927 31.5108 17.0925 31.5141 17.0923 31.5172ZM16.9535 31.5666C16.9492 31.5642 16.945 31.5619 16.9416 31.5593C16.9452 31.5618 16.9492 31.5642 16.9535 31.5666ZM16.9743 31.5647C16.9794 31.5635 16.9842 31.5621 16.9889 31.56C16.9842 31.5619 16.9794 31.5635 16.9743 31.5647ZM16.9556 31.5673C16.9606 31.5671 16.9657 31.5664 16.9703 31.5655C16.9655 31.5664 16.9606 31.5671 16.9556 31.5673ZM16.9835 30.8706C16.9885 30.8699 16.9943 30.8696 17.0003 30.8698C16.9943 30.8698 16.9885 30.8698 16.9835 30.8706ZM17.0963 31.5451C17.1003 31.5571 17.1064 31.5673 17.1145 31.5757C17.1062 31.5673 17.1003 31.5571 17.0963 31.5451ZM17.0968 31.4896C17.0994 31.48 17.1038 31.4691 17.1088 31.4574C17.1038 31.4691 17.0996 31.48 17.0968 31.4896ZM17.4302 31.507C17.4361 31.5325 17.4382 31.5526 17.4363 31.5669C17.438 31.5526 17.4361 31.5325 17.4302 31.507ZM17.3827 31.6239C17.3888 31.6227 17.3942 31.6213 17.3983 31.6195C17.3942 31.6213 17.3888 31.6229 17.3827 31.6239ZM16.5063 31.3906C16.5063 31.3906 16.5063 31.3916 16.5063 31.3921C16.5063 31.3916 16.5063 31.3911 16.5063 31.3906ZM16.5022 30.8226C16.5022 30.8048 16.4982 30.7893 16.4902 30.7756C16.4982 30.7892 16.5023 30.8048 16.5022 30.8226ZM16.4994 30.856C16.4975 30.8693 16.4947 30.8849 16.4911 30.9027C16.4947 30.8849 16.4976 30.8693 16.4994 30.856ZM15.9137 30.661C15.9141 30.6536 15.9134 30.6466 15.9123 30.6397C15.9134 30.6464 15.9141 30.6535 15.9137 30.661ZM16.309 30.8446C16.3091 30.8377 16.3093 30.831 16.309 30.8246C16.3091 30.831 16.3091 30.8377 16.309 30.8446ZM13.9706 26.9984C14.1314 26.838 14.2295 26.6379 14.4133 26.5146C14.645 26.3589 14.7704 26.3116 15.0106 26.1256L15.0988 26.3038C15.3502 26.1187 15.2773 26.1181 15.4095 25.9166C15.418 25.9037 15.444 25.8676 15.4528 25.8559C15.5108 25.7799 15.4895 25.8128 15.5287 25.769C15.7049 25.9135 15.6287 26.0136 15.8839 26.0828C15.8908 25.7513 16.0203 25.4401 16.2949 25.2577C16.297 26.3358 16.1497 26.7003 15.839 27.6363L15.1343 29.765C15.1305 29.7718 15.1203 29.7853 15.1133 29.7954C14.8694 29.736 13.9455 29.2753 13.7394 29.1119C13.7857 28.7525 13.7492 29.1632 13.6616 28.4165L13.2174 28.1474C13.2205 27.9191 13.2524 27.9732 13.3539 27.8233C13.5873 27.4785 13.1056 27.8607 13.9708 26.9985L13.9706 26.9984ZM18.7012 26.0863C18.6731 26.092 18.6423 26.0966 18.6081 26.0997C18.6099 26.0994 18.6118 26.0989 18.6135 26.0985C18.643 26.0952 18.6721 26.0911 18.7012 26.0863ZM15.8075 24.5661C15.8307 24.5886 15.8541 24.611 15.8775 24.6329C15.8635 24.6351 15.8461 24.6379 15.8238 24.6408C15.8205 24.6146 15.8149 24.5897 15.8075 24.5661ZM19.186 25.9876C19.1427 25.985 19.1048 25.9855 19.0706 25.9883C19.0978 25.9786 19.1247 25.9687 19.1517 25.9583C19.1964 25.9449 19.2408 25.9309 19.285 25.9166L19.186 25.9876ZM15.5973 24.3496C15.5758 24.3429 15.5531 24.3377 15.5292 24.3351C15.5171 24.2943 15.5029 24.2581 15.4869 24.2251C15.5233 24.2674 15.5602 24.3089 15.5973 24.3496ZM16.2277 24.9484C16.2202 24.9377 16.2136 24.9283 16.2078 24.9198C16.2206 24.93 16.2332 24.9401 16.2461 24.9501C16.2452 24.9496 16.2443 24.9491 16.2435 24.9486H16.2277V24.9484ZM16.8648 25.3776C16.8283 25.3686 16.7924 25.3628 16.7572 25.3609C16.7432 25.3249 16.7404 25.3089 16.7378 25.2989C16.7803 25.3259 16.8227 25.3523 16.8648 25.3776ZM13.7372 29.6303C13.7294 29.6274 13.7223 29.6255 13.7159 29.6243C13.7223 29.6253 13.7294 29.6274 13.7372 29.6303ZM13.5187 29.5094C13.5104 29.4992 13.4982 29.4889 13.4821 29.4782C13.4981 29.4887 13.5104 29.4992 13.5187 29.5094ZM15.1707 30.3252C15.1813 30.3307 15.1899 30.3362 15.1965 30.3421C15.1899 30.3362 15.1811 30.3307 15.1707 30.3252ZM15.658 30.5122C15.6677 30.5207 15.6755 30.5312 15.681 30.5443C15.6753 30.5312 15.6677 30.5207 15.658 30.5122ZM15.7808 31.1953C15.773 31.2111 15.7628 31.2232 15.75 31.2313C15.7626 31.2232 15.7728 31.2111 15.7808 31.1953ZM15.0361 29.8759C15.2353 29.9637 15.4535 30.0529 15.6902 30.1382C15.4535 30.0529 15.2355 29.9637 15.0361 29.8759ZM14.4861 29.6177C14.4861 29.6177 14.4851 29.6172 14.4844 29.6168C14.4849 29.6172 14.4854 29.6174 14.4861 29.6177ZM23.001 17.8375C23.0062 18.008 23.0114 18.1785 23.0168 18.3492C23.0114 18.1787 23.0062 18.008 23.001 17.8375ZM22.982 17.1679C22.9868 17.3493 22.9918 17.5306 22.9974 17.7123C22.992 17.5308 22.9868 17.3493 22.982 17.1679ZM14.9534 23.5136C14.9506 23.5093 14.9479 23.5048 14.9449 23.5005C14.9477 23.505 14.9506 23.5093 14.9534 23.5136ZM14.9065 23.4401C14.912 23.4487 14.9174 23.4575 14.9229 23.4661C14.9174 23.4575 14.9118 23.4487 14.9065 23.4401ZM14.8687 23.3793C14.8739 23.3879 14.8793 23.3963 14.8845 23.4049C14.8793 23.3965 14.8739 23.3879 14.8687 23.3793ZM13.2505 29.4019C13.2498 29.3904 13.2479 29.3795 13.2447 29.3694C13.248 29.3795 13.2499 29.3904 13.2505 29.4019ZM13.1396 29.633C13.1455 29.6344 13.1512 29.6356 13.1565 29.6368C13.1512 29.6358 13.1456 29.6344 13.1396 29.633ZM13.189 29.5533C13.2016 29.5421 13.2125 29.5283 13.222 29.5121C13.2125 29.5285 13.2014 29.5421 13.189 29.5533ZM13.0753 29.5795C13.0661 29.5765 13.0554 29.5722 13.0431 29.5666C13.0552 29.5722 13.0659 29.5765 13.0753 29.5795ZM13.0897 29.6325C13.0732 29.6137 13.0515 29.5953 13.0249 29.5774C13.0515 29.5955 13.0732 29.6139 13.0897 29.6325ZM12.9614 29.9306C12.954 29.9306 12.9465 29.9294 12.9391 29.9281C12.9465 29.9294 12.954 29.9305 12.9614 29.9306ZM13.176 29.5636C13.1623 29.5731 13.1479 29.5796 13.1326 29.5829C13.1479 29.5795 13.1623 29.5731 13.176 29.5636ZM14.3735 30.675C14.3735 30.6709 14.374 30.6665 14.3747 30.6621C14.374 30.6664 14.3736 30.6707 14.3735 30.675ZM15.0503 30.9562C15.043 30.9655 15.0347 30.9728 15.0255 30.9778C15.0349 30.9726 15.0432 30.9655 15.0503 30.9562ZM16.3909 31.3625C16.3961 31.3504 16.4015 31.3329 16.407 31.3098C16.4015 31.3329 16.3963 31.3504 16.3909 31.3625ZM16.6909 31.5046C16.6817 31.5046 16.6711 31.5039 16.6588 31.502C16.6711 31.5037 16.6817 31.5046 16.6909 31.5046ZM17.1247 31.5829C17.135 31.5902 17.1473 31.5957 17.1622 31.5993C17.1474 31.5957 17.135 31.5903 17.1247 31.5829ZM17.6582 31.6734C17.6484 31.6706 17.6395 31.668 17.6323 31.6654C17.6397 31.668 17.6484 31.6706 17.6582 31.6734ZM23.5702 29.6695C23.576 29.6708 23.5808 29.6737 23.5851 29.6771C23.5808 29.6737 23.576 29.6709 23.5702 29.6695ZM21.7547 31.0826C21.7547 31.0876 21.7547 31.0923 21.7547 31.0969C21.7547 31.0923 21.7547 31.0875 21.7547 31.0826ZM21.8113 31.2123C21.8188 31.2146 21.8269 31.2156 21.8354 31.2152C21.8269 31.2154 21.8188 31.2146 21.8113 31.2123ZM22.0958 31.0716C22.0962 31.0633 22.0948 31.0549 22.092 31.0461C22.095 31.0547 22.0962 31.0633 22.0958 31.0716ZM22.1723 30.3863C22.178 30.3886 22.1832 30.3917 22.1882 30.3955C22.1832 30.3919 22.1778 30.3886 22.1723 30.3863ZM22.331 30.4099C22.3253 30.3931 22.3214 30.3788 22.3197 30.3679C22.3214 30.3788 22.3254 30.3931 22.331 30.4099ZM22.5297 30.8705C22.5183 30.86 22.5074 30.8445 22.497 30.8243C22.5074 30.8445 22.5185 30.86 22.5297 30.8705ZM22.5727 29.6844C22.6063 29.6675 22.6392 29.6506 22.6715 29.6342C22.6394 29.6508 22.6065 29.6675 22.5727 29.6844ZM22.7733 30.8224C22.7629 30.8331 22.7506 30.8432 22.7363 30.8527C22.7505 30.8432 22.7629 30.8331 22.7733 30.8224ZM23.1137 29.9175C23.1079 29.9237 23.1036 29.9313 23.0998 29.9392C23.1036 29.9313 23.1081 29.9237 23.1137 29.9175ZM23.6558 30.3426C23.6558 30.3426 23.6562 30.3428 23.6564 30.3429C23.6562 30.3429 23.656 30.3428 23.6558 30.3426ZM23.9885 28.1309C23.2906 28.4745 23.651 28.267 23.5184 28.7423C23.463 28.9409 23.3692 28.8596 23.4793 29.1062C23.2046 29.3258 22.4311 29.7154 22.101 29.7942L21.0409 26.5785C20.9488 26.3091 20.9689 26.2282 20.9711 25.9268C20.973 25.6478 20.921 25.4983 20.9195 25.2567C21.384 25.5653 21.1946 25.8452 21.3994 26.1245L21.7373 25.8255C21.7439 25.834 21.7746 25.8738 21.7832 25.8856L22.0629 26.2749C22.2454 26.2241 22.06 26.2814 22.2376 26.1423C22.454 26.3582 22.6143 26.3439 22.8078 26.5069L23.7094 27.4584C23.8695 27.6458 23.7397 27.5836 23.847 27.7844C23.9631 28.0017 24.0168 27.8247 23.9887 28.1313L23.9885 28.1309ZM14.2326 21.6448C14.2315 21.6355 14.2307 21.6262 14.2298 21.6169C14.2307 21.6262 14.2317 21.6355 14.2326 21.6448ZM14.2265 21.5784C14.2258 21.5692 14.225 21.5601 14.2244 21.551C14.2251 21.5601 14.2258 21.5692 14.2265 21.5784ZM14.2218 21.511C14.2213 21.5024 14.2208 21.494 14.2205 21.4854C14.2208 21.494 14.2215 21.5024 14.2218 21.511ZM14.2187 21.4413C14.2186 21.434 14.2182 21.427 14.218 21.4197C14.218 21.427 14.2186 21.434 14.2187 21.4413ZM14.2123 15.3177C14.2123 15.3177 14.2128 15.3172 14.2132 15.317C14.2128 15.3172 14.2127 15.3175 14.2123 15.3177ZM14.2307 15.3055C14.2293 15.3064 14.2277 15.307 14.2264 15.3079C14.2277 15.307 14.2291 15.3062 14.2307 15.3055ZM14.204 16.5314C14.204 16.5391 14.2037 16.5469 14.2035 16.5546C14.2035 16.5469 14.2038 16.5391 14.204 16.5314ZM14.2028 16.5872C14.2028 16.5949 14.2024 16.6025 14.2023 16.6102C14.2024 16.6025 14.2026 16.5949 14.2028 16.5872ZM14.2016 16.6421C14.2014 16.6502 14.2012 16.6581 14.2011 16.6662C14.2012 16.6581 14.2014 16.65 14.2016 16.6421ZM14.2002 16.7003C14.2002 16.7069 14.1998 16.7132 14.1997 16.7198C14.1997 16.7132 14.2 16.7069 14.2002 16.7003ZM14.1988 16.7561C14.1986 16.7632 14.1985 16.7702 14.1983 16.7775C14.1985 16.7704 14.1986 16.7632 14.1988 16.7561ZM14.1974 16.8124C14.1974 16.8186 14.1971 16.8248 14.1969 16.8309C14.1969 16.8247 14.1972 16.8185 14.1974 16.8124ZM14.1959 16.8715C14.1959 16.8767 14.1955 16.882 14.1955 16.8872L14.1959 16.8715ZM14.1929 16.9862C14.1929 16.9891 14.1929 16.9921 14.1927 16.9952C14.1927 16.9922 14.1927 16.9893 14.1929 16.9862ZM14.1881 17.177C14.1881 17.1836 14.1877 17.1901 14.1875 17.1967C14.1875 17.1901 14.1879 17.1836 14.1881 17.177ZM14.1867 17.2323C14.1867 17.239 14.1863 17.2457 14.1862 17.2523C14.1862 17.2456 14.1865 17.2389 14.1867 17.2323ZM14.1839 17.3405C14.1837 17.3487 14.1836 17.357 14.1832 17.3653C14.1834 17.357 14.1836 17.3487 14.1839 17.3405ZM14.1825 17.3963C14.1823 17.4038 14.1822 17.4116 14.182 17.4192C14.1822 17.4116 14.1823 17.404 14.1825 17.3963ZM14.1813 17.4502C14.1811 17.4583 14.181 17.4662 14.1808 17.4743C14.181 17.4664 14.1811 17.4583 14.1813 17.4502ZM14.1801 17.5046C14.1799 17.5125 14.1797 17.5203 14.1796 17.5282C14.1796 17.5203 14.1799 17.5125 14.1801 17.5046ZM14.1789 17.558C14.1789 17.5659 14.1785 17.5737 14.1784 17.5816C14.1784 17.5738 14.1787 17.5659 14.1789 17.558ZM14.2555 21.8167C14.2568 21.8253 14.2582 21.8341 14.2596 21.8427C14.2581 21.8341 14.2568 21.8253 14.2555 21.8167ZM14.2367 21.6827C14.2378 21.692 14.239 21.7013 14.2402 21.7106C14.239 21.7013 14.238 21.692 14.2367 21.6827ZM14.2452 21.7494C14.2465 21.7585 14.2478 21.7676 14.2492 21.7769C14.2478 21.7678 14.2466 21.7587 14.2452 21.7494ZM14.5675 22.8137C14.5634 22.8048 14.5594 22.7958 14.5552 22.7868C14.5592 22.7958 14.5634 22.8048 14.5675 22.8137ZM14.5379 22.7476C14.5343 22.7391 14.5305 22.7309 14.5268 22.7224C14.5305 22.7309 14.5341 22.7391 14.5379 22.7476ZM14.5081 22.6778C14.5053 22.6711 14.5024 22.6646 14.4996 22.6578C14.5024 22.6646 14.5052 22.6711 14.5081 22.6778ZM14.4487 22.5283C14.4457 22.5206 14.4429 22.5128 14.44 22.5049C14.4429 22.5127 14.4457 22.5204 14.4487 22.5283ZM14.4248 22.4632C14.4216 22.4545 14.4185 22.4457 14.4154 22.4367C14.4185 22.4455 14.4215 22.4543 14.4248 22.4632ZM14.4019 22.3978C14.3988 22.3887 14.3956 22.3794 14.3927 22.3702C14.3958 22.3794 14.3988 22.3887 14.4019 22.3978ZM14.3802 22.332C14.3773 22.3227 14.3743 22.3134 14.3714 22.3039C14.3743 22.3132 14.3773 22.3225 14.3802 22.332ZM14.322 22.1319C14.3197 22.1233 14.3175 22.1148 14.3152 22.1062C14.3173 22.1148 14.3197 22.1233 14.322 22.1319ZM14.2846 21.9745C14.2841 21.9722 14.2837 21.97 14.2832 21.9676C14.2837 21.9698 14.2841 21.9721 14.2846 21.9745ZM14.7609 23.194C14.7581 23.189 14.7554 23.184 14.7526 23.1788C14.7554 23.1838 14.7581 23.1888 14.7609 23.194ZM14.7266 23.1318C14.7223 23.1239 14.7181 23.116 14.7139 23.1082C14.7181 23.1161 14.7224 23.1241 14.7266 23.1318ZM14.6602 23.0061C14.6556 22.9971 14.6511 22.988 14.6465 22.979C14.6511 22.9882 14.6556 22.9971 14.6602 23.0061ZM14.5973 22.8785C14.593 22.8693 14.5887 22.8602 14.5843 22.8509C14.5887 22.86 14.593 22.8693 14.5973 22.8785ZM12.9751 29.2595C12.9687 29.2736 12.9597 29.2907 12.9478 29.311C12.9597 29.2907 12.9687 29.2738 12.9751 29.2595ZM13.1385 29.9765C13.115 29.9921 13.0902 30.0007 13.064 30.0023C13.0902 30.0007 13.1151 29.9921 13.1385 29.9765ZM13.3934 30.1397C13.3981 30.1223 13.4083 30.0977 13.4244 30.0658C13.4083 30.0977 13.3979 30.1223 13.3934 30.1397ZM13.7341 30.2463C13.7178 30.2785 13.7041 30.3013 13.6928 30.3145C13.7041 30.3013 13.7176 30.2784 13.7341 30.2463ZM13.6 30.3405C13.5916 30.3378 13.5826 30.334 13.5728 30.3288C13.5826 30.334 13.5916 30.3376 13.6 30.3405ZM13.9715 30.5162C13.967 30.5172 13.9623 30.5179 13.9576 30.5181C13.9623 30.5181 13.9668 30.5172 13.9715 30.5162ZM14.3438 30.0543C14.3345 30.0703 14.3249 30.0893 14.3149 30.1113C14.3248 30.0893 14.3345 30.0703 14.3438 30.0543ZM14.2912 30.6855C14.2849 30.6869 14.2789 30.6874 14.2726 30.687C14.2789 30.6874 14.2851 30.6869 14.2912 30.6855ZM22.4103 30.9278C22.4095 30.9221 22.4077 30.9154 22.4058 30.908C22.4077 30.9152 22.4095 30.9221 22.4103 30.9278ZM22.9371 30.0224C22.9283 30.02 22.9192 30.0193 22.9102 30.0202C22.9192 30.0192 22.9283 30.02 22.9371 30.0224ZM23.3432 30.5257C23.3543 30.5313 23.3658 30.5343 23.3777 30.5343C23.3658 30.5343 23.3542 30.5313 23.3432 30.5257ZM23.533 30.3872C23.5283 30.37 23.5177 30.3455 23.5013 30.3135C23.5179 30.3455 23.5283 30.37 23.533 30.3872ZM24.6244 29.7708C24.6196 29.7703 24.6146 29.7691 24.6094 29.7677C24.6146 29.7693 24.6196 29.7703 24.6244 29.7708ZM25.2687 29.7954C25.2158 29.6616 25.0173 29.3843 24.7915 29.1624C25.0171 29.3843 25.2157 29.6616 25.2687 29.7954ZM23.4029 24.7254C23.4037 24.7268 23.4048 24.7283 23.4056 24.7297C23.4046 24.7283 23.4037 24.7268 23.4029 24.7254ZM23.4107 24.7369C23.4131 24.7404 23.4153 24.7438 23.4179 24.7471C23.4155 24.7436 23.4131 24.7402 23.4107 24.7369ZM23.4223 24.7529C23.4245 24.7559 23.4268 24.759 23.429 24.7619C23.4268 24.759 23.4243 24.7559 23.4223 24.7529ZM23.4339 24.7681C23.4366 24.7717 23.4396 24.7752 23.4427 24.7788C23.4398 24.7752 23.4368 24.7717 23.4339 24.7681ZM23.4467 24.7834C23.4503 24.7876 23.454 24.7917 23.458 24.7958C23.4541 24.7917 23.4503 24.7876 23.4467 24.7834ZM23.6378 24.9219C23.629 24.9178 23.6203 24.9136 23.6122 24.9093C23.6205 24.9136 23.629 24.9178 23.6378 24.9219ZM23.5798 24.8917C23.5727 24.8876 23.5657 24.8833 23.559 24.8792C23.5657 24.8835 23.5727 24.8876 23.5798 24.8917ZM23.556 24.8773C23.5491 24.8728 23.5427 24.8683 23.5363 24.8638C23.5427 24.8683 23.5493 24.8728 23.556 24.8773ZM23.5318 24.8607C23.5257 24.8564 23.5198 24.852 23.5143 24.8477C23.5198 24.8521 23.5257 24.8564 23.5318 24.8607ZM23.4912 24.8284C23.4867 24.8244 23.4824 24.8203 23.4781 24.8163C23.4822 24.8203 23.4867 24.8244 23.4912 24.8284ZM23.6428 24.9241C23.6522 24.9284 23.6619 24.9326 23.672 24.9369C23.6619 24.9327 23.6522 24.9284 23.6428 24.9241ZM23.674 24.9376C23.6839 24.9415 23.6941 24.9457 23.7049 24.9494C23.6943 24.9455 23.6839 24.9415 23.674 24.9376ZM23.7096 24.9513C23.7203 24.9553 23.7314 24.9591 23.743 24.9629C23.7316 24.9591 23.7203 24.9553 23.7096 24.9513ZM23.7496 24.9649C23.7612 24.9687 23.7731 24.9723 23.7854 24.976C23.773 24.9723 23.761 24.9687 23.7496 24.9649Z"
                                      stroke="#50CD89"
                                      strokeWidth="0.00848328"
                                      strokeMiterlimit="2.61"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M13.4382 24.2931L13.4552 24.2418L13.4092 24.2551L13.4382 24.2931Z"
                                      fill="#50CD89"
                                      stroke="#50CD89"
                                      strokeWidth="0.00848328"
                                      strokeMiterlimit="2.61"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1415_4134">
                                      <rect
                                        width="26"
                                        height="28.1667"
                                        fill="white"
                                        transform="translate(6 5)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </div>
                              <h3 className="text-white font-semibold text-sm md:text-base text-center">
                                Kolaborasi Kementerian & Lembaga
                              </h3>
                            </div>
                            <div
                              className="p-2 md:p-6 gap-y-6 md:gap-y-[4.5rem] md:h-[12.5rem] md:w-[8.5rem] flex flex-col rounded-xl md:rounded-3xl bg-no-repeat bg-cover bg-left-top bg-[url('/src/assets/images/icon/bg-perpusnas-press.svg')] cursor-pointer"
                              onClick={() => this.gotoSearch(37)}
                            >
                              <div className="p-2 w-12 h-12 md:w-15 md:h-15 flex items-center justify-start bg-white rounded-md md:rounded-xl">
                                <svg
                                  className="md:w-16 h-16"
                                  width="37"
                                  height="38"
                                  viewBox="0 0 37 38"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M18.4952 3.55988C18.9411 4.23679 19.3707 4.925 19.8129 5.60464C20.6215 6.86038 21.4637 8.10133 22.1255 9.44076C22.5551 10.3131 22.8897 11.2422 23.0037 12.2092C23.0899 12.8639 23.063 13.5283 22.9645 14.1804L23.0282 14.1539C22.8577 14.2734 22.7568 14.4587 22.633 14.6194C21.3501 16.3376 20.074 18.0612 18.7884 19.7775C18.6946 19.2948 18.5558 18.8187 18.3354 18.3761C17.9668 17.614 17.4422 16.939 16.9078 16.2839C16.2907 15.5354 15.6538 14.8028 15.0537 14.0406C16.2001 10.5466 17.3465 7.05306 18.4952 3.55988Z"
                                    fill="#A3D513"
                                  />
                                  <path
                                    d="M23.0295 14.1538C24.1102 13.6952 25.2966 13.4948 26.4702 13.5224C27.9327 13.5415 29.3671 13.8614 30.79 14.1655C32.0709 14.4605 33.3636 14.7015 34.654 14.9502C31.5716 17.1503 28.4806 19.3398 25.3978 21.5399C24.5169 21.239 23.6581 20.8817 22.7886 20.552C21.514 20.0678 20.1544 19.6419 18.7715 19.8023L18.7897 19.7774C20.0753 18.0611 21.3515 16.3375 22.6343 14.6193C22.7581 14.4586 22.859 14.2733 23.0295 14.1538Z"
                                    fill="#A3D513"
                                  />
                                  <path
                                    d="M2.32715 14.6366C5.08829 14.6354 7.84943 14.6455 10.6106 14.6451C11.7625 14.6424 12.9144 14.6591 14.0667 14.6479C14.4888 15.1644 14.9066 15.6848 15.3401 16.1928C15.8425 16.7923 16.3552 17.3859 16.7986 18.0301C17.1938 18.6109 17.5281 19.2516 17.6396 19.9491C17.7104 20.3512 17.6891 20.7611 17.7144 21.1671C17.7195 21.2547 17.6586 21.3228 17.6103 21.3894C15.8836 23.6895 14.1787 26.0052 12.4643 28.3139C11.2435 29.9558 10.0271 31.6008 8.80871 33.2442C8.75491 33.3209 8.70349 33.4018 8.62793 33.4602C8.64534 33.3213 8.70428 33.1928 8.74542 33.0601C9.98754 29.3259 11.2304 25.5926 12.471 21.8581C9.83089 19.9803 7.19119 18.1021 4.55149 16.2236C3.81097 15.6934 3.06332 15.1726 2.32715 14.6366Z"
                                    fill="#A3D513"
                                  />
                                  <path
                                    d="M17.7152 21.1671C18.2026 21.0515 18.6923 20.9114 19.1974 20.9082C20.0831 20.8646 20.9518 21.1001 21.781 21.3831C22.9349 21.7876 24.0555 22.28 25.2162 22.6673C26.4199 26.3037 27.6347 29.937 28.8405 33.5731C28.206 33.1418 27.592 32.6801 26.9646 32.2383C24.2138 30.2613 21.4562 28.2928 18.7081 26.3123C15.3318 28.7346 11.9552 31.1562 8.57812 33.5774C8.58841 33.5295 8.59909 33.4816 8.60898 33.4345L8.62876 33.4602C8.70431 33.4018 8.75574 33.3209 8.80954 33.2442C10.0279 31.6007 11.2443 29.9557 12.4651 28.3138C14.1795 26.0052 15.8845 23.6895 17.6112 21.3894C17.6594 21.3228 17.7203 21.2547 17.7152 21.1671Z"
                                    fill="#A3D513"
                                  />
                                </svg>
                              </div>
                              <h3 className="text-white font-semibold text-sm md:text-base text-center">
                                Perpusnas Press
                              </h3>
                            </div>
                            <div
                              className="p-2 md:p-6 gap-y-6 md:gap-y-[4.5rem] md:h-[12.5rem] md:w-[8.5rem] flex flex-col rounded-xl md:rounded-3xl bg-no-repeat bg-cover bg-left-top bg-[url('/src/assets/images/icon/bg-buku-anak.svg')] cursor-pointer"
                              onClick={() => this.gotoSearch(38)}
                            >
                              <div className="p-2 w-12 h-12 md:w-15 md:h-15 flex items-center justify-start bg-white rounded-md md:rounded-xl">
                                <svg
                                  width="45"
                                  height="45"
                                  viewBox="0 0 45 45"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clipPath="url(#clip0_1440_1589)">
                                    <path
                                      d="M22.2129 4.12305C17.55 4.12305 13.7695 7.90352 13.7695 12.5665C13.7695 17.2294 17.55 21.0099 22.2129 21.0099C26.8759 21.0099 30.6564 17.2294 30.6564 12.5665C30.6564 7.90352 26.8759 4.12305 22.2129 4.12305ZM22.2129 19.5572C19.1207 19.5572 16.4932 17.5399 15.5744 14.7527C16.3062 14.4258 18.9227 13.1602 20.0104 11.2954C20.0104 11.2954 20.2828 12.3667 20.0104 13.6015C20.0104 13.6015 22.8249 11.7494 23.5512 10.4783C23.5512 10.4783 25.4886 13.8212 28.8406 14.7908C27.9091 17.5581 25.2925 19.5572 22.2148 19.5572H22.2129Z"
                                      fill="#7F8C8D"
                                    />
                                    <path
                                      d="M12.9521 8.75327C13.2281 8.47727 13.5059 8.25575 13.7419 8.10867C13.15 7.12451 11.3596 4.61509 9.15525 5.94425C8.25825 6.48354 7.68991 7.43501 7.5628 8.47364C7.47383 9.2054 7.51741 10.1405 7.98407 11.0938C8.0458 11.2191 8.22375 11.2282 8.29638 11.1083C8.64683 10.52 9.55472 9.20722 10.6823 9.20722C11.2016 9.20722 11.7845 9.34522 12.3184 9.52316C12.4654 9.29074 12.6833 9.02019 12.9521 8.75327Z"
                                      fill="#7F8C8D"
                                    />
                                    <path
                                      d="M14.1216 8.62622C13.9763 8.8423 13.7748 9.08743 13.5314 9.33075C13.3571 9.50506 13.1828 9.65759 13.0176 9.78469C13.6386 10.0425 14.0834 10.2877 14.0834 10.2877L14.63 8.85319C14.63 8.85319 14.4085 8.84412 14.1216 8.62622Z"
                                      fill="#7F8C8D"
                                    />
                                    <path
                                      d="M31.3524 8.75327C31.0764 8.47727 30.7986 8.25575 30.5625 8.10867C31.1544 7.12451 32.9448 4.61509 35.1492 5.94425C36.0462 6.48354 36.6145 7.43501 36.7416 8.47364C36.8306 9.2054 36.787 10.1405 36.3204 11.0938C36.2586 11.2191 36.0807 11.2282 36.008 11.1083C35.6576 10.52 34.7497 9.20722 33.6221 9.20722C33.1028 9.20722 32.5199 9.34522 31.9861 9.52316C31.839 9.29074 31.6211 9.02019 31.3524 8.75327Z"
                                      fill="#7F8C8D"
                                    />
                                    <path
                                      d="M30.1842 8.62622C30.3295 8.8423 30.531 9.08743 30.7743 9.33075C30.9486 9.50506 31.123 9.65759 31.2882 9.78469C30.6672 10.0425 30.2223 10.2877 30.2223 10.2877L29.6758 8.85319C29.6758 8.85319 29.8973 8.84412 30.1842 8.62622Z"
                                      fill="#7F8C8D"
                                    />
                                    <path
                                      d="M22.125 28.4146C23.7465 26.9438 30.3796 25.7 30.3796 25.7C28.8743 23.3104 25.8928 22.2791 25.8928 22.2791C24.8396 23.1815 22.8586 23.2814 22.2085 23.2904C22.2085 23.2904 22.1704 23.2904 22.1014 23.2904C22.0324 23.2904 21.9943 23.2904 21.9943 23.2904C21.3442 23.2832 19.3632 23.1815 18.3101 22.2791C18.3101 22.2791 15.3285 23.3086 13.8232 25.7C13.8232 25.7 20.4581 26.942 22.0778 28.4146V28.4545C22.0778 28.4545 22.0942 28.4418 22.1014 28.4346C22.1087 28.4418 22.1178 28.4473 22.1232 28.4545V28.4146H22.125Z"
                                      fill="#7F8C8D"
                                    />
                                    <path
                                      d="M22.5058 39.3603C22.2661 39.5637 21.9157 39.571 21.6596 39.3876C17.7975 36.6512 12.1395 36.3679 10.6796 36.3606C10.4798 36.3606 10.3182 36.1972 10.3182 35.9975V34.81C10.3182 34.6084 10.4816 34.4468 10.6814 34.4468H12.0142C12.7822 34.4468 13.4032 33.824 13.4032 33.0577V29.5859C13.4032 28.8179 12.7804 28.1969 12.0142 28.1969H10.6796C10.4798 28.1969 10.3164 28.0334 10.3164 27.8337V26.6099C10.3164 26.4174 10.4671 26.2594 10.6596 26.2467C15.0048 25.9453 20.3178 28.56 21.6923 29.2809C21.9029 29.3917 22.1535 29.3862 22.3605 29.27C23.6243 28.5618 28.3199 26.1359 33.2716 26.2122C33.4695 26.2158 33.6275 26.3793 33.6275 26.5772V27.7938C33.6275 27.9953 33.4641 28.1569 33.2643 28.1569H31.7663C30.9982 28.1569 30.3772 28.7797 30.3772 29.546V33.2393C30.3772 34.0074 31 34.6284 31.7663 34.6284H33.2661C33.4659 34.6284 33.6293 34.79 33.6293 34.9915V36.0556C33.6293 36.2535 33.4713 36.4151 33.2734 36.4188C31.7427 36.4405 25.6598 36.6984 22.5076 39.364L22.5058 39.3603Z"
                                      fill="#7F8C8D"
                                    />
                                    <path
                                      d="M12.3174 29.1809C13.0437 29.9072 12.3174 30.6335 12.3174 30.6335C12.8621 31.3599 12.3174 32.2678 12.3174 32.2678C12.8621 33.1756 11.9542 33.7204 11.9542 33.7204C11.9542 33.7204 9.23055 33.902 8.68581 33.4771C8.14108 33.0522 7.77792 30.452 8.68581 29.3625C9.59371 28.273 10.32 29.1355 10.32 29.1355C10.5415 29.0683 10.8539 29.0012 11.2279 28.9993C11.6946 28.9957 12.0723 29.0956 12.3174 29.1809Z"
                                      fill="#7F8C8D"
                                    />
                                    <path
                                      d="M31.6988 29.1809C30.9725 29.9072 31.6988 30.6335 31.6988 30.6335C31.154 31.3599 31.6988 32.2678 31.6988 32.2678C31.154 33.1756 32.0619 33.7204 32.0619 33.7204C32.0619 33.7204 34.7856 33.902 35.3304 33.4771C35.8751 33.0522 36.2383 30.452 35.3304 29.3625C34.4225 28.273 33.6961 29.1355 33.6961 29.1355C33.4746 29.0683 33.1623 29.0012 32.7883 28.9993C32.3216 28.9957 31.9439 29.0956 31.6988 29.1809Z"
                                      fill="#7F8C8D"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1440_1589">
                                      <rect
                                        width="29.256"
                                        height="35.397"
                                        fill="white"
                                        transform="translate(7.52539 4.12305)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </div>
                              <h3 className="text-white font-semibold text-sm md:text-base text-center">
                                Buku Anak Indonesia
                              </h3>
                            </div>
                            <div
                              className="p-2 md:p-6 gap-y-6 md:gap-y-[1.5rem] md:h-[12.5rem] md:w-[8.5rem] flex flex-col rounded-xl md:rounded-3xl bg-no-repeat bg-cover bg-left-top  bg-[url('/src/assets/images/icon/bg-good-read.svg')] cursor-pointer"
                              onClick={() => this.gotoSearch(36)}
                            >
                              <div className="p-2 w-12 h-12 md:w-15 md:h-15 flex items-center justify-start bg-white rounded-md md:rounded-xl">
                                <svg
                                  className="md:w-16 md:h-16"
                                  width="39"
                                  height="39"
                                  viewBox="0 0 39 39"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M15.375 27.375H9.875C8.57864 27.375 7.93046 27.375 7.52773 26.9723C7.125 26.5695 7.125 25.9214 7.125 24.625V12.25C7.125 10.9536 7.125 10.3055 7.52773 9.90273C7.93046 9.5 8.57864 9.5 9.875 9.5H11.25C15.1391 9.5 17.0836 9.5 18.2918 10.7082C19.5 11.9164 19.5 13.8609 19.5 17.75V31.5C19.5 29.2218 17.6532 27.375 15.375 27.375ZM14.101 14.937C13.7783 14.2572 12.8458 14.2572 12.5231 14.937L11.9654 16.112C11.8372 16.382 11.5895 16.5691 11.303 16.6124L10.0559 16.8008C9.33425 16.9098 9.04612 17.8318 9.56828 18.361L10.4707 19.2756C10.6781 19.4857 10.7727 19.7885 10.7237 20.0852L10.5107 21.3766C10.3874 22.1238 11.1418 22.6937 11.7872 22.3409L12.9027 21.7312C13.159 21.5911 13.4651 21.5911 13.7214 21.7312L14.8369 22.3409C15.4823 22.6937 16.2367 22.1238 16.1134 21.3766L15.9004 20.0852C15.8514 19.7885 15.946 19.4857 16.1534 19.2756L17.0558 18.361C17.578 17.8318 17.2899 16.9098 16.5682 16.8008L15.3211 16.6124C15.0346 16.5691 14.7869 16.382 14.6587 16.112L14.101 14.937Z"
                                    fill="#FF8300"
                                  />
                                  <path
                                    d="M29.125 27.375H25C22.7218 27.375 20.875 29.2218 20.875 31.5V17.75C20.875 13.8609 20.875 11.9164 22.0832 10.7082C23.2914 9.5 25.2359 9.5 29.125 9.5C30.4214 9.5 31.0695 9.5 31.4723 9.90273C31.875 10.3055 31.875 10.9536 31.875 12.25V24.625C31.875 25.9214 31.875 26.5695 31.4723 26.9723C31.0695 27.375 30.4214 27.375 29.125 27.375Z"
                                    fill="#FF8300"
                                  />
                                </svg>
                              </div>
                              <h3 className="text-white font-semibold text-xs md:text-base text-center">
                                Bacaan Bermutu Anak Indonesia
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {this.state.hybrid_umum && (
                    <>
                      <div className="flex justify-between px-4 lg:px-6 items-center mt-4 lg:mt-6 mb-2">
                        <h3 className="text-base lg:text-xl text-black font-semibold">
                          Koleksi Buku Digital Titikbaca
                        </h3>
                      </div>
                      <div className="px-4 lg:px-6">
                        <div className="grid grid-cols-1">
                          <button
                            onClick={() => this.gotoSearch(35)}
                            className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                          >
                            <div className="rounded-l-2xl">
                              <div
                                className="h-24 w-32 bg-no-repeat bg-left"
                                style={{
                                  backgroundImage: `url(${iconBukuDigital})`,
                                }}
                              ></div>
                            </div>
                            <div className="w-7/12 p-2 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                              Koleksi Buku Digital Titikbaca
                              <br />
                              <span className="text-xs">
                                Informasi Koleksi Buku
                              </span>
                            </div>
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="px-4 lg:px-6">
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-4 mt-5">
                      {this.state.datakategori["CAT001"] == 1 && (
                        <button
                          onClick={() => this.gotoSearch(8)}
                          className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                        >
                          <div className="rounded-l-2xl">
                            <div
                              className="h-24 w-20 bg-no-repeat bg-left"
                              style={{
                                backgroundImage: `url(${iconIlmuTerapan})`,
                              }}
                            ></div>
                          </div>
                          <div className="w-7/12 p-2 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                            Ilmu Terapan
                          </div>
                        </button>
                      )}
                      {this.state.datakategori["CAT002"] == 1 && (
                        <button
                          onClick={() => this.gotoSearch(9)}
                          className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                        >
                          <div className="rounded-l-2xl">
                            <div
                              className="h-24 w-20 bg-no-repeat bg-left"
                              style={{
                                backgroundImage: `url(${iconKesehatan})`,
                              }}
                            ></div>
                          </div>
                          <div className="w-7/12 p-2 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                            Kesehatan
                          </div>
                        </button>
                      )}

                      {this.state.hybrid_umum ? (
                        <>
                          {this.state.datakategori["cat003"] == 1 && (
                            <button
                              onClick={() => this.gotoSearch(10)}
                              className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                            >
                              <div className="rounded-l-2xl">
                                <div
                                  className="h-24 w-20 bg-no-repeat bg-left"
                                  style={{
                                    backgroundImage: `url(${iconUmum})`,
                                  }}
                                ></div>
                              </div>
                              <div className="w-7/12 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                                Koleksi Umum
                              </div>
                            </button>
                          )}
                        </>
                      ) : (
                        <>
                          <button
                            onClick={() => this.gotoSearch(31)}
                            className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                          >
                            <div className="rounded-l-2xl">
                              <div
                                className="h-24 w-20 bg-no-repeat bg-left"
                                style={{
                                  backgroundImage: `url(${iconBukuAjar})`,
                                }}
                              ></div>
                            </div>
                            <div className="w-7/12 p-2 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                              Buku Ajar Sekolah
                            </div>
                          </button>
                          <button
                            onClick={() => this.gotoSearch(14)}
                            className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                          >
                            <div className="rounded-l-2xl">
                              <div
                                className="h-24 w-20 bg-no-repeat bg-left"
                                style={{
                                  backgroundImage: `url(${iconKemendikbud})`,
                                }}
                              ></div>
                            </div>
                            <div className="w-7/12 p-2 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                              BSE Kemendikbud
                            </div>
                          </button>
                        </>
                      )}
                    </div>
                  </div>

                  {this.state.hybrid_smp && (
                    <>
                      <div className="px-4 lg:px-6 mt-4 block sm:block md:hidden lg:hidden">
                        <div className="grid grid-cols-1 w-full">
                          <div
                            className="w-full md:h-[9.5rem] h-[6rem] flex items-center py-4 px-5 md:px-10 rounded-3xl  // warna dasar hijaubg-no-repeat bg-cover bg-right bg-[url('/src/assets/images/icon/bg-good-read.svg')] cursor-pointer"
                            onClick={() => this.gotoSearch(36)}
                          >
                            <div className="p-2 w-12 h-12 md:w-20 md:h-20 flex items-center justify-center bg-white rounded-md md:rounded-xl">
                              <svg
                                className="md:w-16 md:h-16"
                                width="39"
                                height="39"
                                viewBox="0 0 39 39"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M15.375 27.375H9.875C8.57864 27.375 7.93046 27.375 7.52773 26.9723C7.125 26.5695 7.125 25.9214 7.125 24.625V12.25C7.125 10.9536 7.125 10.3055 7.52773 9.90273C7.93046 9.5 8.57864 9.5 9.875 9.5H11.25C15.1391 9.5 17.0836 9.5 18.2918 10.7082C19.5 11.9164 19.5 13.8609 19.5 17.75V31.5C19.5 29.2218 17.6532 27.375 15.375 27.375ZM14.101 14.937C13.7783 14.2572 12.8458 14.2572 12.5231 14.937L11.9654 16.112C11.8372 16.382 11.5895 16.5691 11.303 16.6124L10.0559 16.8008C9.33425 16.9098 9.04612 17.8318 9.56828 18.361L10.4707 19.2756C10.6781 19.4857 10.7727 19.7885 10.7237 20.0852L10.5107 21.3766C10.3874 22.1238 11.1418 22.6937 11.7872 22.3409L12.9027 21.7312C13.159 21.5911 13.4651 21.5911 13.7214 21.7312L14.8369 22.3409C15.4823 22.6937 16.2367 22.1238 16.1134 21.3766L15.9004 20.0852C15.8514 19.7885 15.946 19.4857 16.1534 19.2756L17.0558 18.361C17.578 17.8318 17.2899 16.9098 16.5682 16.8008L15.3211 16.6124C15.0346 16.5691 14.7869 16.382 14.6587 16.112L14.101 14.937Z"
                                  fill="#FF8300"
                                />
                                <path
                                  d="M29.125 27.375H25C22.7218 27.375 20.875 29.2218 20.875 31.5V17.75C20.875 13.8609 20.875 11.9164 22.0832 10.7082C23.2914 9.5 25.2359 9.5 29.125 9.5C30.4214 9.5 31.0695 9.5 31.4723 9.90273C31.875 10.3055 31.875 10.9536 31.875 12.25V24.625C31.875 25.9214 31.875 26.5695 31.4723 26.9723C31.0695 27.375 30.4214 27.375 29.125 27.375Z"
                                  fill="#FF8300"
                                />
                              </svg>
                            </div>
                            <div className="w-7/12  p-1 lg:p-4 text-white text-start ml-5 text-base md:text-2xl lg:text-xxl font-semibold">
                              Bacaan Bermutu Anak Indonesia
                            </div>
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-2 mt-3">
                          <button
                            className="p-3 md:p-6 gap-y-6 md:h-28 h-24 items-center w-full flex flex-row rounded-xl bg-no-repeat bg-cover bg-right  bg-[url('/src/assets/images/icon/bg-buku-anak.svg')] cursor-pointer"
                            onClick={() => this.gotoSearch(38)}
                          >
                            <div className="p-2 w-12 h-12 md:w-16 md:h-16 flex  items-center justify-start bg-white rounded-md md:rounded-xl">
                              <svg
                                className="md:w-16 md:h-16"
                                width="45"
                                height="45"
                                viewBox="0 0 45 45"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_1440_1589)">
                                  <path
                                    d="M22.2129 4.12305C17.55 4.12305 13.7695 7.90352 13.7695 12.5665C13.7695 17.2294 17.55 21.0099 22.2129 21.0099C26.8759 21.0099 30.6564 17.2294 30.6564 12.5665C30.6564 7.90352 26.8759 4.12305 22.2129 4.12305ZM22.2129 19.5572C19.1207 19.5572 16.4932 17.5399 15.5744 14.7527C16.3062 14.4258 18.9227 13.1602 20.0104 11.2954C20.0104 11.2954 20.2828 12.3667 20.0104 13.6015C20.0104 13.6015 22.8249 11.7494 23.5512 10.4783C23.5512 10.4783 25.4886 13.8212 28.8406 14.7908C27.9091 17.5581 25.2925 19.5572 22.2148 19.5572H22.2129Z"
                                    fill="#7F8C8D"
                                  />
                                  <path
                                    d="M12.9521 8.75327C13.2281 8.47727 13.5059 8.25575 13.7419 8.10867C13.15 7.12451 11.3596 4.61509 9.15525 5.94425C8.25825 6.48354 7.68991 7.43501 7.5628 8.47364C7.47383 9.2054 7.51741 10.1405 7.98407 11.0938C8.0458 11.2191 8.22375 11.2282 8.29638 11.1083C8.64683 10.52 9.55472 9.20722 10.6823 9.20722C11.2016 9.20722 11.7845 9.34522 12.3184 9.52316C12.4654 9.29074 12.6833 9.02019 12.9521 8.75327Z"
                                    fill="#7F8C8D"
                                  />
                                  <path
                                    d="M14.1216 8.62622C13.9763 8.8423 13.7748 9.08743 13.5314 9.33075C13.3571 9.50506 13.1828 9.65759 13.0176 9.78469C13.6386 10.0425 14.0834 10.2877 14.0834 10.2877L14.63 8.85319C14.63 8.85319 14.4085 8.84412 14.1216 8.62622Z"
                                    fill="#7F8C8D"
                                  />
                                  <path
                                    d="M31.3524 8.75327C31.0764 8.47727 30.7986 8.25575 30.5625 8.10867C31.1544 7.12451 32.9448 4.61509 35.1492 5.94425C36.0462 6.48354 36.6145 7.43501 36.7416 8.47364C36.8306 9.2054 36.787 10.1405 36.3204 11.0938C36.2586 11.2191 36.0807 11.2282 36.008 11.1083C35.6576 10.52 34.7497 9.20722 33.6221 9.20722C33.1028 9.20722 32.5199 9.34522 31.9861 9.52316C31.839 9.29074 31.6211 9.02019 31.3524 8.75327Z"
                                    fill="#7F8C8D"
                                  />
                                  <path
                                    d="M30.1842 8.62622C30.3295 8.8423 30.531 9.08743 30.7743 9.33075C30.9486 9.50506 31.123 9.65759 31.2882 9.78469C30.6672 10.0425 30.2223 10.2877 30.2223 10.2877L29.6758 8.85319C29.6758 8.85319 29.8973 8.84412 30.1842 8.62622Z"
                                    fill="#7F8C8D"
                                  />
                                  <path
                                    d="M22.125 28.4146C23.7465 26.9438 30.3796 25.7 30.3796 25.7C28.8743 23.3104 25.8928 22.2791 25.8928 22.2791C24.8396 23.1815 22.8586 23.2814 22.2085 23.2904C22.2085 23.2904 22.1704 23.2904 22.1014 23.2904C22.0324 23.2904 21.9943 23.2904 21.9943 23.2904C21.3442 23.2832 19.3632 23.1815 18.3101 22.2791C18.3101 22.2791 15.3285 23.3086 13.8232 25.7C13.8232 25.7 20.4581 26.942 22.0778 28.4146V28.4545C22.0778 28.4545 22.0942 28.4418 22.1014 28.4346C22.1087 28.4418 22.1178 28.4473 22.1232 28.4545V28.4146H22.125Z"
                                    fill="#7F8C8D"
                                  />
                                  <path
                                    d="M22.5058 39.3603C22.2661 39.5637 21.9157 39.571 21.6596 39.3876C17.7975 36.6512 12.1395 36.3679 10.6796 36.3606C10.4798 36.3606 10.3182 36.1972 10.3182 35.9975V34.81C10.3182 34.6084 10.4816 34.4468 10.6814 34.4468H12.0142C12.7822 34.4468 13.4032 33.824 13.4032 33.0577V29.5859C13.4032 28.8179 12.7804 28.1969 12.0142 28.1969H10.6796C10.4798 28.1969 10.3164 28.0334 10.3164 27.8337V26.6099C10.3164 26.4174 10.4671 26.2594 10.6596 26.2467C15.0048 25.9453 20.3178 28.56 21.6923 29.2809C21.9029 29.3917 22.1535 29.3862 22.3605 29.27C23.6243 28.5618 28.3199 26.1359 33.2716 26.2122C33.4695 26.2158 33.6275 26.3793 33.6275 26.5772V27.7938C33.6275 27.9953 33.4641 28.1569 33.2643 28.1569H31.7663C30.9982 28.1569 30.3772 28.7797 30.3772 29.546V33.2393C30.3772 34.0074 31 34.6284 31.7663 34.6284H33.2661C33.4659 34.6284 33.6293 34.79 33.6293 34.9915V36.0556C33.6293 36.2535 33.4713 36.4151 33.2734 36.4188C31.7427 36.4405 25.6598 36.6984 22.5076 39.364L22.5058 39.3603Z"
                                    fill="#7F8C8D"
                                  />
                                  <path
                                    d="M12.3174 29.1809C13.0437 29.9072 12.3174 30.6335 12.3174 30.6335C12.8621 31.3599 12.3174 32.2678 12.3174 32.2678C12.8621 33.1756 11.9542 33.7204 11.9542 33.7204C11.9542 33.7204 9.23055 33.902 8.68581 33.4771C8.14108 33.0522 7.77792 30.452 8.68581 29.3625C9.59371 28.273 10.32 29.1355 10.32 29.1355C10.5415 29.0683 10.8539 29.0012 11.2279 28.9993C11.6946 28.9957 12.0723 29.0956 12.3174 29.1809Z"
                                    fill="#7F8C8D"
                                  />
                                  <path
                                    d="M31.6988 29.1809C30.9725 29.9072 31.6988 30.6335 31.6988 30.6335C31.154 31.3599 31.6988 32.2678 31.6988 32.2678C31.154 33.1756 32.0619 33.7204 32.0619 33.7204C32.0619 33.7204 34.7856 33.902 35.3304 33.4771C35.8751 33.0522 36.2383 30.452 35.3304 29.3625C34.4225 28.273 33.6961 29.1355 33.6961 29.1355C33.4746 29.0683 33.1623 29.0012 32.7883 28.9993C32.3216 28.9957 31.9439 29.0956 31.6988 29.1809Z"
                                    fill="#7F8C8D"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1440_1589">
                                    <rect
                                      width="29.256"
                                      height="35.397"
                                      fill="white"
                                      transform="translate(7.52539 4.12305)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <div className="w-7/12 ml-2 p-1 lg:p-4 text-white text-sm md:text-md lg:text-lg text-left font-semibold">
                              Buku Anak Indonesia
                            </div>
                          </button>
                          <button
                            className="py-3 px-3 md:p-6 gap-y-6 md:h-28 h-24  items-center w-full flex flex-row rounded-xl bg-no-repeat bg-cover bg-right bg-[url('/src/assets/images/icon/bg-perpusnas-press.svg')] cursor-pointer"
                            onClick={() => this.gotoSearch(37)}
                          >
                            <div className="p-2 w-12 h-12 md:w-16 md:h-16 flex items-center justify-start bg-white rounded-md md:rounded-xl">
                              <svg
                                className="md:w-16 h-16"
                                width="37"
                                height="38"
                                viewBox="0 0 37 38"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M18.4952 3.55988C18.9411 4.23679 19.3707 4.925 19.8129 5.60464C20.6215 6.86038 21.4637 8.10133 22.1255 9.44076C22.5551 10.3131 22.8897 11.2422 23.0037 12.2092C23.0899 12.8639 23.063 13.5283 22.9645 14.1804L23.0282 14.1539C22.8577 14.2734 22.7568 14.4587 22.633 14.6194C21.3501 16.3376 20.074 18.0612 18.7884 19.7775C18.6946 19.2948 18.5558 18.8187 18.3354 18.3761C17.9668 17.614 17.4422 16.939 16.9078 16.2839C16.2907 15.5354 15.6538 14.8028 15.0537 14.0406C16.2001 10.5466 17.3465 7.05306 18.4952 3.55988Z"
                                  fill="#A3D513"
                                />
                                <path
                                  d="M23.0295 14.1538C24.1102 13.6952 25.2966 13.4948 26.4702 13.5224C27.9327 13.5415 29.3671 13.8614 30.79 14.1655C32.0709 14.4605 33.3636 14.7015 34.654 14.9502C31.5716 17.1503 28.4806 19.3398 25.3978 21.5399C24.5169 21.239 23.6581 20.8817 22.7886 20.552C21.514 20.0678 20.1544 19.6419 18.7715 19.8023L18.7897 19.7774C20.0753 18.0611 21.3515 16.3375 22.6343 14.6193C22.7581 14.4586 22.859 14.2733 23.0295 14.1538Z"
                                  fill="#A3D513"
                                />
                                <path
                                  d="M2.32715 14.6366C5.08829 14.6354 7.84943 14.6455 10.6106 14.6451C11.7625 14.6424 12.9144 14.6591 14.0667 14.6479C14.4888 15.1644 14.9066 15.6848 15.3401 16.1928C15.8425 16.7923 16.3552 17.3859 16.7986 18.0301C17.1938 18.6109 17.5281 19.2516 17.6396 19.9491C17.7104 20.3512 17.6891 20.7611 17.7144 21.1671C17.7195 21.2547 17.6586 21.3228 17.6103 21.3894C15.8836 23.6895 14.1787 26.0052 12.4643 28.3139C11.2435 29.9558 10.0271 31.6008 8.80871 33.2442C8.75491 33.3209 8.70349 33.4018 8.62793 33.4602C8.64534 33.3213 8.70428 33.1928 8.74542 33.0601C9.98754 29.3259 11.2304 25.5926 12.471 21.8581C9.83089 19.9803 7.19119 18.1021 4.55149 16.2236C3.81097 15.6934 3.06332 15.1726 2.32715 14.6366Z"
                                  fill="#A3D513"
                                />
                                <path
                                  d="M17.7152 21.1671C18.2026 21.0515 18.6923 20.9114 19.1974 20.9082C20.0831 20.8646 20.9518 21.1001 21.781 21.3831C22.9349 21.7876 24.0555 22.28 25.2162 22.6673C26.4199 26.3037 27.6347 29.937 28.8405 33.5731C28.206 33.1418 27.592 32.6801 26.9646 32.2383C24.2138 30.2613 21.4562 28.2928 18.7081 26.3123C15.3318 28.7346 11.9552 31.1562 8.57812 33.5774C8.58841 33.5295 8.59909 33.4816 8.60898 33.4345L8.62876 33.4602C8.70431 33.4018 8.75574 33.3209 8.80954 33.2442C10.0279 31.6007 11.2443 29.9557 12.4651 28.3138C14.1795 26.0052 15.8845 23.6895 17.6112 21.3894C17.6594 21.3228 17.7203 21.2547 17.7152 21.1671Z"
                                  fill="#A3D513"
                                />
                              </svg>
                            </div>
                            <div className="w-7/12 ml-2 p-1 lg:p-4 text-white text-xs md:text-md lg:text-lg text-left font-semibold">
                              Perpusnas Press
                            </div>
                          </button>
                        </div>
                      </div>
                      <div className="px-4 lg:px-6 mt-4 hidden sm:hidden md:block lg:block">
                        <div className="grid grid-cols-2 gap-4 w-full px-4">
                          <div className="cols-span-2 gap-2">
                            <div
                              className="w-full md:h-[9.5rem] h-[6rem] flex items-center py-4 px-5 md:px-10 rounded-3xl  // warna dasar hijaubg-no-repeat bg-cover bg-right bg-[url('/src/assets/images/icon/bg-good-read.svg')] cursor-pointer"
                              onClick={() => this.gotoSearch(36)}
                            >
                              <div className="p-2 w-12 h-12 md:w-20 md:h-20 flex items-center justify-center bg-white rounded-md md:rounded-xl">
                                <svg
                                  className="md:w-16 md:h-16"
                                  width="39"
                                  height="39"
                                  viewBox="0 0 39 39"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M15.375 27.375H9.875C8.57864 27.375 7.93046 27.375 7.52773 26.9723C7.125 26.5695 7.125 25.9214 7.125 24.625V12.25C7.125 10.9536 7.125 10.3055 7.52773 9.90273C7.93046 9.5 8.57864 9.5 9.875 9.5H11.25C15.1391 9.5 17.0836 9.5 18.2918 10.7082C19.5 11.9164 19.5 13.8609 19.5 17.75V31.5C19.5 29.2218 17.6532 27.375 15.375 27.375ZM14.101 14.937C13.7783 14.2572 12.8458 14.2572 12.5231 14.937L11.9654 16.112C11.8372 16.382 11.5895 16.5691 11.303 16.6124L10.0559 16.8008C9.33425 16.9098 9.04612 17.8318 9.56828 18.361L10.4707 19.2756C10.6781 19.4857 10.7727 19.7885 10.7237 20.0852L10.5107 21.3766C10.3874 22.1238 11.1418 22.6937 11.7872 22.3409L12.9027 21.7312C13.159 21.5911 13.4651 21.5911 13.7214 21.7312L14.8369 22.3409C15.4823 22.6937 16.2367 22.1238 16.1134 21.3766L15.9004 20.0852C15.8514 19.7885 15.946 19.4857 16.1534 19.2756L17.0558 18.361C17.578 17.8318 17.2899 16.9098 16.5682 16.8008L15.3211 16.6124C15.0346 16.5691 14.7869 16.382 14.6587 16.112L14.101 14.937Z"
                                    fill="#FF8300"
                                  />
                                  <path
                                    d="M29.125 27.375H25C22.7218 27.375 20.875 29.2218 20.875 31.5V17.75C20.875 13.8609 20.875 11.9164 22.0832 10.7082C23.2914 9.5 25.2359 9.5 29.125 9.5C30.4214 9.5 31.0695 9.5 31.4723 9.90273C31.875 10.3055 31.875 10.9536 31.875 12.25V24.625C31.875 25.9214 31.875 26.5695 31.4723 26.9723C31.0695 27.375 30.4214 27.375 29.125 27.375Z"
                                    fill="#FF8300"
                                  />
                                </svg>
                              </div>
                              <div className="w-7/12  p-1 lg:p-4 text-white text-start ml-5 text-base md:text-2xl lg:text-xxl font-semibold">
                                Bacaan Bermutu Anak Indonesia
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-2">
                              <button
                                className="p-3 md:p-6 gap-y-6 md:h-28 h-24 items-center w-full flex flex-row rounded-xl bg-no-repeat bg-cover bg-right  bg-[url('/src/assets/images/icon/bg-buku-anak.svg')] cursor-pointer"
                                onClick={() => this.gotoSearch(38)}
                              >
                                <div className="p-2 w-12 h-12 md:w-16 md:h-16 flex  items-center justify-start bg-white rounded-md md:rounded-xl">
                                  <svg
                                    className="md:w-16 md:h-16"
                                    width="45"
                                    height="45"
                                    viewBox="0 0 45 45"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clipPath="url(#clip0_1440_1589)">
                                      <path
                                        d="M22.2129 4.12305C17.55 4.12305 13.7695 7.90352 13.7695 12.5665C13.7695 17.2294 17.55 21.0099 22.2129 21.0099C26.8759 21.0099 30.6564 17.2294 30.6564 12.5665C30.6564 7.90352 26.8759 4.12305 22.2129 4.12305ZM22.2129 19.5572C19.1207 19.5572 16.4932 17.5399 15.5744 14.7527C16.3062 14.4258 18.9227 13.1602 20.0104 11.2954C20.0104 11.2954 20.2828 12.3667 20.0104 13.6015C20.0104 13.6015 22.8249 11.7494 23.5512 10.4783C23.5512 10.4783 25.4886 13.8212 28.8406 14.7908C27.9091 17.5581 25.2925 19.5572 22.2148 19.5572H22.2129Z"
                                        fill="#7F8C8D"
                                      />
                                      <path
                                        d="M12.9521 8.75327C13.2281 8.47727 13.5059 8.25575 13.7419 8.10867C13.15 7.12451 11.3596 4.61509 9.15525 5.94425C8.25825 6.48354 7.68991 7.43501 7.5628 8.47364C7.47383 9.2054 7.51741 10.1405 7.98407 11.0938C8.0458 11.2191 8.22375 11.2282 8.29638 11.1083C8.64683 10.52 9.55472 9.20722 10.6823 9.20722C11.2016 9.20722 11.7845 9.34522 12.3184 9.52316C12.4654 9.29074 12.6833 9.02019 12.9521 8.75327Z"
                                        fill="#7F8C8D"
                                      />
                                      <path
                                        d="M14.1216 8.62622C13.9763 8.8423 13.7748 9.08743 13.5314 9.33075C13.3571 9.50506 13.1828 9.65759 13.0176 9.78469C13.6386 10.0425 14.0834 10.2877 14.0834 10.2877L14.63 8.85319C14.63 8.85319 14.4085 8.84412 14.1216 8.62622Z"
                                        fill="#7F8C8D"
                                      />
                                      <path
                                        d="M31.3524 8.75327C31.0764 8.47727 30.7986 8.25575 30.5625 8.10867C31.1544 7.12451 32.9448 4.61509 35.1492 5.94425C36.0462 6.48354 36.6145 7.43501 36.7416 8.47364C36.8306 9.2054 36.787 10.1405 36.3204 11.0938C36.2586 11.2191 36.0807 11.2282 36.008 11.1083C35.6576 10.52 34.7497 9.20722 33.6221 9.20722C33.1028 9.20722 32.5199 9.34522 31.9861 9.52316C31.839 9.29074 31.6211 9.02019 31.3524 8.75327Z"
                                        fill="#7F8C8D"
                                      />
                                      <path
                                        d="M30.1842 8.62622C30.3295 8.8423 30.531 9.08743 30.7743 9.33075C30.9486 9.50506 31.123 9.65759 31.2882 9.78469C30.6672 10.0425 30.2223 10.2877 30.2223 10.2877L29.6758 8.85319C29.6758 8.85319 29.8973 8.84412 30.1842 8.62622Z"
                                        fill="#7F8C8D"
                                      />
                                      <path
                                        d="M22.125 28.4146C23.7465 26.9438 30.3796 25.7 30.3796 25.7C28.8743 23.3104 25.8928 22.2791 25.8928 22.2791C24.8396 23.1815 22.8586 23.2814 22.2085 23.2904C22.2085 23.2904 22.1704 23.2904 22.1014 23.2904C22.0324 23.2904 21.9943 23.2904 21.9943 23.2904C21.3442 23.2832 19.3632 23.1815 18.3101 22.2791C18.3101 22.2791 15.3285 23.3086 13.8232 25.7C13.8232 25.7 20.4581 26.942 22.0778 28.4146V28.4545C22.0778 28.4545 22.0942 28.4418 22.1014 28.4346C22.1087 28.4418 22.1178 28.4473 22.1232 28.4545V28.4146H22.125Z"
                                        fill="#7F8C8D"
                                      />
                                      <path
                                        d="M22.5058 39.3603C22.2661 39.5637 21.9157 39.571 21.6596 39.3876C17.7975 36.6512 12.1395 36.3679 10.6796 36.3606C10.4798 36.3606 10.3182 36.1972 10.3182 35.9975V34.81C10.3182 34.6084 10.4816 34.4468 10.6814 34.4468H12.0142C12.7822 34.4468 13.4032 33.824 13.4032 33.0577V29.5859C13.4032 28.8179 12.7804 28.1969 12.0142 28.1969H10.6796C10.4798 28.1969 10.3164 28.0334 10.3164 27.8337V26.6099C10.3164 26.4174 10.4671 26.2594 10.6596 26.2467C15.0048 25.9453 20.3178 28.56 21.6923 29.2809C21.9029 29.3917 22.1535 29.3862 22.3605 29.27C23.6243 28.5618 28.3199 26.1359 33.2716 26.2122C33.4695 26.2158 33.6275 26.3793 33.6275 26.5772V27.7938C33.6275 27.9953 33.4641 28.1569 33.2643 28.1569H31.7663C30.9982 28.1569 30.3772 28.7797 30.3772 29.546V33.2393C30.3772 34.0074 31 34.6284 31.7663 34.6284H33.2661C33.4659 34.6284 33.6293 34.79 33.6293 34.9915V36.0556C33.6293 36.2535 33.4713 36.4151 33.2734 36.4188C31.7427 36.4405 25.6598 36.6984 22.5076 39.364L22.5058 39.3603Z"
                                        fill="#7F8C8D"
                                      />
                                      <path
                                        d="M12.3174 29.1809C13.0437 29.9072 12.3174 30.6335 12.3174 30.6335C12.8621 31.3599 12.3174 32.2678 12.3174 32.2678C12.8621 33.1756 11.9542 33.7204 11.9542 33.7204C11.9542 33.7204 9.23055 33.902 8.68581 33.4771C8.14108 33.0522 7.77792 30.452 8.68581 29.3625C9.59371 28.273 10.32 29.1355 10.32 29.1355C10.5415 29.0683 10.8539 29.0012 11.2279 28.9993C11.6946 28.9957 12.0723 29.0956 12.3174 29.1809Z"
                                        fill="#7F8C8D"
                                      />
                                      <path
                                        d="M31.6988 29.1809C30.9725 29.9072 31.6988 30.6335 31.6988 30.6335C31.154 31.3599 31.6988 32.2678 31.6988 32.2678C31.154 33.1756 32.0619 33.7204 32.0619 33.7204C32.0619 33.7204 34.7856 33.902 35.3304 33.4771C35.8751 33.0522 36.2383 30.452 35.3304 29.3625C34.4225 28.273 33.6961 29.1355 33.6961 29.1355C33.4746 29.0683 33.1623 29.0012 32.7883 28.9993C32.3216 28.9957 31.9439 29.0956 31.6988 29.1809Z"
                                        fill="#7F8C8D"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_1440_1589">
                                        <rect
                                          width="29.256"
                                          height="35.397"
                                          fill="white"
                                          transform="translate(7.52539 4.12305)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </div>
                                <div className="w-7/12 ml-2 p-1 lg:p-4 text-white text-sm md:text-md lg:text-lg text-left font-semibold">
                                  Buku Anak Indonesia
                                </div>
                              </button>
                              <button
                                className="py-3 px-3 md:p-6 gap-y-6 md:h-28 h-24  items-center w-full flex flex-row rounded-xl bg-no-repeat bg-cover bg-right bg-[url('/src/assets/images/icon/bg-perpusnas-press.svg')] cursor-pointer"
                                onClick={() => this.gotoSearch(37)}
                              >
                                <div className="p-2 w-12 h-12 md:w-16 md:h-16 flex items-center justify-start bg-white rounded-md md:rounded-xl">
                                  <svg
                                    className="md:w-16 h-16"
                                    width="37"
                                    height="38"
                                    viewBox="0 0 37 38"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M18.4952 3.55988C18.9411 4.23679 19.3707 4.925 19.8129 5.60464C20.6215 6.86038 21.4637 8.10133 22.1255 9.44076C22.5551 10.3131 22.8897 11.2422 23.0037 12.2092C23.0899 12.8639 23.063 13.5283 22.9645 14.1804L23.0282 14.1539C22.8577 14.2734 22.7568 14.4587 22.633 14.6194C21.3501 16.3376 20.074 18.0612 18.7884 19.7775C18.6946 19.2948 18.5558 18.8187 18.3354 18.3761C17.9668 17.614 17.4422 16.939 16.9078 16.2839C16.2907 15.5354 15.6538 14.8028 15.0537 14.0406C16.2001 10.5466 17.3465 7.05306 18.4952 3.55988Z"
                                      fill="#A3D513"
                                    />
                                    <path
                                      d="M23.0295 14.1538C24.1102 13.6952 25.2966 13.4948 26.4702 13.5224C27.9327 13.5415 29.3671 13.8614 30.79 14.1655C32.0709 14.4605 33.3636 14.7015 34.654 14.9502C31.5716 17.1503 28.4806 19.3398 25.3978 21.5399C24.5169 21.239 23.6581 20.8817 22.7886 20.552C21.514 20.0678 20.1544 19.6419 18.7715 19.8023L18.7897 19.7774C20.0753 18.0611 21.3515 16.3375 22.6343 14.6193C22.7581 14.4586 22.859 14.2733 23.0295 14.1538Z"
                                      fill="#A3D513"
                                    />
                                    <path
                                      d="M2.32715 14.6366C5.08829 14.6354 7.84943 14.6455 10.6106 14.6451C11.7625 14.6424 12.9144 14.6591 14.0667 14.6479C14.4888 15.1644 14.9066 15.6848 15.3401 16.1928C15.8425 16.7923 16.3552 17.3859 16.7986 18.0301C17.1938 18.6109 17.5281 19.2516 17.6396 19.9491C17.7104 20.3512 17.6891 20.7611 17.7144 21.1671C17.7195 21.2547 17.6586 21.3228 17.6103 21.3894C15.8836 23.6895 14.1787 26.0052 12.4643 28.3139C11.2435 29.9558 10.0271 31.6008 8.80871 33.2442C8.75491 33.3209 8.70349 33.4018 8.62793 33.4602C8.64534 33.3213 8.70428 33.1928 8.74542 33.0601C9.98754 29.3259 11.2304 25.5926 12.471 21.8581C9.83089 19.9803 7.19119 18.1021 4.55149 16.2236C3.81097 15.6934 3.06332 15.1726 2.32715 14.6366Z"
                                      fill="#A3D513"
                                    />
                                    <path
                                      d="M17.7152 21.1671C18.2026 21.0515 18.6923 20.9114 19.1974 20.9082C20.0831 20.8646 20.9518 21.1001 21.781 21.3831C22.9349 21.7876 24.0555 22.28 25.2162 22.6673C26.4199 26.3037 27.6347 29.937 28.8405 33.5731C28.206 33.1418 27.592 32.6801 26.9646 32.2383C24.2138 30.2613 21.4562 28.2928 18.7081 26.3123C15.3318 28.7346 11.9552 31.1562 8.57812 33.5774C8.58841 33.5295 8.59909 33.4816 8.60898 33.4345L8.62876 33.4602C8.70431 33.4018 8.75574 33.3209 8.80954 33.2442C10.0279 31.6007 11.2443 29.9557 12.4651 28.3138C14.1795 26.0052 15.8845 23.6895 17.6112 21.3894C17.6594 21.3228 17.7203 21.2547 17.7152 21.1671Z"
                                      fill="#A3D513"
                                    />
                                  </svg>
                                </div>
                                <div className="w-7/12 ml-2 p-1 lg:p-4 text-white text-xs md:text-md lg:text-lg text-left font-semibold">
                                  Perpusnas Press
                                </div>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {this.state.hybrid_umum && (
                    <>
                      <div className="flex justify-between px-4 lg:px-6 items-center mt-4 lg:mt-6 mb-2">
                        <h3 className="text-base lg:text-xl text-black font-semibold">
                          Video Content Creator
                        </h3>
                      </div>
                      <div className="px-4 lg:px-6">
                        <div className="grid grid-cols-1">
                          <button
                            onClick={() => this.gotoContenCreator()}
                            className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                          >
                            <div
                              className="rounded-l-2xl"
                              style={{ position: "relative" }}
                            >
                              <img
                                src={kreator}
                                style={{ width: "100vw", maxHeight: "260px" }}
                              ></img>
                              <div
                                className="w-7/12  lg:p-4 text-black text-lg sm:text-3xl lg:text-4xl text-left font-bold"
                                style={{
                                  position: "absolute",
                                  top: "20%",
                                  left: "40vw",
                                }}
                              >
                                Content Creator
                                <br />
                                <span className="text-xs sm:text-base lg:text-lg">
                                  Video pendek ragam literasi dan perpustakaan
                                </span>
                              </div>
                            </div>
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  {this.state.hybrid_smp && (
                    <div className="block sm:block md:hidden lg:hidden">
                      <div className="flex justify-between px-4 lg:px-6 items-center mt-4 lg:mt-6 mb-2 ">
                        <h3 className="text-base lg:text-xl text-black font-semibold">
                          Buku Pengayaan SMP
                        </h3>
                      </div>
                      <div className="px-4 lg:px-6">
                        <div className="grid grid-cols-1">
                          <button
                            onClick={() => this.gotoSearch(30)}
                            className="rounded-2xl overflow-hidden"
                          >
                            <div className="rounded-2xl">
                              <img
                                src={iconBukuPengayaan}
                                alt="buku pengayaan SMP"
                                className="w-full h-full"
                              />
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {(this.state.datakategori["CAT008"] == 1 ||
                    this.state.datakategori["CAT009"] == 1) && (
                    <div className="flex justify-between px-4 lg:px-6 items-center mt-4 lg:mt-6 mb-2">
                      <h3 className="text-base lg:text-xl text-black font-semibold">
                        Koleksi Audiobook & Videobook
                      </h3>
                    </div>
                  )}

                  <div className="px-4 lg:px-6">
                    <div className="grid grid-cols-2 gap-2 lg:gap-4">
                      {this.state.datakategori["CAT008"] == 1 && (
                        <button
                          onClick={() => this.gotoSearch(12)}
                          className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                        >
                          <div className="rounded-l-2xl">
                            <div
                              className="h-24 w-20 bg-no-repeat bg-left"
                              style={{
                                backgroundImage: `url(${iconAudiobook})`,
                              }}
                            ></div>
                          </div>
                          <div className="w-7/12 p-2 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                            Audiobook
                          </div>
                        </button>
                      )}
                      {this.state.datakategori["CAT009"] == 1 && (
                        <button
                          onClick={() => this.gotoSearch(15)}
                          className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                        >
                          <div className="rounded-l-2xl">
                            <div
                              className="h-24 w-20 bg-no-repeat bg-left"
                              style={{
                                backgroundImage: `url(${iconVideobook})`,
                              }}
                            ></div>
                          </div>
                          <div className="w-7/12 p-2 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                            Videobook
                          </div>
                        </button>
                      )}
                    </div>
                  </div>

                  {this.state.hybrid_umum && (
                    <>
                      <div className="flex justify-between px-4 lg:px-6 items-center mt-4 lg:mt-6 mb-2">
                        <h3 className="text-base lg:text-xl text-black font-semibold">
                          Literasi Daerah
                        </h3>
                      </div>
                      <div className="px-4 lg:px-6">
                        <div className="grid grid-cols-1">
                          <button
                            onClick={() => this.gotoSearch(21)}
                            className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                          >
                            <div className="rounded-l-2xl">
                              <div
                                className="h-24 w-32 bg-no-repeat bg-left"
                                style={{
                                  backgroundImage: `url(${iconLiterasiDaerah})`,
                                }}
                              ></div>
                            </div>
                            <div className="w-7/12 p-2 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                              Literasi Daerah
                              <br />
                              <span className="text-xs">
                                Informasi dan Literatur Daerah
                              </span>
                            </div>
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  {this.state.hybrid_smp && (
                    <>
                      <div className="flex justify-between px-4 lg:px-6 items-center mt-4 lg:mt-6 mb-2">
                        <h3 className="text-base lg:text-xl text-black font-semibold">
                          P3SMPT Perpusnas RI
                        </h3>
                      </div>
                      <div className="px-4 lg:px-6">
                        <div className="grid grid-cols-1">
                          <button
                            onClick={() => this.gotoSearch(34)}
                            className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                          >
                            <div className="rounded-l-2xl">
                              <div
                                className="h-24 w-32 bg-no-repeat bg-left"
                                style={{
                                  backgroundImage: `url(${iconP3SMPT})`,
                                }}
                              ></div>
                            </div>
                            <div className="w-7/12 p-2 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                              P3SMPT Perpusnas RI
                              <br />
                              <span className="text-xs">
                                Memuat Informasi P3SMPT
                              </span>
                            </div>
                          </button>
                        </div>
                      </div>
                      <div className="flex justify-between px-4 lg:px-6 items-center mt-4 lg:mt-6 mb-2">
                        <h3 className="text-base lg:text-xl text-black font-semibold">
                          Informasi
                        </h3>
                      </div>
                      <div className="px-4 lg:px-6">
                        <div className="grid grid-cols-2 gap-2 lg:gap-4">
                          <button
                            onClick={() => this.gotoSearch(32)}
                            className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                          >
                            <div className="rounded-l-2xl">
                              <div
                                className="h-24 w-20 bg-no-repeat bg-left"
                                style={{
                                  backgroundImage: `url(${iconInfoKemendikbud})`,
                                }}
                              ></div>
                            </div>
                            <div className="w-7/12 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                              Informasi Kemendikbud
                            </div>
                          </button>
                          <button
                            onClick={() => this.gotoSearch(33)}
                            className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                          >
                            <div className="rounded-l-2xl">
                              <div
                                className="h-24 w-20 bg-no-repeat bg-left"
                                style={{
                                  backgroundImage: `url(${iconInfoSekolah})`,
                                }}
                              ></div>
                            </div>
                            <div className="w-7/12 p-2 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                              Informasi Sekolah
                            </div>
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                  {this.state.hybrid_umum && (
                    <>
                      <div className="flex justify-between px-4 lg:px-6 items-center mt-4 lg:mt-6 mb-2">
                        <h3 className="text-base lg:text-xl text-black font-semibold">
                          Koleksi BSE
                        </h3>
                      </div>
                      <div className="px-4 lg:px-6">
                        <div className="grid grid-cols-2 gap-2 lg:gap-4">
                          <button
                            onClick={() => this.gotoSearch(13)}
                            className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                          >
                            <div className="rounded-l-2xl">
                              <div
                                className="h-24 w-20 bg-no-repeat bg-left"
                                style={{
                                  backgroundImage: `url(${iconKemenag})`,
                                }}
                              ></div>
                            </div>
                            <div className="w-7/12 p-2 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                              BSE Kemenag
                            </div>
                          </button>
                          <button
                            onClick={() => this.gotoSearch(14)}
                            className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                          >
                            <div className="rounded-l-2xl">
                              <div
                                className="h-24 w-20 bg-no-repeat bg-left"
                                style={{
                                  backgroundImage: `url(${iconKemendikbud})`,
                                }}
                              ></div>
                            </div>
                            <div className="w-7/12 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                              BSE Kemendikbud
                            </div>
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                  {this.state.hybrid_umum && (
                    <>
                      <div className="flex justify-between px-4 lg:px-6 items-center mt-4 lg:mt-6 mb-2">
                        <h3 className="text-base lg:text-xl text-black font-semibold">
                          Konten Baru
                        </h3>
                      </div>
                      <div className="px-4 lg:px-6">
                        <div className="grid grid-cols-1">
                          <button
                            onClick={() => this.gotoSearch(39)}
                            className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                          >
                            <div className="rounded-l-2xl">
                              <div
                                className="h-24 w-32 bg-no-repeat bg-left"
                                style={{
                                  backgroundImage: `url(${iconSirkulasi})`,
                                }}
                              ></div>
                            </div>
                            <div className="w-7/12 p-2 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                              Konten Baru
                            </div>
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                  {this.state.hybrid_umum && (
                    <>
                      <div className="flex justify-between px-4 lg:px-6 items-center mt-4 lg:mt-6 mb-2">
                        <h3 className="text-base lg:text-xl text-black font-semibold">
                          Tutorial Edukasi
                        </h3>
                      </div>
                      <div className="px-4 lg:px-6">
                        <div className="grid grid-cols-1">
                          <button
                            onClick={() => this.gotoSearch(40)}
                            className="flex items-center shadow-md border border-slate-50 border-opacity-100 rounded-2xl overflow-hidden hover:shadow-lg"
                          >
                            <div className="rounded-l-2xl">
                              <div
                                className="h-24 w-32 bg-no-repeat bg-left"
                                style={{
                                  backgroundImage: `url(${tutorialEdukasi})`,
                                }}
                              ></div>
                            </div>
                            <div className="w-7/12 p-2 lg:p-4 text-black text-sm lg:text-lg text-left font-semibold">
                              Tutorial Edukasi
                            </div>
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                  {this.state.hybrid_umum && (
                    <>
                      {this.state.datakategori["CAT020"] == 1 && (
                        <>
                          <div className="flex justify-between px-4 lg:px-6 items-center mt-4 lg:mt-6 mb-2">
                            <h3 className="text-base lg:text-xl text-black font-semibold">
                              Potensi Lokal
                            </h3>
                          </div>
                          <div className="px-4 lg:px-6">
                            <div className="grid grid-cols-1">
                              <button
                                onClick={() => this.gotoSearch(20)}
                                className="bg-[#D6F5FF] h-[182px] sm:h-auto lg:h-auto flex items-center shadow-md rounded-2xl overflow-hidden hover:shadow-lg"
                              >
                                <div className="rounded-l-2xl pt-4">
                                  <img
                                    src={iconLokal}
                                    alt=""
                                    className="w-full"
                                  />
                                </div>
                                <div className="w-7/12 p-2 lg:p-4 text-[#6B92AA] text-lg sm:text-3xl lg:text-4xl text-left font-bold">
                                  POTENSI LOKAL
                                  <br />
                                  <span className="text-xs">
                                    Buku Penunjang Kegiatan Lokal
                                  </span>
                                </div>
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}
                  {this.state.hybrid_smp && (
                    <>
                      <div className="flex justify-between px-4 lg:px-6 items-center mt-4 lg:mt-6 mb-2">
                        <h3 className="text-base lg:text-xl text-black font-semibold">
                          Permainan Edukasi
                        </h3>
                      </div>
                      <div className="px-4 lg:px-6">
                        <div className="grid grid-cols-1">
                          <button
                            onClick={() => this.gotoGames()}
                            className="rounded-2xl overflow-hidden"
                          >
                            <div className="rounded-2xl">
                              <img
                                src={iconPermainanEdukasi}
                                alt="permainan edukasi"
                                className="w-full h-full"
                              />
                            </div>
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  {this.state.hybrid_smp && (
                    <>
                      <div className="flex justify-between px-4 lg:px-6 items-center mt-4 lg:mt-6 mb-2">
                        <h3 className="text-base lg:text-xl text-black font-semibold">
                          BintangPusnas Edu
                        </h3>
                      </div>
                      <div className="px-4 lg:px-6">
                        <div className="grid grid-cols-1">
                          <button
                            onClick={() =>
                              (window.location.href = `https://bintangpusnas.perpusnas.go.id/titikbaca/${this.state.alias}`)
                            }
                            className="border rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow"
                          >
                            <div className="rounded-2xl p-10">
                              <img
                                src={logoBpEdu}
                                alt="permainan edukasi"
                                className="w-full h-full"
                              />
                            </div>
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Title Section */}
                  {this.state.loadingBukuKesehatan ? (
                    <SkeletonHomePage />
                  ) : (
                    <>
                      {this.state.flagKesehatan && (
                        <>
                          <div className="flex justify-between px-4 items-center mt-4 mb-2">
                            <h3 className="text-base text-black font-semibold">
                              Buku Kesehatan
                            </h3>
                            <div
                              onClick={() => this.gotoSearch(9)}
                              className={
                                "text-xs font-medium " + this.state.textcolor
                              }
                            >
                              Lihat Semua
                            </div>
                          </div>
                          {/* End Title Section */}
                          {this.state.flagYoutube && (
                            <div className="pl-4 md:hidden sm:block">
                              <Glider
                                slidesToShow={3.3}
                                slidesToScroll={1}
                                draggable
                              >
                                {this.state.dataKesehatan.length > 0 && (
                                  <>
                                    {this.state.dataKesehatan
                                      .slice(0, 6)
                                      .map((item) => {
                                        return (
                                          <div className="p-1">
                                            <div
                                              onClick={() =>
                                                this.gotoDetail(item.alias)
                                              }
                                              className="rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer"
                                            >
                                              <div className="h-[130px] overflow-hidden">
                                                <img
                                                  src={item.cover_file}
                                                  alt="cover buku"
                                                  className="rounded-xl"
                                                />
                                              </div>
                                              <div className="p-2 min-h-[120px]">
                                                <div className="title-book text-sm text-black font-semibold line-clamp-2">
                                                  {item.judul}
                                                </div>
                                                <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                                                  {item.penulis}
                                                </div>
                                                <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                                                  {item.penerbit}
                                                </div>
                                                <div
                                                  className={
                                                    "stock mt-1 text-sm " +
                                                    this.state.textcolor +
                                                    " font-semibold"
                                                  }
                                                >
                                                  Stok: {item.terpakai}/
                                                  {item.qty}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                  </>
                                )}
                              </Glider>
                            </div>
                          )}
                          <div className="pl-4 hidden md:block">
                            <Glider
                              slidesToShow={5.3}
                              slidesToScroll={1}
                              draggable
                            >
                              {this.state.dataKesehatan.length > 0 && (
                                <>
                                  {this.state.dataKesehatan
                                    .slice(0, 6)
                                    .map((item) => {
                                      return (
                                        <div className="p-1">
                                          <div
                                            onClick={() =>
                                              this.gotoDetail(item.alias)
                                            }
                                            className="rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer"
                                          >
                                            <div className="h-[130px] overflow-hidden">
                                              <img
                                                src={item.cover_file}
                                                alt="cover buku"
                                                className="rounded-xl"
                                              />
                                            </div>
                                            <div className="p-2 min-h-[120px]">
                                              <div className="title-book text-sm text-black font-semibold line-clamp-2">
                                                {item.judul}
                                              </div>
                                              <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                                                {item.penulis}
                                              </div>
                                              <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                                                {item.penerbit}
                                              </div>
                                              <div
                                                className={
                                                  "stock mt-1 text-sm " +
                                                  this.state.textcolor +
                                                  " font-semibold"
                                                }
                                              >
                                                Stok: {item.terpakai}/{item.qty}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </>
                              )}
                            </Glider>
                          </div>
                        </>
                      )}
                    </>
                  )}

                  {/* Category 
              <div className="grid grid-cols-3 gap-2 mt-4 px-4">
                {this.state.datakategori.length > 0 && (
                  <>
                    {this.state.datakategori.slice(0, 6).map((item, index) => {
                      return (
                        <button onClick={() => this.gotoKategori(item.sub_kategori)} type="button" className={warna[index] + ' px-4 py-3 text-sm text-white font-semibold rounded-lg truncate'}>
                          {item.sub_kategori}
                        </button>
                      )
                    })}
                  </>
                )}
              </div>
              {/* End Category */}

                  {/* Title Section */}
                  {this.state.loadigngBerita ? (
                    <SkeletonBerita />
                  ) : (
                    <>
                      {this.state.dataBerita.length > 0 && (
                        <>
                          <div className="flex justify-between px-4 items-center mt-4 mb-2">
                            <h3 className="text-base text-black font-semibold">
                              Berita Sekitar
                            </h3>
                            <a
                              href="/news"
                              className={
                                "text-xs font-medium " + this.state.textcolor
                              }
                            >
                              Lihat Semua
                            </a>
                          </div>
                          {/* End Title Section */}
                          <div className="px-4 md:grid md:grid-cols-2 md:gap-2">
                            {this.state.dataBerita.slice(0, 1).map((item) => {
                              return (
                                <div
                                  onClick={() => this.gotoNewsDetail(item.id)}
                                  className="mb-2.5 border bg-white rounded-2xl shadow-md hover:shadow-lg"
                                >
                                  <div className="max-h-[165px] overflow-hidden">
                                    <img
                                      className="w-full rounded-2xl"
                                      src={item.image}
                                      alt="cover news"
                                    />
                                  </div>
                                  <div className="px-2.5 py-4">
                                    <h3 className="mb-1 text-sm text-black font-semibold line-clamp-2">
                                      {item.judul}
                                    </h3>
                                    <div className="text-xs text-gray-light">
                                      {item.sumber}
                                    </div>
                                    <div className="text-xs text-gray-light">
                                      {formatTanggal(item.ins_date)}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                            {this.state.dataBerita.length > 1 &&
                              this.state.flagBerita && (
                                <div className="md:mt-3">
                                  {this.state.dataBerita
                                    .slice(1, 3)
                                    .map((item) => {
                                      return (
                                        <div
                                          href="#"
                                          onClick={() =>
                                            this.gotoNewsDetail(item.id)
                                          }
                                          className="flex mb-2.5 p-2.5 border bg-white rounded-2xl shadow-md hover:shadow-lg cursor-pointer"
                                          id="local"
                                          role="tabpanel"
                                          aria-labelledby="local-tab"
                                        >
                                          <div
                                            style={{
                                              background:
                                                "url('" +
                                                item.image +
                                                "') center center / cover repeat",
                                            }}
                                            className={
                                              "w-[90px] h-[90px] mr-3 bg-center bg-no-repeat rounded-xl"
                                            }
                                          ></div>
                                          <div className="w-8/12">
                                            <h3 className="text-sm text-black font-semibold line-clamp-3">
                                              {item.judul}
                                            </h3>
                                            <div className="mt-1 text-xs text-gray-light">
                                              {item.sumber}
                                            </div>
                                            <div className="text-xs text-gray-light">
                                              {formatTanggal(item.ins_date)}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                              )}
                          </div>
                        </>
                      )}
                    </>
                  )}

                  {/* Title Section */}
                  {this.state.loadingRekomendasi ? (
                    <SkeletonHomePage />
                  ) : (
                    <>
                      {this.state.flagRekomendasi && (
                        <>
                          <div className="flex justify-between px-4 items-center mt-4 mb-2">
                            <h3 className="text-base text-black font-semibold">
                              Buku Rekomendasi
                            </h3>
                            <div
                              onClick={() => this.gotoSearch(2)}
                              className={
                                "text-xs font-medium " + this.state.textcolor
                              }
                            >
                              Lihat Semua
                            </div>
                          </div>
                          {/* End Title Section */}
                          {this.state.flagYoutube && (
                            <div className="pl-4 md:hidden sm:block">
                              <Glider
                                slidesToShow={3.3}
                                slidesToScroll={1}
                                draggable
                              >
                                {this.state.dataRekomendasi.length > 0 && (
                                  <>
                                    {this.state.dataRekomendasi
                                      .slice(0, 6)
                                      .map((item) => {
                                        return (
                                          <div className="p-1">
                                            <div
                                              onClick={() =>
                                                this.gotoDetail(item.alias)
                                              }
                                              className="rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer"
                                            >
                                              <div className="h-[130px] overflow-hidden">
                                                <img
                                                  src={item.cover_file}
                                                  alt="cover buku"
                                                  className="rounded-xl"
                                                />
                                              </div>
                                              <div className="p-2 min-h-[120px]">
                                                <div className="title-book text-sm text-black font-semibold line-clamp-2">
                                                  {item.judul}
                                                </div>
                                                <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                                                  {item.penulis}
                                                </div>
                                                <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                                                  {item.penerbit}
                                                </div>
                                                <div
                                                  className={
                                                    "stock mt-1 text-sm " +
                                                    this.state.textcolor +
                                                    " font-semibold"
                                                  }
                                                >
                                                  Stok: {item.terpakai}/
                                                  {item.qty}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                  </>
                                )}
                              </Glider>
                            </div>
                          )}
                          <div className="pl-4 hidden md:block">
                            <Glider
                              slidesToShow={5.3}
                              slidesToScroll={1}
                              draggable
                            >
                              {this.state.dataRekomendasi.length > 0 && (
                                <>
                                  {this.state.dataRekomendasi
                                    .slice(0, 6)
                                    .map((item) => {
                                      return (
                                        <div className="p-1">
                                          <div
                                            onClick={() =>
                                              this.gotoDetail(item.alias)
                                            }
                                            className="rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer"
                                          >
                                            <div className="h-[130px] overflow-hidden">
                                              <img
                                                src={item.cover_file}
                                                alt="cover buku"
                                                className="rounded-xl"
                                              />
                                            </div>
                                            <div className="p-2 min-h-[120px]">
                                              <div className="title-book text-sm text-black font-semibold line-clamp-2">
                                                {item.judul}
                                              </div>
                                              <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                                                {item.penulis}
                                              </div>
                                              <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                                                {item.penerbit}
                                              </div>
                                              <div
                                                className={
                                                  "stock mt-1 text-sm " +
                                                  this.state.textcolor +
                                                  " font-semibold"
                                                }
                                              >
                                                Stok: {item.terpakai}/{item.qty}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </>
                              )}
                            </Glider>
                          </div>
                        </>
                      )}
                    </>
                  )}

                  {/* <!-- Titel Section --> */}
                  {this.state.loadingGetRss ? (
                    <SkeletonBerita />
                  ) : (
                    <>
                      <div className="flex justify-between items-center pl-4 pr-4 mt-4 mb-2">
                        <h3 className="text-base text-black font-semibold">
                          Berita Unggulan
                        </h3>
                      </div>
                      {/* <!-- End Title Section --> */}
                      <div className="m-2 relative overflow-hidden mb-4">
                        {this.state.news.slice(0, 1).map((item) => {
                          return (
                            <div
                              onClick={() =>
                                this.gotoRSSDetail(item.tipe, item.id)
                              }
                              className="border bg-white rounded-2xl shadow-md hover:shadow-lg"
                            >
                              <img
                                className="cursor-pointer w-full rounded-2xl"
                                src={item.img + "?w=700&q=90"}
                                alt="cover news"
                              />
                              <div className="w-full max-h-32 p-4 absolute bottom-0 left-0 bg-gradient-to-t from-orange rounded-2xl">
                                <h3 className="mb-1 text-sm text-white font-semibold line-clamp-2">
                                  {item.title}
                                </h3>
                                <div className="flex">
                                  <div className="w-8 h-8 overflow-hidden rounded-full border-[1px] border-slate-300">
                                    <img src={item.logo} alt="logo kumparan" />
                                  </div>
                                  <div className="ml-2 text-white text-xs">
                                    <div>{item.publisher}</div>
                                    <div>{formatTanggal(item.date)}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className="pl-4 pr-4  md:grid md:grid-cols-2 md:gap-2">
                        {this.state.news.length > 0 &&
                          this.state.flagBerita && (
                            <>
                              {this.state.news.slice(1, 5).map((item) => {
                                return (
                                  <>
                                    <div
                                      onClick={() =>
                                        this.gotoRSSDetail(item.tipe, item.id)
                                      }
                                      className="flex mb-2.5 p-2.5 bg-white border rounded-xl shadow-md hover:shadow-lg cursor-pointer"
                                    >
                                      <div className="w-9/12 mr-4">
                                        <h3 className="mt-1 font-semibold text-sm text-black line-clamp-2">
                                          {item.title}
                                        </h3>
                                        <div className="mt-1 flex items-center">
                                          <div className="w-6 h-6 overflow-hidden rounded-full border-[1px] border-slate-300">
                                            <img
                                              src={item.logo}
                                              alt="logo kumparan"
                                            />
                                          </div>
                                          <div className="ml-2 text-white text-xs">
                                            <div className="text-xs text-gray-light">
                                              {item.publisher}
                                            </div>
                                            <div className="text-xs text-gray-light">
                                              {formatTanggal(item.date)}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          background:
                                            "url('" +
                                            item.img +
                                            "') center center / cover repeat",
                                        }}
                                        className={
                                          "w-[90px] h-[90px] bg-center bg-no-repeat rounded-xl"
                                        }
                                      ></div>
                                    </div>
                                  </>
                                );
                              })}
                            </>
                          )}
                      </div>
                    </>
                  )}

                  {/* Title Section */}
                  {this.state.loadingAudioBook ? (
                    <SkeletonHomePage />
                  ) : (
                    <>
                      {this.state.datakategori["CAT008"] == 1 && (
                        <>
                          <div className="flex justify-between px-4 items-center mt-4 mb-2">
                            <h3 className="text-base text-black font-semibold">
                              Audiobook
                            </h3>
                            <div
                              onClick={() => this.gotoSearch(12)}
                              className={
                                "text-xs font-medium " + this.state.textcolor
                              }
                            >
                              Lihat Semua
                            </div>
                          </div>
                          {/* <!-- End Titel Section --> */}
                          {this.state.flagYoutube && (
                            <div className="pl-4 sm:block md:hidden">
                              <Glider
                                draggable
                                slidesToShow={3.2}
                                slidesToScroll={1}
                              >
                                {this.state.dataAudio.length > 0 && (
                                  <>
                                    {this.state.dataAudio.map((item) => {
                                      return (
                                        <div className="p-1">
                                          <div
                                            onClick={() =>
                                              this.gotoDetail(item.alias)
                                            }
                                            className="rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer"
                                          >
                                            <div className="h-[130px] overflow-hidden">
                                              <img
                                                src={item.cover_file}
                                                alt="cover buku"
                                                className="rounded-xl"
                                              />
                                            </div>
                                            <div className="p-2 min-h-[120px]">
                                              <div className="title-book text-sm text-black font-semibold line-clamp-2">
                                                {item.judul}
                                              </div>
                                              <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                                                {item.penulis}
                                              </div>
                                              <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                                                {item.penerbit}
                                              </div>
                                              <div
                                                className={
                                                  "stock mt-1 text-sm " +
                                                  this.state.textcolor +
                                                  " font-semibold"
                                                }
                                              >
                                                Stok: {item.terpakai}/{item.qty}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </>
                                )}
                              </Glider>
                            </div>
                          )}
                          <div className="pl-4 hidden md:block">
                            <div className="grid grid-cols-5 gap-2">
                              {this.state.dataAudio.length > 0 && (
                                <>
                                  {this.state.dataAudio
                                    .slice(0, 5)
                                    .map((item) => {
                                      return (
                                        <div className="p-1">
                                          <div
                                            onClick={() =>
                                              this.gotoDetail(item.alias)
                                            }
                                            className="rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer"
                                          >
                                            <div className="h-[130px] overflow-hidden">
                                              <img
                                                src={item.cover_file}
                                                alt="cover buku"
                                                className="rounded-xl"
                                              />
                                            </div>
                                            <div className="p-2 min-h-[120px]">
                                              <div className="title-book text-sm text-black font-semibold line-clamp-2">
                                                {item.judul}
                                              </div>
                                              <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                                                {item.penulis}
                                              </div>
                                              <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                                                {item.penerbit}
                                              </div>
                                              <div
                                                className={
                                                  "stock mt-1 text-sm " +
                                                  this.state.textcolor +
                                                  " font-semibold"
                                                }
                                              >
                                                Stok: {item.terpakai}/{item.qty}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}

                  {/* Title Section */}
                  {this.state.loadingGetTitikbacaTerdekat ? (
                    <SkeletonTitikBaca />
                  ) : (
                    <>
                      <div className="flex justify-between px-4 items-center mt-4 mb-2">
                        <h3 className="text-base text-black font-semibold">
                          Titikbaca Terdekat
                        </h3>
                      </div>
                      {/* End Title Section */}
                      <div className="px-4 md:hidden sm:block ">
                        <div className="grid grid-cols-3 gap-4">
                          {this.state.dataterdekat_array.length > 0 && (
                            <>
                              {this.state.dataterdekat_array
                                .slice(0, 3)
                                .map((item) => {
                                  // { console.log('titik_terdekat = ' + JSON.stringify(item)) }
                                  // { console.log('titik_terdekat = ' + this.state.alias) }
                                  let mySentence = item.nama.toLowerCase();
                                  let words = mySentence.split(" ");

                                  for (let i = 0; i < words.length; i++) {
                                    if (words[i].length > 1) {
                                      words[i] =
                                        words[i][0].toUpperCase() +
                                        words[i].substr(1);
                                    }
                                  }

                                  let titik = words.join(" ");
                                  return (
                                    <a href={"/" + item.alias}>
                                      <div className="text-center">
                                        <div className="rounded-full p-4">
                                          <img
                                            src={image_location}
                                            alt="location"
                                          />
                                        </div>
                                        <div className="mt-2 text-sm text-black font-semibold line-clamp-2">
                                          {titik}
                                        </div>
                                      </div>
                                    </a>
                                  );
                                })}
                            </>
                          )}
                        </div>
                      </div>

                      <div className="px-4 hidden md:block ">
                        <div className="grid grid-cols-6 gap-4">
                          {this.state.dataterdekat_array.length > 0 && (
                            <>
                              {this.state.dataterdekat_array
                                .slice(0, 6)
                                .map((item) => {
                                  // { console.log('titik_terdekat = ' + JSON.stringify(item)) }
                                  // { console.log('titik_terdekat = ' + this.state.alias) }
                                  let mySentence = item.nama.toLowerCase();
                                  let words = mySentence.split(" ");

                                  for (let i = 0; i < words.length; i++) {
                                    if (words[i].length > 1) {
                                      words[i] =
                                        words[i][0].toUpperCase() +
                                        words[i].substr(1);
                                    }
                                  }

                                  let titik = words.join(" ");
                                  return (
                                    <a href={"/" + item.alias}>
                                      <div className="text-center">
                                        <div className="rounded-full p-4">
                                          <img
                                            src={image_location}
                                            alt="location"
                                          />
                                        </div>
                                        <div className="mt-2 text-sm text-black font-semibold line-clamp-2">
                                          {titik}
                                        </div>
                                      </div>
                                    </a>
                                  );
                                })}
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {localStorage.getItem("P3SMPT") && (
                    <>
                      <div className="flex justify-between px-4 items-center mt-4 mb-2">
                        <h3 className="text-base text-black font-semibold">
                          Koleksi buku{" "}
                          {localStorage.getItem("P3SMPT").toUpperCase()}
                        </h3>
                        <div
                          className={
                            "text-xs font-medium " + this.state.textcolor
                          }
                          onClick={() => this.gotoSearch(50)}
                        >
                          Lihat Semua
                        </div>
                      </div>
                      {Array.isArray(this.state.dataJenjang) &&
                      this.state.dataJenjang.length > 0 ? (
                        <>
                          <div className="pl-4 sm:block md:hidden">
                            <Glider
                              draggable
                              slidesToShow={3.2}
                              slidesToScroll={1}
                            >
                              {this.state.dataJenjang.map((item, index) => (
                                <div className="p-1" key={index}>
                                  <div
                                    className="rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer"
                                    onClick={() => this.gotoDetail(item.alias)}
                                  >
                                    <div className="h-[130px] overflow-hidden">
                                      <img
                                        src={item.cover_file}
                                        alt="cover buku"
                                        className="rounded-xl"
                                      />
                                    </div>
                                    <div className="p-2 min-h-[120px]">
                                      <div className="title-book text-sm text-black font-semibold line-clamp-2">
                                        {item.judul}
                                      </div>
                                      <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                                        {item.penulis}
                                      </div>
                                      <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                                        {item.penerbit}
                                      </div>
                                      <div
                                        className={
                                          "stock mt-1 text-sm " +
                                          this.state.textcolor +
                                          " font-semibold line-clamp-2"
                                        }
                                      >
                                        Stok: {item.terpakai}/{item.qty}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </Glider>
                          </div>
                          <div className="pl-4 hidden md:block">
                            <div className="grid grid-cols-5 gap-2">
                              {this.state.dataJenjang.map((item, index) => (
                                <div className="p-1" key={index}>
                                  <div
                                    onClick={() => this.gotoDetail(item.alias)}
                                    className="rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer"
                                  >
                                    <div className="h-[130px] overflow-hidden">
                                      <img
                                        src={item.cover_file}
                                        alt="cover buku"
                                        className="rounded-xl"
                                      />
                                    </div>
                                    <div className="p-2 min-h-[120px]">
                                      <div className="title-book text-sm text-black font-semibold line-clamp-2">
                                        {item.judul}
                                      </div>
                                      <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                                        {item.penulis}
                                      </div>
                                      <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                                        {item.penerbit}
                                      </div>
                                      <div
                                        className={
                                          "stock mt-1 text-sm " +
                                          this.state.textcolor +
                                          " font-semibold"
                                        }
                                      >
                                        Stok: {item.terpakai}/{item.qty}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  )}

                  {/* Title Section */}
                  {this.state.loadingBukuTerlaris ? (
                    <SkeletonBukuTerlaris />
                  ) : (
                    <>
                      {this.state.dataTerlaris.length > 0 && (
                        <div className="flex justify-between px-4 items-center mt-4 mb-2">
                          <h3 className="text-base text-black font-semibold">
                            Paling banyak dilihat
                          </h3>
                          <div
                            onClick={() => this.gotoSearch(3)}
                            className={
                              "text-xs font-medium " + this.state.textcolor
                            }
                          >
                            Lihat Semua
                          </div>
                        </div>
                      )}

                      {/* End Title Section */}
                      <div className="px-4 md:grid md:grid-cols-2 md:gap-2">
                        {this.state.dataTerlaris.length > 0 && (
                          <>
                            {this.state.dataTerlaris.slice(0, 6).map((item) => {
                              return (
                                <div className="mb-2.5 border border-gray-border bg-white p-2.5 rounded-2xl shadow-md">
                                  <div
                                    onClick={() => this.gotoDetail(item.alias)}
                                    className="flex"
                                  >
                                    <div className="w-4/12 md:w-3/12">
                                      <img
                                        className="rounded-xl"
                                        src={item.cover_file}
                                        alt="cover book"
                                      />
                                    </div>
                                    <div className="w-8/12 md:w-9/12 ml-3">
                                      <h3 className="font-semibold text-sm text-black line-clamp-2">
                                        {item.judul}
                                      </h3>
                                      <div className="mt-1 text-xs text-gray-light">
                                        {item.penulis}
                                      </div>
                                      <div className="mt-3 text-xs text-gray-light line-clamp-3 sm:line-clamp-6">
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: item.sinopsis,
                                          }}
                                        />
                                      </div>
                                      <div
                                        className={
                                          "stock mt-2 text-sm " +
                                          this.state.textcolor +
                                          " font-semibold"
                                        }
                                      >
                                        Stok: {item.terpakai}/{item.qty}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </>
                        )}
                      </div>
                    </>
                  )}

                  {/* Title Section */}
                  {this.state.loadingVideoBook ? (
                    <SkeletonHomePage />
                  ) : (
                    <>
                      <div className="flex justify-between px-4 items-center mt-4 mb-2">
                        <h3 className="text-base text-black font-semibold">
                          Videobook
                        </h3>
                        <div
                          onClick={() => this.gotoSearch(12)}
                          className={
                            "text-xs font-medium " + this.state.textcolor
                          }
                        >
                          Lihat Semua
                        </div>
                      </div>
                      {/* <!-- End Titel Section --> */}
                      {this.state.flagYoutube && (
                        <div className="pl-4 sm:block md:hidden">
                          <Glider
                            draggable
                            slidesToShow={3.2}
                            slidesToScroll={1}
                          >
                            {this.state.dataVideo.length > 0 && (
                              <>
                                {this.state.dataVideo.map((item) => {
                                  return (
                                    <div className="p-1">
                                      <div
                                        onClick={() =>
                                          this.gotoDetail(item.alias)
                                        }
                                        className="rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer"
                                      >
                                        <div className="h-[130px] overflow-hidden">
                                          <img
                                            src={item.cover_file}
                                            alt="cover buku"
                                            className="rounded-xl"
                                          />
                                        </div>
                                        <div className="p-2 min-h-[120px]">
                                          <div className="title-book text-sm text-black font-semibold line-clamp-2">
                                            {item.judul}
                                          </div>
                                          <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                                            {item.penulis}
                                          </div>
                                          <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                                            {item.penerbit}
                                          </div>
                                          <div
                                            className={
                                              "stock mt-1 text-sm " +
                                              this.state.textcolor +
                                              " font-semibold"
                                            }
                                          >
                                            Stok: {item.terpakai}/{item.qty}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                              </>
                            )}
                          </Glider>
                        </div>
                      )}
                      <div className="pl-4 hidden md:block">
                        <div className="grid grid-cols-5 gap-2">
                          {this.state.dataVideo.length > 0 && (
                            <>
                              {this.state.dataVideo.slice(0, 5).map((item) => {
                                return (
                                  <div className="p-1">
                                    <div
                                      onClick={() =>
                                        this.gotoDetail(item.alias)
                                      }
                                      className="rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer"
                                    >
                                      <div className="h-[130px] overflow-hidden">
                                        <img
                                          src={item.cover_file}
                                          alt="cover buku"
                                          className="rounded-xl"
                                        />
                                      </div>
                                      <div className="p-2 min-h-[120px]">
                                        <div className="title-book text-sm text-black font-semibold line-clamp-2">
                                          {item.judul}
                                        </div>
                                        <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                                          {item.penulis}
                                        </div>
                                        <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                                          {item.penerbit}
                                        </div>
                                        <div
                                          className={
                                            "stock mt-1 text-sm " +
                                            this.state.textcolor +
                                            " font-semibold"
                                          }
                                        >
                                          Stok: {item.terpakai}/{item.qty}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {/* BERITA HERE! */}
                  {this.state.loadingGetRssKominfo ? (
                    <SkeletonHalamanBerita />
                  ) : (
                    <>
                      {this.state.flagRSSKominfo &&
                        this.state.dataRssKominfo.length > 0 && (
                          <>
                            <div>
                              <div className="md:mt-3 p-2">
                                <div className="hidden md:block">
                                  <div className="flex justify-between items-center m-2 mt-4 mb-2">
                                    <div className="flex">
                                      <h3 className="ml-1 text-base text-black font-semibold">
                                        Berita
                                      </h3>
                                    </div>
                                    <a
                                      href="/listrss/0"
                                      className={
                                        "text-xs font-medium " +
                                        this.state.textcolor +
                                        " hover:opacity-50 duration-150"
                                      }
                                    >
                                      Lihat Semua
                                    </a>
                                  </div>
                                  <div
                                    className="grid grid-cols-2"
                                    id="local"
                                    role="tabpanel"
                                    aria-labelledby="local-tab"
                                  >
                                    {this.state.dataRssKominfo.map((item) => {
                                      return (
                                        <>
                                          <div
                                            onClick={() =>
                                              this.gotoRSSDetail(
                                                item.link,
                                                item.id,
                                              )
                                            }
                                            className="flex mb-2.5 p-2.5 m-1 bg-white border rounded-xl shadow-md hover:shadow-lg cursor-pointer"
                                          >
                                            <div
                                              style={{
                                                background:
                                                  "url('" +
                                                  item.img +
                                                  "') center center / cover repeat",
                                              }}
                                              className={
                                                "w-[90px] h-[90px] ml-3 mr-3 bg-center bg-no-repeat rounded-xl"
                                              }
                                            ></div>
                                            <div className="w-9/12">
                                              <h3 className="mt-1 font-semibold text-sm text-black line-clamp-2">
                                                {item.title}
                                              </h3>
                                              <div className="mt-1 flex items-center">
                                                <div className="w-6 h-6 overflow-hidden rounded-full border-[1px] border-slate-300">
                                                  <img
                                                    src={item.logo}
                                                    alt="logo kumparan"
                                                  />
                                                </div>
                                                <div className="ml-2 text-white text-xs">
                                                  <div className="text-xs text-gray-light">
                                                    {item.publisher}
                                                  </div>
                                                  <div className="text-xs text-gray-light">
                                                    {formatTanggal(item.date)}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    })}
                                  </div>
                                </div>

                                <div className="px-2 md:hidden">
                                  <div className="flex justify-between items-center mt-4 mb-2">
                                    <div className="flex">
                                      <h3 className="ml-1 text-base text-black font-semibold">
                                        Berita
                                      </h3>
                                    </div>
                                    <a
                                      href="/listrss/0"
                                      className={
                                        "text-xs font-medium " +
                                        this.state.textcolor +
                                        " hover:opacity-50 duration-150"
                                      }
                                    >
                                      Lihat Semua
                                    </a>
                                  </div>
                                  {this.state.dataRssKominfo
                                    .slice(0, 4)
                                    .map((item, index) => {
                                      return (
                                        <>
                                          <div
                                            onClick={() =>
                                              this.gotoRSSDetail(
                                                item.link,
                                                item.id,
                                              )
                                            }
                                            className="flex mb-2.5 p-2 bg-white border rounded-xl shadow-md hover:shadow-lg cursor-pointer"
                                          >
                                            <div
                                              style={{
                                                background:
                                                  "url('" +
                                                  item.img +
                                                  "') center center / cover repeat",
                                              }}
                                              className={
                                                "w-[90px] h-[90px] mr-3 bg-center bg-no-repeat rounded-xl"
                                              }
                                            ></div>
                                            <div className="w-9/12">
                                              <h3 className="mt-1 font-semibold text-sm text-black line-clamp-2">
                                                {item.title}
                                              </h3>
                                              <div className="mt-1 flex items-center">
                                                <div className="w-6 h-6 overflow-hidden rounded-full border-[1px] border-slate-300">
                                                  <img
                                                    src={item.logo}
                                                    alt="logo kumparan"
                                                  />
                                                </div>
                                                <div className="ml-2 text-white text-xs">
                                                  <div className="text-xs text-gray-light">
                                                    {item.publisher}
                                                  </div>
                                                  <div className="text-xs text-gray-light">
                                                    {formatTanggal(item.date)}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      {this.state.flagYoutube && (
                        <div
                          style={{
                            position: "fixed",
                            right: "10px",
                            bottom: "100px",
                          }}
                        >
                          <Draggable>
                            <div style={{ width: "96px", zIndex: "500" }}>
                              <img src={mascot} alt="mascot"></img>
                            </div>
                          </Draggable>
                        </div>
                      )}
                    </>
                  )}

                  {this.state.loadingGetTitikbacaTerdekat ? (
                    <SkeletonTitikBaca />
                  ) : (
                    <div className="px-4 hidden md:block ">
                      <div className="grid grid-cols-6 gap-4">
                        {this.state.dataterdekat.length > 0 && (
                          <>
                            {this.state.dataterdekat.slice(0, 7).map((item) => {
                              let mySentence = item.nama.toLowerCase();
                              let words = mySentence.split(" ");

                              for (let i = 0; i < words.length; i++) {
                                if (words[i].length > 1) {
                                  words[i] =
                                    words[i][0].toUpperCase() +
                                    words[i].substr(1);
                                }
                              }

                              let titik = words.join(" ");
                              if (item.alias != this.state.alias) {
                                return (
                                  <a href={"/" + item.alias}>
                                    <div className="text-center">
                                      <div className="rounded-full p-4">
                                        <img
                                          src={image_location}
                                          alt="location"
                                        />
                                      </div>
                                      <div className="mt-2 text-sm text-black font-semibold line-clamp-2">
                                        {titik}
                                      </div>
                                    </div>
                                  </a>
                                );
                              }
                            })}
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {this.state.loadingBukuTop ? (
                    <SkeletonBanyakDibaca />
                  ) : (
                    <>
                      {this.state.flagDataTop &&
                        this.state.dataTop.length > 0 && (
                          <div className="px-4">
                            {/* Title Section */}
                            {this.state.flagDataTop &&
                              this.state.dataTop.length > 0 && (
                                <div className="flex justify-between items-center mt-4 mb-2">
                                  <h3 className="text-base text-black font-semibold">
                                    Paling Banyak Dibaca
                                  </h3>
                                  <div
                                    onClick={() => this.gotoSearch(0)}
                                    className={
                                      "text-xs font-medium " +
                                      this.state.textcolor +
                                      " hover:opacity-50 duration-150"
                                    }
                                  >
                                    Lihat Semua
                                  </div>
                                </div>
                              )}
                            {/* End Title Section */}
                            {this.state.flagDataTop &&
                              this.state.dataTop.length > 0 && (
                                <Masonry
                                  breakpointCols={{ default: 6, 680: 2 }}
                                  className="flex w-auto"
                                >
                                  {this.state.dataTop.map((item, i) => {
                                    return (
                                      <div
                                        key={i}
                                        onClick={() =>
                                          this.gotoDetail(item.alias)
                                        }
                                        className="m-2 mb-4 break-inside-avoid rounded-xl shadow-md hover:shadow-lg cursor-pointer"
                                      >
                                        <div className="h-[130px] overflow-hidden">
                                          <img
                                            src={item.cover_file}
                                            alt="cover buku"
                                            className="w-full rounded-xl"
                                          />
                                        </div>
                                        <div className="p-2">
                                          <div className="title-book text-sm text-black font-semibold line-clamp-3">
                                            {item.judul}
                                          </div>
                                          <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                                            {item.penulis}
                                          </div>
                                          <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                                            {item.penerbit}
                                          </div>
                                          <div
                                            className={
                                              "stock mt-1 text-sm " +
                                              this.state.textcolor +
                                              " font-semibold"
                                            }
                                          >
                                            Stok: {item.terpakai}/{item.qty}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </Masonry>
                              )}

                            {!this.state.flagMoreSearch && (
                              <div className="text-center mb-16 h-[88px]">
                                <button
                                  type="button"
                                  onClick={() => this.getBukuTop()}
                                  className={
                                    "mt-2 py-2 px-8 border-[1px] border-orange " +
                                    this.state.textcolor +
                                    " text-sm font-semibold text-center rounded-full"
                                  }
                                >
                                  Lihat Lebih Banyak
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                    </>
                  )}
                </div>
                {/* End Main Content Wrap */}

                {/* Ads Video */}
                {/* <div className="fixed bottom-20 right-2 z-50 ads">
              <div className="relative">
                <img src={icon_arrow} alt="arrow" className="arrow absolute bottom-5 left-2" />
                <img src={icon_ads} alt="ads video" className="w-20" />
              </div>
            </div> */}
                {/* End Ads Video */}

                {/* Search Page */}
                <div className="hidden fixed top-0 left-0 w-screen h-screen bg-white z-50">
                  <div className="shadow-md mb-3 p-3">
                    <div className="flex items-center">
                      <div className="flex-0">
                        <svg
                          width="34"
                          height="34"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="mr-2"
                        >
                          <path
                            d="M11.0303 8.53033C11.3232 8.23744 11.3232 7.76256 11.0303 7.46967C10.7374 7.17678 10.2626 7.17678 9.96967 7.46967L5.96967 11.4697C5.82322 11.6161 5.75 11.8081 5.75 12C5.75 12.1017 5.77024 12.1987 5.80691 12.2871C5.84351 12.3755 5.89776 12.4584 5.96967 12.5303L9.96967 16.5303C10.2626 16.8232 10.7374 16.8232 11.0303 16.5303C11.3232 16.2374 11.3232 15.7626 11.0303 15.4697L8.31066 12.75H18C18.4142 12.75 18.75 12.4142 18.75 12C18.75 11.5858 18.4142 11.25 18 11.25H8.31066L11.0303 8.53033Z"
                            fill="#383838"
                          />
                        </svg>
                      </div>
                      <div className="flex-1">
                        <div className="relative">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="absolute top-3 left-[16px] mr-2"
                          >
                            <path
                              d="M9.33512 4.80232C9.74423 4.73752 10.0234 4.35334 9.95856 3.94423C9.89376 3.53511 9.50958 3.25599 9.10047 3.32079C6.64008 3.71047 4.71044 5.64012 4.32076 8.1005C4.25596 8.50961 4.53508 8.89379 4.9442 8.95859C5.35331 9.02339 5.73749 8.74426 5.80229 8.33515C6.09032 6.51661 7.51658 5.09035 9.33512 4.80232Z"
                              fill="#d3d3d3"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11 0.25C5.61522 0.25 1.25 4.61522 1.25 10C1.25 15.3848 5.61522 19.75 11 19.75C16.3848 19.75 20.75 15.3848 20.75 10C20.75 4.61522 16.3848 0.25 11 0.25ZM2.75 10C2.75 5.44365 6.44365 1.75 11 1.75C15.5563 1.75 19.25 5.44365 19.25 10C19.25 14.5563 15.5563 18.25 11 18.25C6.44365 18.25 2.75 14.5563 2.75 10Z"
                              fill="#d3d3d3"
                            />
                            <path
                              d="M19.5304 17.4698C19.2375 17.1769 18.7626 17.1769 18.4697 17.4698C18.1768 17.7626 18.1768 18.2375 18.4697 18.5304L22.4696 22.5304C22.7625 22.8233 23.2374 22.8233 23.5303 22.5304C23.8232 22.2375 23.8232 21.7626 23.5303 21.4697L19.5304 17.4698Z"
                              fill="#d3d3d3"
                            />
                          </svg>
                          <input
                            type="text"
                            className="flex items-center w-full pr-4 pl-11 py-2.5 bg-white border border-gray-200 rounded-2xl placeholder:text-gray-400 text-sm focus:outline-none focus:border-orange focus:ring-orange"
                            placeholder="Cari judul buku, penulis, penerbit..."
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="px-4 pb-28 grid grid-cols-2 gap-2 h-screen overflow-y-auto">
                    <div className="rounded-xl mb-2 shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                      <div className="h-[180px] overflow-hidden">
                        <img
                          src="https://kubuku.id/prod/img/cover/C9789797569624.JPG"
                          alt="cover buku"
                          className="w-full rounded-xl"
                        />
                      </div>
                      <div className="p-2">
                        <div className="title-book text-sm text-black font-semibold line-clamp-3">
                          Konseling Lintas
                        </div>
                        <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                          Dr. A.A. Ngurah Adhiputra, M.Pd
                        </div>
                        <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                          Graha Ilmu
                        </div>
                        <div
                          className={
                            "stock mt-1 text-sm " +
                            this.state.textcolor +
                            " font-semibold"
                          }
                        >
                          Stok: 1/3
                        </div>
                      </div>
                    </div>
                    <div className="rounded-xl mb-2 shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                      <div className="h-[180px] overflow-hidden">
                        <img
                          src="https://kubuku.id/prod/img/cover/C9789797565626.JPG"
                          alt="cover buku"
                          className="w-full rounded-xl"
                        />
                      </div>
                      <div className="p-2">
                        <div className="title-book text-sm text-black font-semibold line-clamp-3">
                          Perpajakan: Teori & Teknis Perhitungan
                        </div>
                        <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                          Siti Kurnia Rahayu;Ely Suhayati
                        </div>
                        <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                          Graha Ilmu
                        </div>
                        <div
                          className={
                            "stock mt-1 text-sm " +
                            this.state.textcolor +
                            " font-semibold"
                          }
                        >
                          Stok: 1/3
                        </div>
                      </div>
                    </div>
                    <div className="rounded-xl mb-2 shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                      <div className="h-[180px] overflow-hidden">
                        <img
                          src="https://kubuku.id/prod/img/cover/978-623-228-906-2.jpg"
                          alt="cover buku"
                          className="w-full rounded-xl"
                        />
                      </div>
                      <div className="p-2">
                        <div className="title-book text-sm text-black font-semibold line-clamp-3">
                          Agroindustri Ubikayu Edisi 2
                        </div>
                        <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                          Kasma Iswari; Atman
                        </div>
                        <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                          Graha Ilmu
                        </div>
                        <div
                          className={
                            "stock mt-1 text-sm " +
                            this.state.textcolor +
                            " font-semibold"
                          }
                        >
                          Stok: 1/3
                        </div>
                      </div>
                    </div>
                    <div className="rounded-xl mb-2 shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                      <div className="h-[180px] overflow-hidden">
                        <img
                          src="https://kubuku.id/prod/img/cover/C9789797567293.JPG"
                          alt="cover buku"
                          className="w-full rounded-xl"
                        />
                      </div>
                      <div className="p-2">
                        <div className="title-book text-sm text-black font-semibold line-clamp-3">
                          Teori dan Aplikasi Sistem Digital
                        </div>
                        <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                          Eko Budi Purwanto
                        </div>
                        <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                          Graha Ilmu
                        </div>
                        <div
                          className={
                            "stock mt-1 text-sm " +
                            this.state.textcolor +
                            " font-semibold"
                          }
                        >
                          Stok: 1/3
                        </div>
                      </div>
                    </div>
                    <div className="rounded-xl mb-2 shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                      <div className="h-[180px] overflow-hidden">
                        <img
                          src="https://kubuku.id/prod/img/cover/C9789797569624.JPG"
                          alt="cover buku"
                          className="w-full rounded-xl"
                        />
                      </div>
                      <div className="p-2">
                        <div className="title-book text-sm text-black font-semibold line-clamp-3">
                          Konseling Lintas
                        </div>
                        <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                          Dr. A.A. Ngurah Adhiputra, M.Pd
                        </div>
                        <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                          Graha Ilmu
                        </div>
                        <div
                          className={
                            "stock mt-1 text-sm " +
                            this.state.textcolor +
                            " font-semibold"
                          }
                        >
                          Stok: 1/3
                        </div>
                      </div>
                    </div>
                    <div className="rounded-xl mb-2 shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                      <div className="h-[180px] overflow-hidden">
                        <img
                          src="https://kubuku.id/prod/img/cover/C9789797565626.JPG"
                          alt="cover buku"
                          className="w-full rounded-xl"
                        />
                      </div>
                      <div className="p-2">
                        <div className="title-book text-sm text-black font-semibold line-clamp-3">
                          Perpajakan: Teori & Teknis Perhitungan
                        </div>
                        <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                          Siti Kurnia Rahayu;Ely Suhayati
                        </div>
                        <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                          Graha Ilmu
                        </div>
                        <div
                          className={
                            "stock mt-1 text-sm " +
                            this.state.textcolor +
                            " font-semibold"
                          }
                        >
                          Stok: 1/3
                        </div>
                      </div>
                    </div>
                    <div className="rounded-xl mb-2 shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                      <div className="h-[180px] overflow-hidden">
                        <img
                          src="https://kubuku.id/prod/img/cover/978-623-228-906-2.jpg"
                          alt="cover buku"
                          className="w-full rounded-xl"
                        />
                      </div>
                      <div className="p-2">
                        <div className="title-book text-sm text-black font-semibold line-clamp-3">
                          Agroindustri Ubikayu Edisi 2
                        </div>
                        <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                          Kasma Iswari; Atman
                        </div>
                        <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                          Graha Ilmu
                        </div>
                        <div
                          className={
                            "stock mt-1 text-sm " +
                            this.state.textcolor +
                            " font-semibold"
                          }
                        >
                          Stok: 1/3
                        </div>
                      </div>
                    </div>
                    <div className="rounded-xl mb-2 shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                      <div className="h-[180px] overflow-hidden">
                        <img
                          src="https://kubuku.id/prod/img/cover/C9789797567293.JPG"
                          alt="cover buku"
                          className="w-full rounded-xl"
                        />
                      </div>
                      <div className="p-2">
                        <div className="title-book text-sm text-black font-semibold line-clamp-3">
                          Teori dan Aplikasi Sistem Digital
                        </div>
                        <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                          Eko Budi Purwanto
                        </div>
                        <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                          Graha Ilmu
                        </div>
                        <div
                          className={
                            "stock mt-1 text-sm " +
                            this.state.textcolor +
                            " font-semibold"
                          }
                        >
                          Stok: 1/3
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End Search Page */}
              </div>
            </>
          )}
        </>
      </div>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const sn = params.get("sn");
  const guid = params.get("guid");
  return (
    <Home
      {...props}
      navigate={navigate}
      params={useParams()}
      sn={sn}
      guid={guid}
    />
  );
}

export default WithNavigate;
